/* Cacilia 2026 redesign: drawers, hearts, add to bag, design picker, bag drawer, dock, show more. No dependencies. */
(function () {
  'use strict';
  var CS = window.CS || (window.CS = {});
  var cfgEl = document.getElementById('csBagCfg');
  var CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
  CS.cfg = CFG;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var GOALS = [5, 10, 20, 30];

  /* ---------- W11: sold bands (real orders, already rounded down) and the Charm of the Month countdown ---------- */
  function soldN(v) { var n = Math.floor(Number(v) || 0); return n >= 100 ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '+' : ''; }
  function soldPill(v) { var t = soldN(v); return t ? '<span class="sold' + (Math.floor(Number(v)) >= 500 ? ' hi' : '') + '">' + esc(t) + ' sold</span>' : ''; }
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  // today in New York as numbers + "YYYY-MM"; null if Intl cannot do it (then no countdown)
  function nyToday() {
    try {
      var o = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      if (!/^\d{4}$/.test(o.year || '') || !/^\d{2}$/.test(o.month || '') || !/^\d{2}$/.test(o.day || '')) return null;
      return { y: Number(o.year), m: Number(o.month), d: Number(o.day), ym: o.year + '-' + o.month };
    } catch (e) { return null; }
  }
  // only when the charm in the shop is really this month's charm
  function cotmLeft() {
    var C = CFG.cotm; if (!C || typeof C.month !== 'string') return null;
    var t = nyToday(); if (!t || C.month.trim() !== t.ym) return null;
    var n = new Date(Date.UTC(t.y, t.m, 0)).getUTCDate() - t.d;
    if (n < 0) return null;
    return { n: n, txt: n === 0 ? 'Last\u00a0day' : n === 1 ? '1\u00a0day\u00a0left' : n + '\u00a0days\u00a0left', mon: MONTHS[t.m - 1] };
  }
  function cotmNote(sep) { var c = cotmLeft(); return c ? sep + esc(c.txt) : ''; }
  function paintCotm(root) {
    var els = $$('[data-cs-cotm]', root || document); if (!els.length) return;
    var c = cotmLeft(), nm = CFG.cotm && CFG.cotm.name ? String(CFG.cotm.name) : '';
    var no = CFG.cotm && CFG.cotm.options ? CFG.cotm.options.length : 0;
    var t = c && nm ? (no > 1 ? c.mon + '\'s charms: pick 1 of ' + no + ' · ' + c.txt : c.mon + '\'s charm: ' + nm + ' · ' + c.txt) : '';
    els.forEach(function (el) { el.textContent = t; el.hidden = !t; });
  }

  /* ---------- money ---------- */
  function money(cents) {
    cents = Math.round(cents || 0);
    var fmt = CS.money || '${{amount}}';
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return withCommas;
    }).replace(/<[^>]*>/g, '');
  }
  CS.formatMoney = money;
  function icon(name) {
    var P = {
      star: '<path d="M12 4l2.4 5 5.4.6-4 3.7 1.1 5.3L12 16l-4.9 2.6 1.1-5.3-4-3.7 5.4-.6z"/>',
      plus: '<path d="M12 6v12M6 12h12"/>', minus: '<path d="M6 12h12"/>', close: '<path d="M6 6l12 12M18 6L6 18"/>',
      heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
      lock: '<rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
      gift: '<rect x="4" y="9" width="16" height="11" rx="1"/><path d="M3.5 9h17M12 9v11M12 9c-2-4-6-4-6-1.5S10 9 12 9zm0 0c2-4 6-4 6-1.5S14 9 12 9z"/>',
      tool: '<path d="M14 4l6 6-3 3-6-6zM11 7l-7 7v4h4l7-7"/>', check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
      bag: '<path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>', right: '<path d="M9 6l6 6-6 6"/>', left: '<path d="M15 6l-6 6 6 6"/>',
      spark: '<path d="M12 3.5l1.8 5.2 5.2 1.8-5.2 1.8L12 17.5l-1.8-5.2L5 10.5l5.2-1.8z"/>',
      shield: '<path d="M12 3.5l7 2.6v5.4c0 4.4-3 7.7-7 9-4-1.3-7-4.6-7-9V6.1z"/><path d="M9 12l2.2 2.2L15.5 10"/>',
      up: '<path d="M6 15l6-6 6 6"/>',
      sort: '<path d="M7 5v14M4 16l3 3 3-3M17 19V5M14 8l3-3 3 3"/>'
    };
    return '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (P[name] || '') + '</svg>';
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(html, action) {
    var t = document.getElementById('csToast'); if (!t) return;
    var fn = action && typeof action === 'object' ? action.fn : null, label = fn ? action.label : action;
    t.innerHTML = '<span>' + html + '</span>' + (label ? '<button type="button" ' + (fn ? 'data-cs-toast-act' : 'data-cs-open="csBag"') + '>' + esc(label) + '</button>' : '');
    var ab = t.querySelector('[data-cs-toast-act]'); if (ab) ab.addEventListener('click', function () { t.classList.remove('on'); fn(); });
    t.classList.add('on'); clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, fn ? 5000 : action ? 3600 : 2400);
  }
  CS.toast = toast;
  var sayT;
  function say(html, openBag) {
    var d = document.getElementById('csDock'), m = d && d.querySelector('[data-cs-dock-msg]');
    if (!m || d.hidden) { toast(html, openBag ? 'Open bag' : 'View bag'); return; }
    m.innerHTML = html; d.classList.add('say'); clearTimeout(sayT);
    sayT = setTimeout(function () { d.classList.remove('say'); }, 2600);
  }
  CS.say = say;
  /* header icons: a little shake, and the number rolls to the new value */
  function shake(which) {
    $$(which === 'heart' ? '[data-cs-hcount]' : '[data-cs-bcount]').forEach(function (b) {
      var btn = b.parentNode; if (!btn) return;
      btn.classList.remove('cs-shake'); void btn.offsetWidth; btn.classList.add('cs-shake');
    });
  }
  CS.shake = shake;
  /* the charm photo jumps into the bag icon, like charms jump onto the bracelet in the builder */
  function flyToBag(src) {
    if (!src || !src.animate || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return false;
    var tgt = null; $$('#csHead [data-cs-bcount]').forEach(function (b) { var r = b.parentNode.getBoundingClientRect(); if (r.width && r.bottom > 0) tgt = r; });
    var r = src.getBoundingClientRect(); if (!tgt || !r.width || r.bottom < 0 || r.top > innerHeight) return false;
    var g = src.cloneNode(true); g.removeAttribute('srcset'); g.removeAttribute('sizes'); g.removeAttribute('loading'); g.className = 'cs-fly';
    g.style.left = r.left + 'px'; g.style.top = r.top + 'px'; g.style.width = r.width + 'px'; g.style.height = r.height + 'px';
    document.body.appendChild(g);
    var tx = tgt.left + tgt.width / 2 - (r.left + r.width / 2), ty = tgt.top + tgt.height / 2 - (r.top + r.height / 2), sc = Math.max(0.12, Math.min(1, 26 / r.width));
    var an = g.animate([
      { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
      { transform: 'translate3d(' + (tx * 0.45) + 'px,' + (ty * 0.45 - 60) + 'px,0) scale(' + ((1 + sc) / 2) + ')', opacity: 1, offset: 0.55 },
      { transform: 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + sc + ')', opacity: 0.2 }
    ], { duration: 560, easing: 'cubic-bezier(.2,.7,.2,1)' });
    CS.flewAt = Date.now();
    an.onfinish = function () { if (g.parentNode) g.parentNode.removeChild(g); shake('bag'); };
    return true;
  }
  CS.flyToBag = flyToBag;
  function roll(el, from, to) {
    clearTimeout(el._rt); el.hidden = !to;
    if (from == null || from === to || !to) { el.textContent = to; return; }
    el.innerHTML = '<span class="cs-roll ' + (to > from ? 'up' : 'down') + '"><i>' + from + '</i><i>' + to + '</i></span>';
    clearTimeout(el._rt); el._rt = setTimeout(function () { el.textContent = to; }, 460);
  }
  var lastBag = null, lastHeart = null;

  /* ---------- drawers / sheets ---------- */
  var openEl = null, lastFocus = null, savedY = 0;
  // the page stays where it is (no jump, the sticky header stays on screen): only scrolling is switched off
  function lock(on) {
    document.documentElement.classList.toggle('cs-lock', !!on); document.body.classList.toggle('cs-lock', !!on);
  }
  // older iPhones scroll the page behind the scrim anyway: stop drags that start outside the open panel
  document.addEventListener('touchmove', function (e) { if (openEl && document.body.classList.contains('cs-lock') && !openEl.contains(e.target)) e.preventDefault(); }, { passive: false });
  function openPanel(id, opts) {
    var el = document.getElementById(id); if (!el) return;
    if (openEl === el) return;
    if (openEl) closePanel(true);
    var sc = document.getElementById('csScrim');
    lastFocus = document.activeElement;
    if (sc) sc.hidden = false; el.hidden = false;
    // force layout so the slide-in animates
    void el.offsetWidth;
    if (sc) sc.classList.add('on'); el.classList.add('on');
    lock(true); openEl = el; setInert(true);
    if (id === 'csBag') { FOLD.csBagFoot = false; renderBag(true); }
    if (id === 'csHeartsD') drawHeartsDrawer();
    if (opts && opts.scrollTo) { var tgt = document.getElementById(opts.scrollTo); if (tgt) setTimeout(function () { tgt.scrollIntoView({ block: 'start' }); }, 60); }
    var f = el.querySelector('[data-cs-close]');
    setTimeout(function () { try { (f || el).focus({ preventScroll: true }); } catch (e) {} }, 80);
  }
  function closePanel(instant) {
    if (!openEl) return;
    var el = openEl, sc = document.getElementById('csScrim');
    openEl = null; el.classList.remove('on'); if (sc) sc.classList.remove('on');
    lock(false); setInert(false);
    var done = function () { if (!el.classList.contains('on')) el.hidden = true; if (!openEl && sc) sc.hidden = true; };
    if (instant) done(); else setTimeout(done, 380);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function setInert(on) {
    var sc = document.getElementById('csScrim'), ts = document.getElementById('csToast');
    $$('body > *').forEach(function (n) {
      if (on) {
        if (!openEl || n.contains(openEl) || (sc && n.contains(sc)) || (ts && n.contains(ts)) || n.tagName === 'SCRIPT' || n.hasAttribute('inert')) return;
        n.setAttribute('inert', ''); n.setAttribute('data-cs-inert', '1');
      } else if (n.hasAttribute('data-cs-inert')) { n.removeAttribute('inert'); n.removeAttribute('data-cs-inert'); }
    });
  }
  CS.open = openPanel; CS.close = closePanel;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanel(); return; }
    if (e.key !== 'Tab' || !openEl) return;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', openEl).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) { e.preventDefault(); return; }
    var i = f.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (i < 0 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- hearts (saved charms, stored on this device) ---------- */
  var HKEY = 'csHearts';
  var MKT = (window.Shopify && Shopify.country || '') + ':' + (window.Shopify && Shopify.currency && Shopify.currency.active || '');
  // a heart key is "handle" or "handle:variantId"; it also repairs entries saved without them
  function fromKey(x) { if (x && x.k && (!x.h || (!x.v && x.k.indexOf(':') > 0))) { var kp = String(x.k).split(':'); x.h = x.h || kp[0]; if (!x.v && kp[1]) x.v = Number(kp[1]); } return x; }
  function readHearts() { try { var v = JSON.parse(localStorage.getItem(HKEY) || '[]'); return Array.isArray(v) ? v.map(fromKey) : []; } catch (e) { return []; } }
  function writeHearts(list) { var ok = true; try { localStorage.setItem(HKEY, JSON.stringify(list.slice(0, 300))); } catch (e) { ok = false; } paintHearts(); return ok; }
  function isHeart(k) { return readHearts().some(function (x) { return x.k === k; }); }
  function paintHearts() {
    var list = readHearts(), keys = {};
    list.forEach(function (x) { keys[x.k] = 1; });
    $$('[data-cs-heart]').forEach(function (b) { var on = !!keys[b.getAttribute('data-cs-heart')]; b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $$('[data-cs-hcount]').forEach(function (n) { roll(n, lastHeart, list.length); });
    if (lastHeart != null && list.length > lastHeart) shake('heart');
    lastHeart = list.length;
    $$('[data-cs-hcount-text]').forEach(function (n) { n.textContent = list.length ? '(' + list.length + ')' : ''; });
    document.dispatchEvent(new CustomEvent('cs:hearts', { detail: list }));
  }
  /* hearts saved by another script (the builder) come without a picture: look the pictures up right after */
  var fillT = null;
  function fillSoon() { clearTimeout(fillT); fillT = setTimeout(fillImages, 300); }
  CS.hearts = { read: readHearts, write: function (list) { var ok = writeHearts(list); fillSoon(); return ok; }, paint: paintHearts };
  function itemData(el) {
    var c = el.closest('[data-cs-item]') || el;
    return { h: c.getAttribute('data-h'), v: c.getAttribute('data-v') ? Number(c.getAttribute('data-v')) : null, t: c.getAttribute('data-title') || el.getAttribute('data-title') || '', i: c.getAttribute('data-img') || '', p: Number(c.getAttribute('data-price') || 0), n: Number(c.getAttribute('data-designs') || 1), u: c.getAttribute('data-url') || '' };
  }
  function toggleHeart(btn) {
    var k = btn.getAttribute('data-cs-heart'), list = readHearts(), i = -1;
    list.forEach(function (x, j) { if (x.k === k) i = j; });
    if (i >= 0) {
      list.splice(i, 1);
      var hg = btn.closest('#csHeartsG,[data-cs-saved-grid]'), hc = hg && btn.closest('.cs-card');
      if (hc && hc.animate && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        // un-hearting from the hearts list: the card fades out, then the others glide into the gap
        var before = {}; $$('.cs-card', hg).forEach(function (c) { var hb = c.querySelector('[data-cs-heart]'); if (hb && c !== hc) before[hb.getAttribute('data-cs-heart')] = c.getBoundingClientRect(); });
        hc.style.pointerEvents = 'none';
        var out = hc.animate([{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.92)' }], { duration: 170, easing: 'ease-out', fill: 'forwards' });
        out.onfinish = function () {
          writeHearts(list);
          $$('.cs-card', hg).forEach(function (c) {
            var hb = c.querySelector('[data-cs-heart]'), r0 = hb && before[hb.getAttribute('data-cs-heart')]; if (!r0) return;
            var r1 = c.getBoundingClientRect(), dx = r0.left - r1.left, dy = r0.top - r1.top; if (!dx && !dy) return;
            c.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 240, easing: 'cubic-bezier(.22,.8,.24,1)' });
          });
        };
      } else writeHearts(list);
      say('Removed from your hearts');
    }
    else {
      var d = itemData(btn);
      if (!d.h) { var pi = document.querySelector('.cs-pdp-info[data-cs-item][data-h="' + k.split(':')[0] + '"]'); if (pi) d = itemData(pi); }
      d.k = k; d.at = Date.now(); d.m = MKT; fromKey(d); if (k.indexOf(':') > 0) d.v = Number(k.split(':')[1]); list.unshift(d);
      if (!writeHearts(list)) { toast('This browser is blocking saved hearts (private mode or blocked cookies).'); return; }
      say(icon('heart') + '<b>' + esc(d.t || 'It') + '</b> is in your hearts');
      btn.classList.remove('cs-beat'); void btn.offsetWidth; btn.classList.add('cs-beat');
    }
  }

  /* ---------- cart ---------- */
  var cart = null, busy = false;
  function api(url, body) {
    var o = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } };
    return fetch(url, o).then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) {} if (!r.ok || !j) { var m = j && (j.description || j.message) || (r.status === 429 || !j ? 'The bag is busy, please try again in a moment' : 'Something went wrong'); var er = new Error(m); er.status = r.status; throw er; } return j; }); });
  }
  function route(k, suffix) { return (CS.routes && CS.routes[k] || ('/cart' + (k === 'cart' ? '' : '/' + k))) + (suffix || ''); }
  function kind(it) {
    if (it.gift_card) return 'other';
    if (CFG.cotm && it.handle === CFG.cotm.handle) return 'gift';
    if ((CFG.toolHandles || []).indexOf(it.handle) >= 0) return 'tool';
    if (it.handle === CFG.bracelet || (CS.braceletHandles || []).indexOf(it.handle) >= 0 || /bracelet/.test(it.handle || '')) return 'bracelet';
    if (it.product_type === 'free' || (CS.otherHandles || ['skip-the-queue']).indexOf(it.handle) >= 0 || isProt(it)) return 'other';
    return 'charm';
  }
  CS.kind = kind;
  /* the photo charm: a charm made from the shopper's photo or words; one is free at PH.need charms (a $0 gift line, photoFix) */
  var PH = CFG.photo || null;
  function isPhotoGift(it) { return !!(PH && PH.gift && it && it.handle === PH.gift.handle); }
  function isPhoto(it) { return !!(PH && it && (it.handle === PH.handle || isPhotoGift(it))); }
  CS.isPhoto = isPhoto;
  // one design = one photo charm line (old lines from before _ccz ids go by their file)
  function phKey(it) { var p = it.properties || {}; return 'ph:' + (p._ccz && p._ccz !== '1' ? p._ccz : (p.Design || it.key)); }
  CS.phKey = phKey;
  /* the designer opens as a popup on any page (assets/cs-custom.js, loaded the first time it is needed) */
  var cczP = null;
  function cczLoad() {
    if (window.CCZ && CCZ.open) return Promise.resolve();
    if (cczP) return cczP;
    var C = window.CCZ_CFG; if (!C || !C.js) return Promise.reject(new Error('off'));
    cczP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = C.js; sc.async = true;
      sc.onload = function () { if (window.CCZ && CCZ.open) res(); else { cczP = null; rej(new Error('off')); } };
      sc.onerror = function () { cczP = null; rej(new Error('off')); };
      document.head.appendChild(sc);
    });
    return cczP;
  }
  CS.designer = function (o) {
    return cczLoad().then(function () { CCZ.open(o || {}); }, function () { var C = window.CCZ_CFG; location.href = (C && C.url) || (PH && PH.url) || '/products/custom-photo-charm'; });
  };
  // the pair row's arrows (computers): one card width at a time
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-cs-pscroll]'); if (!b) return;
    var row = b.closest('.cs-pairbox'); row = row && row.querySelector('[data-cs-pairs]'); if (!row) return;
    e.preventDefault(); row.scrollBy({ left: Number(b.getAttribute('data-cs-pscroll')) * Math.max(120, row.clientWidth * 0.7), behavior: 'smooth' });
  });
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-ccz-open]'); if (!t || !window.CCZ_CFG) return;
    e.preventDefault();
    var o = {}; try { o = JSON.parse(t.getAttribute('data-ccz-open') || '{}') || {}; } catch (x) { o = {}; }
    // from inside a drawer: the drawer goes first, then the designer comes up
    if (t.closest('.cs-drawer,.cs-sheet')) { closePanel(); setTimeout(function () { CS.designer(o); }, 280); } else CS.designer(o);
  });
  /* shipping protection: never drawn as a line, never counted as an item; only the footer switch shows it */
  function isProt(it) { var P = CFG.protection; return !!(P && it && !it.gift_card && (it.handle === P.handle || String(it.variant_id) === String(P.variant))); }
  function protLines(c) { return (c && c.items || []).filter(isProt); }
  function protQty(c) { return protLines(c).reduce(function (a, it) { return a + it.quantity; }, 0); }
  function pouchQty(c) { var P = CFG.pouch; return P ? (c && c.items || []).reduce(function (a, it) { return a + (it.handle === P.handle ? it.quantity : 0); }, 0) : 0; }
  function bagCount(c) { return Math.max(0, (c && c.item_count || 0) - protQty(c) - pouchQty(c)); }
  // something in the bag gets posted (gift cards, protection and digital items do not)
  function ships(c) { return (c && c.items || []).some(function (it) { return !isProt(it) && !it.gift_card && it.requires_shipping !== false; }); }
  CS.isProtection = isProt;
  // thresholds are set in the shop's currency; the bag is in the shopper's (Shopify.currency.rate converts)
  var RATE = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
  var FS = Math.round((CFG.freeShip || 4000) * RATE);
  /* Charm of the Month with a few designs: the shopper picks one (remembered on this device) */
  function cotmOpts() { return (CFG.cotm && CFG.cotm.options || []).filter(function (o) { return o && o.variant; }); }
  function cotmUse(id) {
    var o = cotmOpts().filter(function (x) { return x.variant === id; })[0]; if (!o) return null;
    CFG.cotm.variant = o.variant; CFG.cotm.name = o.name; if (o.image) CFG.cotm.image = o.image; return o;
  }
  (function () { var p = 0; try { p = Number(localStorage.getItem('cs_cotm_pick')) || 0; } catch (e) {} if (!cotmUse(p) && cotmOpts().length) cotmUse(cotmOpts()[0].variant); })();
  function cotmStrip(cur, label) {
    var o = cotmOpts(); if (o.length < 2) return '';
    return '<div class="cs-cpick" data-a="cpick' + (label ? 'l' : 'g') + '" role="group" aria-label="Pick this month\'s charm"><span class="lb">' + label + '</span><span class="ops">' +
      o.map(function (x) { return '<button type="button" data-cs-cotm-pick="' + x.variant + '" aria-pressed="' + (x.variant === cur ? 'true' : 'false') + '" aria-label="' + esc(x.name) + '" title="' + esc(x.name) + '">' + (x.image ? '<img src="' + esc(x.image) + '" alt="" loading="lazy">' : esc(x.name)) + '</button>'; }).join('') + '</span></div>';
  }
  if (RATE !== 1) { (CFG.rates || []).forEach(function (r) { r[0] = Math.round(r[0] * RATE); r[1] = Math.round(r[1] * RATE); }); if (CFG.cotm && CFG.cotm.value) CFG.cotm.value = Math.round(CFG.cotm.value * RATE); if (CFG.giftTool && CFG.giftTool.value) CFG.giftTool.value = Math.round(CFG.giftTool.value * RATE); }
  function stats(c) {
    var s = { photo: 0, photoFree: 0, photoPaid: 0, charms: 0, charmsTotal: 0, bracelets: 0, classic: 0, eligible: 0, matching: 0, braceletTotal: 0, braceletOrig: 0, tools: 0, toolTotal: 0, cotm: 0, prot: 0, protTotal: 0, lines: { charm: [], bracelet: [], tool: [], gift: [], other: [] } };
    s.items = c && c.item_count || 0; s.sub = c && c.total_price || 0;
    (c && c.items || []).forEach(function (it) { if (it.gift_card) s.sub -= it.final_line_price; });
    // free shipping is one Shopify rule: the order total after codes reaches $40
    s.freeShip = s.sub >= FS; s.shipNeed = s.freeShip ? 0 : FS - s.sub;
    (c && c.items || []).forEach(function (it) {
      if (isProt(it)) { s.prot += it.quantity; s.protTotal += it.final_line_price; return; }
      var k = kind(it); s.lines[k].push(it);
      // the free photo charm ($0 gift) is not one of the charms that count; a paid one is
      if (k === 'charm' && isPhotoGift(it)) { s.photo += it.quantity; s.photoFree += it.quantity; }
      else if (k === 'charm') { s.charms += it.quantity; s.charmsTotal += it.final_line_price; if (isPhoto(it)) { s.photo += it.quantity; s.photoPaid += it.quantity; } }
      if (k === 'bracelet') { s.bracelets += it.quantity; s.braceletTotal += it.final_line_price; s.braceletOrig += it.original_line_price; if (it.handle === CFG.bracelet) s.classic += it.quantity; if (CFG.matching && it.handle === CFG.matching.handle) s.matching += it.quantity; else s.eligible += it.quantity; }
      if (k === 'tool') { s.tools += it.quantity; s.toolTotal += it.final_line_price; }
      if (k === 'gift') s.cotm += it.quantity;
    });
    s.items = Math.max(0, s.items - s.prot);
    // the photo charm offer counts the other charms (the free one itself does not count towards it)
    s.base = s.charms - s.photoPaid;
    // something to post (a gift card alone is emailed): shipping and the surprise charm only apply then
    s.ship = ships(c);
    return s;
  }
  CS.stats = stats;
  function shipping(c, s) {
    var sub = (s || stats(c)).sub;
    if (c.requires_shipping === false || sub >= FS) return 0;
    var rates = CFG.rates || [];
    for (var i = 0; i < rates.length; i++) if (sub < rates[i][0]) return rates[i][1];
    return rates.length ? rates[rates.length - 1][1] : 0;
  }
  // the bar: 5, 10, 20 and 30 charms, one quarter each, so the labels sit under their dots
  var PCT = [[0, 0], [5, 25], [10, 50], [20, 75], [30, 100]];
  function pct(c) { c = Math.max(0, Math.min(30, c)); for (var i = 1; i < PCT.length; i++) if (c <= PCT[i][0]) { var a = PCT[i - 1], b = PCT[i]; return a[1] + (c - a[0]) / (b[0] - a[0]) * (b[1] - a[1]); } return 100; }
  CS.pct = pct;
  function more(n, word) { return n + ' more ' + (n === 1 ? word : word + 's'); }
  function message(s) {
    var c = s.charms;
    if (c === 0) return 'Pick 5 charms and this month\'s charm is free. At 10, the bracelet is free too.';
    if (c < 5) return '<b>' + more(5 - c, 'charm') + '</b> and this month\'s charm is free.';
    if (c < 10) return (s.cotm ? 'This month\'s charm is in your bag. ' : '') + '<b>' + more(10 - c, 'charm') + '</b> and the bracelet is free' + (s.cotm ? ' too.' : '.');
    if (PH && c < 20 && s.base < PH.need && s.base >= 10) return 'Your bracelet is free. <b>' + more(PH.need - s.base, 'charm') + '</b> and a photo charm is free too.';
    if (PH && c < 20 && s.base >= PH.need) return 'Your bracelet' + (s.photoFree ? ' and photo charm are' : ' is') + ' free. <b>' + more(20 - c, 'charm') + '</b> and a second bracelet is free.';
    if (c < 20) return 'Your bracelet is free. <b>' + more(20 - c, 'charm') + '</b> and a second one is free.';
    if (c < 30) return 'Two bracelets are free. <b>' + more(30 - c, 'charm') + '</b> and a third one is free.';
    return 'Everything is unlocked: three bracelets, the charm tool and this month\'s charm.';
  }
  function shortNext(s) {
    var c = s.charms;
    if (c < 5) return more(5 - c, 'charm') + ' for a free charm';
    if (c < 10) return more(10 - c, 'charm') + ' and the bracelet is free';
    if (PH && s.base >= 10 && s.base < PH.need) return more(PH.need - s.base, 'charm') + ' for a free photo charm';
    if (c < 20) return more(20 - c, 'charm') + ' for a 2nd free bracelet';
    if (c < 30) return more(30 - c, 'charm') + ' for a 3rd free bracelet';
    return 'Every reward unlocked';
  }
  CS.message = message; CS.shortNext = shortNext;
  var STEPS = [[5, 'This month\'s charm'], [10, 'Bracelet + tool'], [20, '2nd bracelet'], [30, '3rd bracelet']];
  function ladder(c, s) {
    var h = '<div class="cs-bar" aria-hidden="true"><i style="width:' + pct(c).toFixed(1) + '%"></i>' +
      STEPS.map(function (x) { return '<b class="' + (c >= x[0] ? 'got' : '') + '" style="left:' + pct(x[0]) + '%"></b>'; }).join('') + '</div>' +
      '<div class="cs-lab cs-lab4" aria-hidden="true">' + STEPS.map(function (x) { return '<div class="' + (c >= x[0] ? 'got' : '') + '"><b>' + x[0] + ' charms</b>' + x[1] + '</div>'; }).join('') + '</div>';
    if (s && s.items && s.ship) h += '<p class="cs-shipbar' + (s.freeShip ? ' got' : '') + '"><span class="tr" aria-hidden="true"><i style="width:' + Math.min(100, s.sub / FS * 100).toFixed(1) + '%"></i></span><span class="tx">' + (s.freeShip ? icon('check') + '<b>Shipping is free</b>' : 'Free shipping from ' + money(FS).replace(/[.,]00(?=\D*$)/, '') + ' · <b>' + money(s.shipNeed) + ' to go</b>') + '</span></p>';
    return h;
  }
  CS.ladder = ladder;
  function paintInBag(root) {
    var byV = {}, byH = {}, v0 = view();
    (v0 && v0.items || []).forEach(function (it) { if (kind(it) !== 'charm') return; byV[it.variant_id] = (byV[it.variant_id] || 0) + it.quantity; byH[it.handle] = (byH[it.handle] || 0) + it.quantity; });
    $$('.cs-card[data-cs-item]', root).forEach(function (c) {
      var v = c.getAttribute('data-v'), q = v ? (byV[v] || 0) : (byH[c.getAttribute('data-h')] || 0), pic = c.querySelector('.pic'); if (!pic) return;
      var b = pic.querySelector('.onb');
      pic.classList.toggle('cs-inb', !!q);
      if (!q) { if (b) pic.removeChild(b); return; }
      var html = icon('check') + 'In bag' + (q > 1 ? ' ×' + q : '');
      if (!b) { b = document.createElement('span'); b.className = 'onb'; pic.appendChild(b); }
      if (b.getAttribute('data-q') !== String(q)) { b.innerHTML = html; b.setAttribute('data-q', q); b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
    });
    fitNames(root);
  }
  CS.paintInBag = paintInBag;
  /* One-line card names: when a name is too long, keep its end ("/ Gold", "in Silver", the last word) and cut the middle,
     so designs that only differ at the end still read differently. Cards in one grid share a width. */
  var nmc = null;
  function fitNames(root) {
    var els = $$('.cs-card .n', root || document); if (!els.length) return;
    if (!nmc) nmc = document.createElement('canvas').getContext('2d');
    var font = '', ls = 0, gw = {};
    els.forEach(function (el) {
      var full = el.getAttribute('data-full') || el.textContent.trim(), g = el.closest('.cs-grid,.cs-hgrid,.cs-hrow,.cs-lines,section') || document.body;
      var w = el.clientWidth; if (w) gw[g.id || g.className] = w; else w = gw[g.id || g.className] || 0;
      if (!w) return;
      if (el.getAttribute('data-fw') === String(w)) return;
      if (!font) { var cs = getComputedStyle(el); font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily; ls = parseFloat(cs.letterSpacing) || 0; nmc.font = font; }
      var W = function (t) { return nmc.measureText(t).width + ls * t.length; };
      el.setAttribute('data-full', full); el.setAttribute('data-fw', w);
      if (W(full) <= w - 1) { if (el.textContent !== full) el.textContent = full; el.removeAttribute('aria-label'); return; }
      var m = full.match(/^(.+?)(\s+\/\s+.+|\s+in\s+(?:rose\s+gold|silver|gold|black|rose)|\s+\S+)$/i); if (!m) return;
      var head = m[1], tail = ' ' + m[2].replace(/^\s+/, ''), lo = 0, hi = head.length;
      while (lo < hi) { var mid = (lo + hi + 1) >> 1; if (W(head.slice(0, mid).replace(/\s+$/, '') + '\u2026' + tail) <= w - 1) lo = mid; else hi = mid - 1; }
      if (lo < 4) return;
      el.textContent = head.slice(0, lo).replace(/\s+$/, '') + '\u2026' + tail; el.setAttribute('aria-label', full);
    });
  }
  CS.fitNames = fitNames;
  /* Adds show at once: a tap counts as "in the bag" right away (badge, bag number, dock) while the request runs.
     Taps made while another add is running wait their turn instead of being dropped. */
  // every bag write (add, +, −, remove) runs one after another, so quick taps are never lost or overwritten
  var pend = [], addQ = Promise.resolve(), addN = 0, qPend = {};
  // the builder page saves its own changes to the bag: a tap here waits until that save is over (20 s at most), and
  // the builder waits for ours (CS.busyNow), so neither writes over the other
  function afterBuilder() {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function w() { var P = window.CSB_SYNC ? window.CSB_SYNC() : null; if (!P || !P.inflight || Date.now() - t0 > 20000) return res(); setTimeout(w, 120); })();
    });
  }
  CS.busyNow = function () { return !!(busy || fixing); };
  function view() {
    if (!pend.length) return cart;
    var c = cart || { items: [], item_count: 0, total_price: 0 }, n = 0, sum = 0;
    var extra = pend.map(function (p) { n += p.q; sum += p.price * p.q; return { variant_id: p.id, handle: p.h, quantity: p.q, price: p.price, final_line_price: p.price * p.q, original_line_price: p.price * p.q, product_type: '', properties: {}, _pending: true }; });
    return { items: (c.items || []).concat(extra), item_count: (c.item_count || 0) + n, total_price: (c.total_price || 0) + sum };
  }
  function paintCount(v, real) {
    var n = bagCount(v);
    $$('[data-cs-bcount]').forEach(function (b) { roll(b, lastBag, n); });
    if (real && lastBag != null && n > lastBag && Date.now() - (CS.flewAt || 0) > 1100) shake('bag');
    lastBag = n;
  }
  function paintView() { var v = view(); if (!v) return; paintCount(v); paintInBag(); paintDock(v, stats(v)); }
  function setCart(c) {
    cart = c; var s = stats(c), v = view();
    if (quiet()) noteGifts(c, s);
    paintCount(v, true);
    paintInBag();
    $$('[data-cs-menu-progress]').forEach(function (n) { n.textContent = s.charms ? s.charms + (s.charms === 1 ? ' charm · ' : ' charms · ') + shortNext(s) : "Pick 10 charms and the bracelet is free"; });
    paintDock(v, v === c ? s : stats(v));
    $$('[data-cs-incart]').forEach(function (b) { var id = Number(b.getAttribute('data-cs-incart')); b.hidden = !(c.items || []).some(function (it) { return it.variant_id === id; }); });
    if ((openEl && openEl.id === 'csBag') || document.getElementById('csCartBody')) renderBag();
    document.dispatchEvent(new CustomEvent('cs:cart', { detail: { cart: c, stats: s } }));
    giftFix(c) || autoGifts(c) || addonFix(c) || protFix(c) || photoFix(c);
    return c;
  }
  function loadCart() { return api(route('cart', '.js')).then(setCart); }
  CS.loadCart = loadCart; CS.getCart = function () { return cart; };
  CS.bagTotal = function () { return cart ? cart.total_price + shipping(cart, stats(cart)) : null; };
  // items: [{id, quantity, properties?, h?, price?}] — h (product handle) and price (cents) let the add show before the bag answers
  // onErr (optional): called with the error (e.message, e.status) after the usual toast
  // silent (optional): no "is in your bag" message (the protection switch is its own feedback)
  function addItems(items, label, onErr, silent) {
    if (busy && !addN) return Promise.resolve(); // the bag is being cleared or put back
    var mine = [], body = items.map(function (it) {
      if (it.h) { var p = { id: it.id, h: it.h, q: it.quantity || 1, price: Number(it.price) || 0 }; pend.push(p); mine.push(p); }
      var o = { id: it.id, quantity: it.quantity || 1 }; if (it.properties) o.properties = it.properties; return o;
    });
    var settled = false;
    function drop() { pend = pend.filter(function (p) { return mine.indexOf(p) < 0; }); }
    function settle() { if (settled) return; settled = true; addN--; if (!addN) busy = false; }
    addN++; busy = true;
    if (mine.length) paintView();
    var run = addQ.then(afterBuilder).then(function () {
      var before = cart ? stats(cart).charms : 0, beforeB = cart ? stats(cart).base : 0;
      return api(route('add', '.js'), { items: body }).then(function () { return api(route('cart', '.js')); }).then(function (c) {
        drop(); settle(); setCart(c);
        var s = stats(c), crossed = GOALS.filter(function (g) { return before < g && s.charms >= g; }).pop();
        if (PH && !crossed && !s.photo && beforeB < PH.need && s.base >= PH.need) crossed = 'photo';
        var nm = esc(label || 'it');
        if (crossed === 5) say('<b>This month\'s charm is free now.</b> It\'s in your bag.');
        else if (crossed === 10) say('<b>The bracelet is free now.</b> Pick the metal in your bag.', !window.CSB);
        else if (crossed === 20) say('<b>A second bracelet is free now.</b> ' + (window.CSB ? 'Tap + to add it.' : 'Pick it in your bag.'), !window.CSB);
        else if (crossed === 'photo') say('<b>A photo charm is free now.</b> <a class="cs-link" href="' + esc(PH.url) + '" data-ccz-open>Make yours</a>');
        else if (crossed === 30) say('<b>A third bracelet is free now.</b> ' + (window.CSB ? 'Tap + to add it.' : 'Pick it in your bag.'), !window.CSB);
        else if (!silent) say(icon('check') + '<b>' + nm + '</b> is in your bag');
        return c;
      });
    }).catch(function (e) {
      drop(); settle();
      paintView(); toast(esc(e.message || 'Could not add that one'));
      if (onErr) { try { onErr(e); } catch (x) {} }
    });
    addQ = run;
    return run;
  }
  CS.add = addItems;
  // FormData add (a file in the line properties): same queue as addItems; resolves to the bag, or false after a toast
  function addForm(fd, label) {
    if (busy && !addN) return Promise.resolve(false);
    var done = false; function settle() { if (done) return; done = true; addN--; if (!addN) busy = false; }
    addN++; busy = true;
    var run = addQ.then(afterBuilder).then(function () {
      return fetch(route('add', '.js'), { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) {
        return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) {} if (!r.ok || !j) { var er = new Error(j && (j.description || j.message) || (r.status === 429 ? 'The bag is busy, please try again in a moment' : 'Could not add it. Please try again.')); er.status = r.status; throw er; } return j; });
      });
    }).then(function () { return api(route('cart', '.js')); }).then(function (c) {
      settle(); setCart(c); say(icon('check') + '<b>' + esc(label || 'It') + '</b> is in your bag', true); return c;
    }).catch(function (e) { settle(); paintView(); toast(esc(e.message || 'Could not add that one')); return false; });
    addQ = run;
    return run;
  }
  CS.addForm = addForm;
  // delta: +1 / -1 from the bag buttons (shown at once, sent in turn); qty: an exact amount (Remove = 0)
  function findLine(key) {
    var items = cart && cart.items || [], vid = String(key).split(':')[0];
    return items.filter(function (it) { return it.key === key; })[0] || items.filter(function (it) { return String(it.variant_id) === vid; })[0] || null;
  }
  // onDone (optional): called once the change is over (saved, gone already, or failed), before the bag is drawn again
  function changeLine(key, qty, delta, onDone) {
    if (busy && !addN) return Promise.resolve();
    if (delta) { qPend[key] = (qPend[key] || 0) + delta; repaintBag(); }
    addN++; busy = true;
    var done = false;
    function settle() { if (done) return; done = true; if (delta) { qPend[key] -= delta; if (!qPend[key]) delete qPend[key]; } addN--; if (!addN) busy = false; }
    var run = addQ.then(afterBuilder).then(function () {
      var line = findLine(key);
      if (!line) { settle(); if (onDone) onDone(); repaintBag(); return null; }
      var target = delta ? Math.max(0, line.quantity + delta) : qty;
      return api(route('change', '.js'), { id: line.key, quantity: target }).then(function (c) { settle(); if (onDone) onDone(); return setCart(c); });
    }).catch(function (e) { settle(); if (onDone) onDone(); repaintBag(); toast(esc(e.message || 'Could not change that one')); });
    addQ = run;
    return run;
  }
  /* A line taken out leaves smoothly: it fades and slides, then its height closes so the lines below glide up.
     The request starts at once. Keys in `leaving` are not drawn until their change is over (or comes back on an error).
     While a row is animating, the bag is not redrawn (that would cut the motion); it is drawn once when the last one has gone. */
  var leaving = {}, holdN = 0, gcHook = null; // gcHook: set by initGc on the gift card page
  function shown(c) {
    if (!c || !Object.keys(leaving).length) return c;
    var o = {}, q = 0, sum = 0;
    Object.keys(c).forEach(function (k) { o[k] = c[k]; });
    o.items = (c.items || []).filter(function (it) { if (!leaving[it.key]) return true; q += it.quantity; sum += it.final_line_price; return false; });
    o.item_count = Math.max(0, (c.item_count || 0) - q);
    o.total_price = Math.max(0, (c.total_price || 0) - sum);
    return o;
  }
  function leaveAnim(row) {
    if (!row || !row.animate || !row.offsetHeight) { renderBag(); return; }
    var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ez = (getComputedStyle(document.documentElement).getPropertyValue('--ease') || '').trim() || 'cubic-bezier(.32,.72,0,1)';
    var over = false, safety;
    holdN++;
    row.style.pointerEvents = 'none';
    function fin() { if (over) return; over = true; clearTimeout(safety); holdN = Math.max(0, holdN - 1); if (!holdN) renderBag(); }
    safety = setTimeout(fin, 700);
    if (rm) { row.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing: 'ease-out', fill: 'forwards' }).onfinish = fin; return; }
    var a = row.animate([{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: 'translateX(16px)' }], { duration: 170, easing: ez, fill: 'forwards' });
    a.onfinish = function () {
      if (over || !row.isConnected) { fin(); return; }
      var st = getComputedStyle(row), h = row.offsetHeight;
      row.style.overflow = 'hidden';
      var b = row.animate([
        { height: h + 'px', paddingTop: st.paddingTop, paddingBottom: st.paddingBottom, borderBottomWidth: st.borderBottomWidth, opacity: 0, transform: 'translateX(16px)' },
        { height: '0px', paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px', opacity: 0, transform: 'translateX(16px)' }
      ], { duration: 220, easing: ez, fill: 'forwards' });
      b.onfinish = fin;
    };
  }
  function removeLine(key, qty, delta, btn) {
    if (busy && !addN) return Promise.resolve();
    // the view holds on the row right after the leaving one
    var row = btn && btn.closest('.cs-line'), nx = row && row.nextElementSibling;
    while (nx && !aid(nx)) nx = nx.nextElementSibling;
    anchorHint = nx ? aid(nx) : null;
    leaving[key] = 1; footBusy();
    leaveAnim(row);
    return changeLine(key, qty, delta, function () { delete leaving[key]; });
  }
  // + / − taps and rollbacks draw at once; everything else goes through the coalesced renderBag()
  function repaintBag() {
    footBusy();
    if ((openEl && openEl.id === 'csBag') || document.getElementById('csCartBody')) renderBag(true);
  }
  function footBusy() {
    var on = Object.keys(qPend).length > 0 || Object.keys(leaving).length > 0;
    $$('#csBagFoot,#csCartFoot').forEach(function (f) { f.classList.toggle('busy', on); });
  }
  /* Scroll anchoring: every bag redraw keeps one row exactly where it was on screen
     (rows are found by data-key, or data-a for rows without a key). */
  var anchorHint = null;
  function aid(el) {
    if (!el || !el.getAttribute) return null;
    var k = el.getAttribute('data-key'); if (k != null) return 'k:' + k;
    var a = el.getAttribute('data-a'); return a ? 'a:' + a : null;
  }
  function bagBox(body) {
    if (body.id === 'csCartBody') return window;
    for (var n = body; n && n !== document.body && n !== document.documentElement; n = n.parentElement) { var o = getComputedStyle(n).overflowY; if (o === 'auto' || o === 'scroll') return n; }
    return null;
  }
  function anchorTake(body) {
    var box = bagBox(body); if (!box) return null;
    var win = box === window;
    if (win) { if (document.body.classList.contains('cs-lock') || window.pageYOffset <= 0) return null; }
    else if (!box.clientHeight || box.scrollTop <= 0) return null; // at the very top: stay at the top
    var top = win ? swHeadH() : box.getBoundingClientRect().top, vis = win ? innerHeight - top : box.clientHeight;
    var list = [], start = -1, hint = -1;
    $$('[data-key],[data-a]', body).forEach(function (el) {
      var id = aid(el), k = el.getAttribute('data-key');
      if (!id || !el.offsetHeight || (k != null && leaving[k])) return;
      var t = el.getBoundingClientRect().top - top;
      list.push({ id: id, off: t });
      if (start < 0 && t >= -0.5) start = list.length - 1;
      if (anchorHint === id && t >= -0.5 && t < vis) hint = list.length - 1;
    });
    anchorHint = null;
    if (!list.length) return null;
    if (hint >= 0) start = hint; else if (start < 0) start = list.length - 1;
    return { body: body, box: box, win: win, list: list.slice(start, start + 40) };
  }
  function anchorPut(a) {
    if (!a) return;
    var top = a.win ? swHeadH() : a.box.getBoundingClientRect().top, map = {};
    $$('[data-key],[data-a]', a.body).forEach(function (el) { var id = aid(el); if (id && !map[id] && el.offsetHeight) map[id] = el; });
    for (var i = 0; i < a.list.length; i++) {
      var el = map[a.list[i].id]; if (!el) continue;
      var d = el.getBoundingClientRect().top - top - a.list[i].off;
      if (Math.abs(d) >= 0.5) { if (a.win) window.scrollTo(0, window.pageYOffset + d); else a.box.scrollTop = a.box.scrollTop + d; }
      return;
    }
  }
  /* Fewer redraws: while a row leaves or any bag change / gift fix is running, redraws wait and happen once (rAF-batched). */
  var bagDirty = false, bagRaf = 0, bagCapT = 0;
  function bagBusy() { return holdN > 0 || addN > 0 || fixing || Object.keys(leaving).length > 0; }

  /* ---------- design picker sheet ---------- */
  var productCache = {};
  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch((CS.routes && CS.routes.products || '/products/') + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Not found'); return r.json(); })
      .then(function (p) { productCache[handle] = p; return p; });
  }
  CS.getProduct = getProduct;
  function imgUrl(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    return src.replace(/^\/\//, 'https://').replace(/(\?.*)?$/, function (q) { return (q ? q + '&' : '?') + 'width=' + (w || 300); });
  }
  CS.imgUrl = imgUrl;
  // a design counts as gold / silver when the word is in its name (same rule as snippets/cs-card.liquid)
  function vidsOf(el) { var s = el && (el.getAttribute('data-vids') || (el.closest('.cs-card') && el.closest('.cs-card').getAttribute('data-vids'))); return s ? s.split(',').filter(Boolean) : null; }
  function hasMetal(t, m) { return String(t || '').toLowerCase().split(/[^a-z]+/).indexOf(m) >= 0; }
  // only: variant ids (strings) to show, for a one-design card or one concept card of a mixed product
  function openPicker(handle, title, metal, all, only) {
    var g = document.getElementById('csVarG'); if (!g) return;
    only = only && only.length ? only.map(String) : null;
    $('#csVarT').textContent = title || 'Pick a design';
    $('#csVarS').textContent = 'Loading designs…';
    g.innerHTML = '';
    if (!all) openPanel('csVar');
    getProduct(handle).then(function (p) {
      var inCart = {}, v0 = view(); (v0 && v0.items || []).forEach(function (it) { inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity; });
      var vs = p.variants, m = metal === 'gold' || metal === 'silver' ? metal : '';
      if (only) { var fo = vs.filter(function (v) { return only.indexOf(String(v.id)) >= 0; }); if (fo.length) vs = fo; else only = null; }
      var vn = vs.length;
      if (m && !all) { var f = vs.filter(function (v) { return hasMetal(v.title, m); }); if (f.length && f.length < vs.length) vs = f; else m = ''; } else m = '';
      $('#csVarT').textContent = only && title ? title : p.title;
      var purl = (CS.routes && CS.routes.products || '/products/') + encodeURIComponent(p.handle);
      // one price for all the designs shown: say it once on top instead of under every design
      var vary = vs.some(function (v) { return v.price !== vs[0].price; });
      if (only && vs.length === 1) purl += '?variant=' + vs[0].id;
      $('#csVarS').innerHTML = esc(vs.length === 1 ? money(vs[0].price) + ' · tap it to add it to your bag' : vs.length + (m ? ' ' + m : '') + ' designs' + (vary || !vs.length ? '' : ' · ' + money(vs[0].price) + ' each') + ' · tap one to add it') +
        (m ? ' · <button type="button" class="cs-link" data-cs-pickall>Show all ' + vn + '</button>' : '') +
        ' · <a class="cs-link" href="' + esc(purl) + '">Details</a>';
      var sa = $('#csVarS [data-cs-pickall]'); if (sa) sa.addEventListener('click', function () { openPicker(handle, title, '', true, only); });
      g.innerHTML = vs.map(function (v) {
        var im = v.featured_image ? v.featured_image.src : (p.featured_image || '');
        var im300 = im ? imgUrl(im, 300) : '';
        var cmp = v.compare_at_price || 0, off = cmp > v.price ? Math.floor((cmp - v.price) * 100 / cmp) : 0;
        return '<div class="cs-vit">' +
          '<button type="button" data-cs-addv="' + v.id + '" data-h="' + esc(p.handle) + '" data-price="' + v.price + '" data-title="' + esc(v.title) + '"' + (v.available ? '' : ' disabled') + '>' +
          '<span class="cs-vpic">' + (im ? '<img src="' + imgUrl(im, 300) + '" alt="" loading="lazy">' : '') + (off ? '<b class="cs-voff">' + off + '% off</b>' : '') + (inCart[v.id] ? '<em>' + icon('check') + inCart[v.id] + '</em>' : '') + '</span>' +
          '<span>' + esc(v.title) + '</span>' + (!v.available ? '<small>Sold out</small>' : vary || off ? '<small>' + (off ? '<s><span class="sr">Regular price </span>' + money(cmp) + '</s> ' : '') + money(v.price) + '</small>' : '') + '</button>' +
          '<button type="button" class="cs-heart cs-vheart" data-cs-heart="' + esc(p.handle) + ':' + esc(v.id) + '" data-h="' + esc(p.handle) + '" data-title="' + esc(v.title) + '" data-price="' + esc(v.price) + '" data-img="' + esc(im300) + '" aria-pressed="false" aria-label="Save ' + esc(v.title) + '">' + icon('heart') + '</button>' +
          '</div>';
      }).join('');
      paintHearts();
    }).catch(function () { $('#csVarS').textContent = 'Could not load the designs. Please try again.'; });
  }
  CS.openPicker = openPicker;
  // swap this month's charm for another design (or pick it ahead of time).
  // The bag changes at once; the cart catches up in the background (one swap in flight, the last tap wins).
  var cpBusy = false, cpWant = 0;
  function cotmLine() { return (cart && cart.items || []).filter(function (it) { return it.handle === CFG.cotm.handle; })[0]; }
  function cotmSync() {
    var line = cotmLine(), id = cpWant;
    if (!line || !id || line._was === id || (!line._was && line.variant_id === id)) { if (cpBusy) { cpBusy = false; fixing = false; } return; }
    if (line._was) { line = JSON.parse(JSON.stringify(line)); line.variant_id = line._was; }
    cpBusy = true; fixing = true;
    api(route('add', '.js'), { items: [{ id: id, quantity: 1, properties: { _gift: '1' } }] })
      .then(function () { var u = {}; u[line.key] = 0; return api(route('update', '.js'), { updates: u }); })
      .then(function (c2) {
        if (cpWant !== id) {
          cart = c2; var l2 = cotmLine(), o2 = cotmOpts().filter(function (x) { return x.variant === cpWant; })[0];
          if (l2 && o2) { l2._was = l2.variant_id; l2.variant_id = o2.variant; l2.variant_title = o2.name; if (o2.image) { l2.image = o2.image; l2.featured_image = { url: o2.image }; } }
          return cotmSync();
        }
        cpBusy = false; fixing = false; setCart(c2);
      })
      .catch(function () { cpBusy = false; fixing = false; loadCart(); toast('That didn\'t change. Please try again.'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cs-cotm-pick]'); if (!t) return;
    e.preventDefault(); e.stopPropagation();
    var id = Number(t.getAttribute('data-cs-cotm-pick')), o = cotmUse(id); if (!o) return;
    try { localStorage.setItem('cs_cotm_pick', String(id)); } catch (er) {}
    var line = cotmLine();
    if (!line) { renderBag(true); paintCotm(); return; }
    if ((line._was ? 0 : line.variant_id) === id && !cpBusy) { renderBag(true); return; }
    if (!cpBusy && !quiet()) { renderBag(true); return; }
    // show the new design right away
    if (!line._was) line._was = line.variant_id;
    line.variant_id = id; line.variant_title = o.name; if (o.image) { line.image = o.image; line.featured_image = { url: o.image }; }
    renderBag(true);
    cpWant = id;
    if (!cpBusy) cotmSync();
  });

  /* ---------- bag drawer ---------- */
  function lineName(it) {
    var v = it.variant_title, multi = v && v !== 'Default Title' && v !== it.product_title && it.product_has_only_default_variant === false;
    if (multi && kind(it) === 'bracelet') return { name: it.product_title, sub: v };
    if (isPhoto(it)) return { name: 'Photo Charm', sub: v || '' };
    return { name: multi ? v : it.product_title, sub: multi ? it.product_title : '' };
  }
  function giftValue(it) { var k = kind(it); return k === 'gift' ? (CFG.cotm && CFG.cotm.value) || 0 : k === 'tool' && it.price === 0 ? (CFG.giftTool && CFG.giftTool.value) || 0 : 0; }
  // W15: struck value above a green FREE pill (screen readers: "Worth $4.49 Free")
  function giftWas(v) { return v ? '<s><span class="sr">Worth </span>' + v + '</s>' : ''; }
  var FREEP = '<span class="cs-freep">Free</span>';
  function priceCell(it) {
    if (it.final_line_price === 0 && it.original_line_price > 0) return giftWas(money(it.original_line_price)) + FREEP;
    if (it.final_line_price === 0 && !it.gift_card) return FREEP;
    if (it.final_line_price < it.original_line_price) return money(it.final_line_price) + '<s>' + money(it.original_line_price) + '</s>';
    return money(it.final_line_price);
  }
  // gift card sent to a friend: "To Anna (anna@x.com) · sends Dec 20" (non-underscore properties, escaped)
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function gcNote(it) {
    if (!it.gift_card || !it.properties) return '';
    var p = it.properties, out = [], nm = p['Recipient name'], em = p['Recipient email'];
    if (nm && em) out.push('To ' + esc(nm) + ' (' + esc(em) + ')'); else if (nm || em) out.push('To ' + esc(nm || em));
    if (p['Send on']) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(p['Send on'])), mo = m && MON[Number(m[2]) - 1]; out.push('sends ' + (mo ? mo + ' ' + Number(m[3]) : esc(p['Send on']))); }
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) === '_' || k === 'Recipient name' || k === 'Recipient email' || k === 'Send on' || p[k] == null || p[k] === '') return;
      var v = String(p[k]);
      if (k === 'Message') { var ch = Array.from ? Array.from(v) : v.split(''); out.push('\u201C' + esc(ch.length > 40 ? ch.slice(0, 40).join('') + '\u2026' : v) + '\u201D'); return; }
      out.push(esc(k) + ': ' + esc(v));
    });
    return out.join(' · ');
  }
  function lineHtml(it, note, after) {
    if (leaving[it.key]) return '';
    var gn = gcNote(it); if (gn) note = (note ? note + ' · ' : '') + gn;
    var n = lineName(it), img = it.image ? imgUrl(it.image, 160) : '';
    if (isPhoto(it)) { var pp = it.properties || {}; if (/^https:\/\//.test(pp.Design || '')) img = pp.Design; if (pp.Words) note = (note ? note + ' · ' : '') + '\u201C' + esc(String(pp.Words).slice(0, 40)) + '\u201D'; }
    return '<div class="cs-line" data-key="' + esc(it.key) + '">' +
      '<a class="th" href="' + esc(it.url) + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" decoding="async">' : '') + '</a>' +
      '<div><a class="nm" href="' + esc(it.url) + '">' + esc(n.name) + '</a>' + (n.sub || note ? '<div class="sub">' + esc(n.sub) + (note ? (n.sub ? ' · ' : '') + note : '') + '</div>' : '') +
      '<div class="ctl"><div class="cs-qty"><button type="button" data-cs-q="' + esc(it.key) + '" data-d="-1" aria-label="One less"' + (it.quantity + (qPend[it.key] || 0) <= 0 ? ' disabled' : '') + '>' + icon('minus') + '</button><span>' + Math.max(0, it.quantity + (qPend[it.key] || 0)) + '</span>' + ((isGift(it) && it.final_line_price === 0) || it.price === 0 ? '' : '<button type="button" data-cs-q="' + esc(it.key) + '" data-d="1" aria-label="One more">' + icon('plus') + '</button>') + '</div>' +
      '<button type="button" class="cs-rm" data-cs-q="' + esc(it.key) + '" data-n="0">Remove</button></div></div>' +
      '<div class="pr">' + priceCell(it) + '</div>' + (after || '') + '</div>';
  }
  /* the builder's picture of the bracelets, only while it still shows charms that are in this bag:
     one made for an older bag (none of its charms left) is not this order */
  function readSnap(c) {
    try {
      var o = JSON.parse(localStorage.getItem('csb_state') ? (localStorage.getItem('csb_snap') || 'null') : 'null'); if (!o || !o.br) return null;
      if (c && o.sig && !(c.items || []).some(function (it) { return o.sig[isPhoto(it) ? phKey(it) : it.variant_id]; })) return null;
      return o;
    } catch (e) { return null; }
  }
  function braceletsHtml(c, s) {
    var snap = readSnap(c), url = esc(CFG.builder || '/');
    if (!s.charms) return '';
    if (!snap || !snap.br.length) {
      return '<a class="cs-bcta" data-a="bcta" href="' + url + '"><span class="cs-lkx">' + icon('spark') + '</span><span class="t"><b>See your charms on a bracelet</b><small>Open the builder to place them, move them and pick the metal.</small></span>' + icon('right') + '</a>';
    }
    var want = {}, have = snap.sig || {}, diff = 0;
    (c.items || []).forEach(function (it) { var k = isPhoto(it) ? phKey(it) : kind(it) === 'charm' ? it.variant_id : null; if (k) want[k] = (want[k] || 0) + it.quantity; });
    Object.keys(want).forEach(function (v) { diff += Math.max(0, want[v] - (have[v] || 0)); });
    var gone = 0; Object.keys(have).forEach(function (v) { gone += Math.max(0, have[v] - (want[v] || 0)); });
    if (syncState()) { gone = 0; diff = 0; } // a save is on its way: the picture is newer than the bag, not older
    var out = '<div class="cs-brs' + (gone ? ' stale' : '') + '" data-a="brs">';
    if (gone) out += '<a class="cs-brnote" href="' + url + '">Your bag changed after you made this bracelet, so the picture is out of date. <u>Update it in the builder</u></a>';
    snap.br.slice(0, 3).forEach(function (b) {
      out += '<div class="cs-br"><div class="hd"><div><b>' + esc(b.name) + '</b><small>' + b.size + ' links · ' + esc(b.sizeLbl || '') + ' · ' + b.n + ' charm' + (b.n === 1 ? '' : 's') + '</small></div><a class="cs-link" href="' + url + '">Edit</a></div>' +
        '<div class="cs-brow" data-w="' + b.w + '" data-h="' + b.h + '"><div class="in" style="width:' + b.w + 'px;height:' + b.h + 'px">' + b.html + '</div></div></div>';
    });
    if (snap.br.length > 3) out += '<a class="cs-brnote" href="' + url + '">' + (snap.br.length - 3) + ' more bracelet' + (snap.br.length - 3 === 1 ? '' : 's') + ' in the builder. <u>See them all</u></a>';
    if (diff && !gone) out += '<a class="cs-brnote" href="' + url + '">' + more(diff, 'charm').replace(' more', '') + ' not on a bracelet yet. <u>Place them in the builder</u></a>';
    return out + '</div>';
  }
  function fitRows(root) {
    var rows = $$('.cs-brow', root), ws = rows.map(function (r) { return r.clientWidth || 300; }); // all reads first, then all writes (one layout, not one per row)
    rows.forEach(function (r, i) {
      var w = Number(r.getAttribute('data-w')) || 1, h = Number(r.getAttribute('data-h')) || 1, k = Math.min(1.4, ws[i] / w);
      var inr = r.firstChild; inr.style.transform = 'scale(' + k + ')'; r.style.height = Math.ceil(h * k) + 'px';
    });
  }
  function freeBracelets(charms) { return Math.min(3, Math.floor(charms / 10)); }
  CS.freeBracelets = freeBracelets;
  function isGift(it) { var p = it.properties || {}; return !!(p._gift || p._builder); }
  CS.isGift = isGift;
  function flag(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} return null; }
  var GFLAGS = ['cs_cotm_no', 'cs_tool_no', 'cs_pouch_no', 'cs_seen_charm-of-the-month', 'cs_seen_free-charm-tool', 'cs_seen_charmie-pouch'];
  function giftFlagsFor(c) { var t = c && c.token || ''; if (flag('cs_gift_token') !== t) { GFLAGS.forEach(function (k) { flag(k, null); }); flag('cs_gift_token', t); } }
  function resetGiftFlags() { GFLAGS.forEach(function (k) { flag(k, null); }); }
  var fixing = false;
  // a gift taken out by hand: remember it (only called when the bag is not mid-change)
  function noteGifts(c, s) {
    giftFlagsFor(c); s = s || stats(c);
    [[CFG.cotm, 'cs_cotm_no', s.charms >= 5], [CFG.giftTool, 'cs_tool_no', s.bracelets > 0], [CFG.pouch, 'cs_pouch_no', s.charms + s.bracelets > 0]].forEach(function (g) {
      if (!g[0]) return; var k = 'cs_seen_' + g[0].handle, have = (c.items || []).reduce(function (x, it) { return x + (it.handle === g[0].handle ? it.quantity : 0); }, 0);
      if (have) flag(k, '1'); else if (g[2] && flag(k) === '1') { flag(g[1], '1'); flag(k, null); }
      if (!g[2]) flag(k, null);
    });
  }
  // a gift that could not be added (sold out) is not tried again on this page
  var giftFailed = {};
  function quiet() { var P = window.CSB_SYNC ? window.CSB_SYNC() : null; return !(fixing || busy || (P && P.pending)); }
  /* A free bracelet we added stays only while the charms still pay for it: after charms are taken out on
     any page, take the extra ones out too (and say so), instead of letting Shopify start charging for them. */
  function giftFix(c) {
    if (window.CSB || !quiet() || !c) return false;
    var s = stats(c), E = freeBracelets(s.charms), q = function (a) { return a.reduce(function (x, it) { return x + it.quantity; }, 0); };
    var cls = s.lines.bracelet.filter(function (it) { return !(CFG.matching && it.handle === CFG.matching.handle); }), gb = cls.filter(isGift).sort(function (a, b) { return (b.properties && b.properties._builder ? 1 : 0) - (a.properties && a.properties._builder ? 1 : 0); });
    // a bracelet added as the pair of the free one does not take its place (Shopify frees the cheapest; the total is the same)
    var pr = cls.filter(function (it) { return it.properties && it.properties._pair && !isGift(it); }), prFree = pr.some(function (it) { return it.final_line_price < it.original_line_price; });
    var keepB = Math.max(0, Math.min(q(gb), E - (q(cls) - q(gb) - q(pr)))), upd = {}, cutB = 0;
    var back = [], mv = {}; if (CFG.matching) CFG.matching.variants.forEach(function (v) { if (v.available !== false) mv[String(v.title).toLowerCase()] = v.id; });
    gb.forEach(function (it) {
      var k = Math.min(it.quantity, keepB); keepB -= k; if (k === it.quantity) return;
      upd[it.key] = k; cutB += it.quantity - k;
      // it was the shopper's matching bracelet before the charms paid for it: it goes back to that, not out of the bag
      var to = it.properties && it.properties._was === 'matching' && mv[String(it.variant_title || '').toLowerCase()];
      if (to) back.push({ id: to, quantity: it.quantity - k });
    });
    // safety net: a bracelet we added as free that Shopify still charges for comes out instead of being paid for
    var charged = 0; if (!prFree) gb.forEach(function (it) { if (!(it.key in upd) && it.final_line_price > 0) { upd[it.key] = 0; charged++; } });
    if (!Object.keys(upd).length) return false;
    fixing = true;
    var nb = back.reduce(function (x, a) { return x + a.quantity; }, 0);
    (back.length ? api(route('add', '.js'), { items: back }).catch(function () { nb = 0; }) : Promise.resolve()).then(function () { return api(route('update', '.js'), { updates: upd }); }).then(function () { return api(route('cart', '.js')); }).then(function (c2) { fixing = false; setCart(c2); }, function () { fixing = false; loadCart().catch(function () {}); }).then(function () {
      if (nb && nb === cutB) toast('Under ' + (E + 1) * 10 + ' charms, ' + (nb === 1 ? 'that bracelet is a matching bracelet again' : 'those bracelets are matching bracelets again') + ' (' + money(CFG.matching.price) + (nb === 1 ? '' : ' each') + ').');
      else if (cutB) toast(E ? 'That bracelet is free at ' + (E + 1) * 10 + ' charms, so it is out of your bag for now.' : 'The free bracelet needs 10 charms, so it is out of your bag for now.');
      else if (charged) toast('That bracelet isn\'t free yet, so we took it out of your bag.');
    });
    return true;
  }
  /* The gifts that follow the bag by themselves:
     - this month's charm at 5 charms or more (one per order)
     - the charm tool whenever a bracelet is in the bag (one per order)
     - a matching bracelet becomes a free Classic bracelet once the charms pay for one (every bracelet counts as one of the free ones)
     A gift the shopper takes out stays out until the reason for it goes away. */
  function autoGifts(c) {
    if (!quiet() || !c) return false;
    giftFlagsFor(c);
    var s = stats(c), upd = {}, add = [], said = [];
    function lines(h) { return (c.items || []).filter(function (it) { return it.handle === h; }); }
    function qty(a) { return a.reduce(function (x, it) { return x + it.quantity; }, 0); }
    function want(cfg, on, noKey, label) {
      if (!cfg || !cfg.variant) return;
      var ls = lines(cfg.handle), have = qty(ls);
      if (!on) { flag(noKey, null); ls.forEach(function (it) { upd[it.key] = 0; }); return; }
      if (flag(noKey) === '1' || giftFailed[cfg.variant]) return;
      if (have === 1) return;
      if (have > 1) { ls.forEach(function (it, i) { upd[it.key] = i === 0 ? 1 : 0; }); return; }
      add.push({ id: cfg.variant, quantity: 1, properties: { _gift: '1' } }); if (label) said.push(label);
    }
    noteGifts(c, s);
    want(CFG.cotm, s.charms >= 5, 'cs_cotm_no', 'this month\'s charm');
    want(CFG.giftTool, s.bracelets > 0, 'cs_tool_no', 'the charm tool');
    // the gift pouch: one in every order with charms or a bracelet (packed with it; no message)
    want(CFG.pouch, s.charms + s.bracelets > 0, 'cs_pouch_no', null);
    // matching bracelets turn into free Classic bracelets (same metal) once the charms pay for them
    var E = freeBracelets(s.charms), room = Math.max(0, E - s.eligible);
    if (room && s.matching && CFG.matching && !window.CSB) {
      var byTitle = {}; (CFG.braceletVariants || []).forEach(function (v) { if (v.available !== false) byTitle[String(v.title).toLowerCase()] = v.id; });
      lines(CFG.matching.handle).forEach(function (it) {
        var to = byTitle[String(it.variant_title || '').toLowerCase()]; if (!to || giftFailed[to]) return;
        var n = Math.min(room, it.quantity); if (!n) return; room -= n;
        upd[it.key] = it.quantity - n;
        add.push({ id: to, quantity: n, properties: { _gift: '1', _was: 'matching' } });
        said.push(n > 1 ? n + ' free bracelets' : 'a free bracelet');
      });
    }
    if (!Object.keys(upd).length && !add.length) return false;
    fixing = true;
    var ch = Promise.resolve();
    // add first: if an add fails (sold out), nothing has been taken out yet
    if (add.length) ch = ch.then(function () { return api(route('add', '.js'), { items: add }); });
    if (Object.keys(upd).length) ch = ch.then(function () { return api(route('update', '.js'), { updates: upd }); });
    ch.then(function () { return api(route('cart', '.js')); }).then(function (c2) { fixing = false; setCart(c2); if (said.length) toast(icon('gift') + 'We added ' + said.join(' and ') + ', free.'); }, function () { fixing = false; add.forEach(function (a) { giftFailed[a.id] = true; }); loadCart().catch(function () {}); });
    return true;
  }
  // the builder calls this after it saved: read the bag fresh, then the fixers run on it
  CS.autoGifts = function () { return loadCart().catch(function () {}); };
  // a free add-on (the pouch) is one per order, on every page
  function addonFix(c) {
    if (!quiet() || !c) return false;
    var upd = {}; (c.items || []).forEach(function (it) { if (kind(it) === 'other' && it.price === 0 && it.quantity > 1) upd[it.key] = 1; });
    if (!Object.keys(upd).length) return false;
    fixing = true;
    api(route('update', '.js'), { updates: upd }).then(function (c2) { fixing = false; setCart(c2); toast('One pouch per order. We kept one in your bag.'); }, function () { fixing = false; });
    return true;
  }
  /* the free photo charm: one per order while the bag has PH.need charms. A free one past that becomes a paid one with the
     same design; a paid one becomes the free one once the bag gets there. The design (Design, Words) moves with it. */
  function photoFix(c) {
    if (!PH || !PH.gift || !quiet() || !c) return false;
    var s = stats(c), gl = [], pl = [], add = [], upd = {};
    (c.items || []).forEach(function (it) { if (isPhotoGift(it)) gl.push(it); else if (isPhoto(it)) pl.push(it); });
    var gq = gl.reduce(function (a, it) { return a + it.quantity; }, 0), want = s.base >= PH.need ? 1 : 0;
    if (gq > want) {
      var extra = gq - want;
      gl.slice().reverse().forEach(function (it) { if (!extra) return; var k = Math.min(extra, it.quantity), pv = (PH.variants || {})[it.variant_title]; extra -= k; upd[it.key] = it.quantity - k; if (pv) add.push({ id: pv, quantity: k, properties: it.properties || {} }); });
    } else if (gq < want && pl.length) {
      var it = pl[0], gv = (PH.gift.variants || {})[it.variant_title];
      if (gv) { add.push({ id: gv, quantity: 1, properties: it.properties || {} }); upd[it.key] = it.quantity - 1; }
    }
    if (!add.length && !Object.keys(upd).length) return false;
    fixing = true;
    (add.length ? api(route('add', '.js'), { items: add }) : Promise.resolve()).then(function () { return api(route('update', '.js'), { updates: upd }); })
      .then(function () { return api(route('cart', '.js')); })
      .then(function (c2) { fixing = false; setCart(c2); if (gq < want) toast('Your photo charm is free now.'); }, function () { fixing = false; loadCart().catch(function () {}); });
    return true;
  }
  /* shipping protection: one per order, and only while something in the bag ships. Never added here. */
  function protFix(c) {
    if (!CFG.protection || !quiet() || !c) return false;
    var ls = protLines(c), upd = {}, keep = ships(c) ? 1 : 0; if (!ls.length) return false;
    ls.forEach(function (it) { var k = Math.min(it.quantity, keep); keep -= k; if (k !== it.quantity) upd[it.key] = k; });
    if (!Object.keys(upd).length) return false;
    fixing = true;
    api(route('update', '.js'), { updates: upd }).then(function (c2) { fixing = false; setCart(c2); }, function () { fixing = false; });
    return true;
  }
  var PROT = { busy: false, want: null };
  function paintProt() {
    $$('[data-cs-prot]').forEach(function (b) { b.setAttribute('aria-checked', PROT.want ? 'true' : 'false'); if (PROT.busy) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
    $$('#csBagFoot,#csCartFoot').forEach(function (f) { f.classList.toggle('pbusy', PROT.busy); });
  }
  // flips at once; the add / remove waits its turn with the other bag changes; on an error the cart redraws it as it was
  function protToggle() {
    var P = CFG.protection; if (!P || PROT.busy || !cart || (busy && !addN)) return;
    var line = protLines(cart)[0], on = !line;
    if (on && !ships(shown(cart))) return;
    PROT.busy = true; PROT.want = on; paintProt();
    var run = on ? addItems([{ id: P.variant, quantity: 1 }], P.title, null, true) : changeLine(line.key, 0, 0);
    run.then(function () {
      PROT.busy = false; PROT.want = null;
      $$('.cs-bagfoot.pbusy').forEach(function (f) { f.classList.remove('pbusy'); });
      repaintBag();
    });
  }
  function protRow(c, s, fid) {
    var P = CFG.protection; if (!P || !P.variant || !ships(c)) return '';
    var on = PROT.want != null ? PROT.want : s.prot > 0, id = 'csPt' + (fid || 'F');
    return '<div class="cs-prot">' + icon('shield') + '<span class="t"><span class="r1"><b id="' + id + '">Shipping protection</b><span class="p" id="' + id + 'P">' + money(P.price) + '</span></span><small id="' + id + 'S">Lost or damaged on the way? We send it again.</small></span>' +
      '<button type="button" class="cs-sw" role="switch" data-cs-prot aria-checked="' + (on ? 'true' : 'false') + '" aria-labelledby="' + id + ' ' + id + 'P" aria-describedby="' + id + 'S"' + (PROT.busy ? ' aria-busy="true"' : '') + '><i></i></button></div>';
  }
  function brUrl() { return String(CS.routes && CS.routes.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/') + 'collections/bracelet'; }
  function minBracelet() { return (CFG.braceletVariants || []).reduce(function (a, v) { return v.available && v.price && (!a || v.price < a) ? v.price : a; }, 0); }
  // free: a Classic bracelet the charms pay for. paid: the matching bracelet at its own price
  function metalPicker(label, paid, classic) {
    var vs = paid && CFG.matching && !classic ? CFG.matching.variants : (CFG.braceletVariants || []);
    vs = vs.filter(function (v) { return v.available !== false; });
    return '<div class="cs-unlock' + (paid ? ' pair' : '') + '" data-a="mp' + (paid ? 'p' : 'f') + (classic ? 'c' : '') + '"><div class="t">' + icon(paid ? 'bag' : 'gift') + '<span>' + label + '</span></div><div class="cs-metals">' +
      vs.map(function (v) { return '<button type="button" data-cs-addv="' + v.id + '"' + (paid ? '' : ' data-cs-gift') + ' data-title="' + esc((paid && !classic ? CFG.matching.title : CFG.braceletTitle) || 'Bracelet') + ' · ' + esc(v.title) + '">' + (v.image ? '<img src="' + esc(v.image) + '" alt="" loading="lazy">' : '') + '<span>' + esc(v.title) + '</span></button>'; }).join('') + '</div></div>';
  }
  /* "Make it a pair": the matching bracelet in each metal, then other bracelets, in one row that swipes (cs-pairs).
     It is a .cs-metals box, so a tap shows "Adding…" in the bag at once, like the metal picker. */
  function pairCard(id, h, img, title, price, was, tag) {
    return '<button type="button" data-cs-addv="' + id + '"' + (tag ? '' : ' data-cs-pair') + ' data-h="' + esc(h) + '" data-price="' + price + '" data-title="' + esc(title) + '" aria-label="Add ' + esc(title) + ', ' + esc(money(price)) + '">' +
      '<span class="im">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + (tag ? '<em>' + tag + '</em>' : '') + '</span>' +
      '<span class="nm">' + esc(title) + '</span><span class="pp">' + (was > price ? '<s>' + money(was) + '</s>' : '') + money(price) + '</span><i class="ad" aria-hidden="true">' + icon('plus') + '</i></button>';
  }
  function pairSlider(label) {
    var M = CFG.matching, cards = [];
    if (M) M.variants.forEach(function (v) { if (v.available !== false) cards.push(pairCard(v.id, M.handle, v.image, v.title, M.price, minBracelet(), 'Matching')); });
    (CFG.pairs || []).forEach(function (p) { cards.push(pairCard(p.id, p.h, p.img, p.t, p.price, 0, '')); });
    return '<div class="cs-unlock pair cs-pairbox" data-a="mpp"><div class="t">' + icon('bag') + '<span>' + label + '</span><span class="cs-parr"><button type="button" data-cs-pscroll="-1" aria-label="Scroll back">' + icon('left') + '</button><button type="button" data-cs-pscroll="1" aria-label="See more bracelets">' + icon('right') + '</button></span></div>' +
      '<div class="cs-metals cs-pairs" data-cs-pairs>' + cards.join('') + '</div></div>';
  }
  // o: {title, sub, img?, ic?, val?, pct? (locked progress), locked?, got?, right?}; data-a keeps the old rw* ids
  function giftRow(o) {
    var th = o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">' : icon(o.ic || 'gift');
    var bar = o.pct != null ? '<span class="cs-gbar" aria-hidden="true"><i style="width:' + Math.max(0, Math.min(100, o.pct)).toFixed(1) + '%"></i></span>' : '';
    return '<div class="cs-line cs-reward cs-gift' + (o.locked ? ' locked' : '') + '" data-a="rw' + (o.locked ? 'l' : 'g') + String(o.title).replace(/<[^>]*>|&#?\w+;|\W+/g, '').slice(0, 30) + '"><span class="th">' + th + '</span><div><div class="nm">' + o.title + '</div><div class="sub">' + (o.got ? icon('check') : '') + o.sub + '</div>' + bar + '</div><div class="pr">' + (o.right != null ? o.right : o.locked ? (o.val ? '<span class="cs-worth">Worth ' + o.val + '</span>' : '') : giftWas(o.val) + FREEP) + '</div></div>';
  }
  // now === true: draw at once (opening the drawer, + / − taps, rollbacks); otherwise coalesced
  function renderBag(now) {
    if (holdN || (now !== true && bagBusy())) {
      bagDirty = true;
      // safety: a request that hangs or fails never leaves the bag stale for long
      if (!bagCapT) bagCapT = setTimeout(function () { bagCapT = 0; if (bagDirty) renderBag(true); }, 1200);
      return;
    }
    if (now === true) { drawBag(); return; }
    bagDirty = true;
    if (!bagRaf) bagRaf = requestAnimationFrame(function () {
      bagRaf = 0; if (!bagDirty) return;
      if (holdN || bagBusy()) renderBag(); else drawBag();
    });
  }
  function drawBag() {
    if (holdN) { bagDirty = true; return; } // a line is leaving: the bag is drawn once it has gone
    bagDirty = false; if (bagRaf) { cancelAnimationFrame(bagRaf); bagRaf = 0; } clearTimeout(bagCapT); bagCapT = 0;
    footBusy();
    var pairs = [['csBagBody', 'csBagFoot'], ['csCartBody', 'csCartFoot']].map(function (p) { return [document.getElementById(p[0]), document.getElementById(p[1])]; }).filter(function (p) { return p[0] && p[1]; });
    if (!pairs.length) return;
    if (!cart) { pairs.forEach(function (p) { p[0].innerHTML = '<div class="cs-empty"><p class="cs-p">Loading your bag…</p></div>'; }); loadCart(); return; }
    pairs.forEach(function (p) { renderBagIn(p[0], p[1]); });
  }
  // the builder is still saving (or offline): say so, instead of showing an older bag as if it were final
  function syncState() { var P = window.CSB_SYNC ? window.CSB_SYNC() : null; return P && P.pending ? { off: navigator.onLine === false, charms: P.charms || 0 } : null; }
  function pendingNote(P, s) {
    var d = P.charms - s.charms, what = d > 0 ? more(d, 'charm').replace(' more', '') + ' from the builder ' + (d === 1 ? 'is' : 'are') + ' not in your bag yet.' : 'Your latest changes from the builder are not in your bag yet.';
    return '<p class="cs-pendnote" role="status">' + (P.off ? '<b>You\'re offline.</b> ' + what + ' They\'ll be saved when you\'re back online.' : '<b>Saving your bag…</b> ' + what) + '</p>';
  }
  function renderBagIn(body, foot) {
    var a = anchorTake(body);
    drawBagIn(body, foot);
    anchorPut(a);
  }
  function drawBagIn(body, foot) {
    var c = shown(cart), s = stats(c), n = bagCount(c), P = syncState();
    $$('[data-cs-bag-n]').forEach(function (x) { x.textContent = s.charms ? ' (' + s.charms + ' charm' + (s.charms === 1 ? '' : 's') + ')' : ''; });
    if (!n && P && P.charms) {
      body.innerHTML = '<div class="cs-empty"><h3 class="cs-h2">' + (P.off ? 'You\'re offline' : 'Saving your bag…') + '</h3><p class="cs-p">' + more(P.charms, 'charm').replace(' more', '') + ' from the builder ' + (P.off ? 'will be added when you\'re back online.' : (P.charms === 1 ? 'is' : 'are') + ' on the way to your bag.') + '</p></div>';
      foot.hidden = true; return;
    }
    if (!n) {
      body.innerHTML = '<div class="cs-empty"><h3 class="cs-h2">Your bag is empty</h3><p class="cs-p">Pick 10 charms and the bracelet is free.</p>' +
        '<a class="cs-btn" href="' + esc(CFG.builder || '/') + '">Start your bracelet</a><a class="cs-link" href="' + esc(CFG.all || '/collections/all') + '">Browse all charms</a></div>' + heartsRow(c);
      foot.hidden = true; return;
    }
    var lost = !s.freeShip && (c.cart_level_discount_applications || []).length && (c.original_total_price || 0) >= FS;
    var h = (P ? pendingNote(P, s) : '') + '<div class="cs-bagtop" data-a="top"><p>' + message(s) + '</p>' + ladder(s.charms, s) + (lost ? '<p class="cs-shipnote">Free shipping counts the total after your code. <b>' + money(FS - c.total_price) + ' more</b> and it\'s free again.</p>' : '') + '</div>' + braceletsHtml(c, s);
    var snapN = (readSnap(c) || { br: [] }).br.length, E = freeBracelets(s.charms), claim = Math.max(0, E - s.eligible);
    var used = Math.max(E, s.eligible), nextAt = used < 3 ? (used + 1) * 10 : 0;
    var mt = CFG.matching ? money(CFG.matching.price) : '';
    if (claim) h += metalPicker('<b>' + (s.eligible === 0 ? 'Your bracelet is free now.' : (s.eligible === 1 ? 'A second bracelet is free.' : 'A third bracelet is free.')) + '</b> Pick a metal, or <a class="cs-link" href="' + esc(brUrl()) + '">choose any bracelet</a>:');
    else if (s.charms > 0 && s.charms < 10 && s.bracelets === 0) h += metalPicker('<b>Want it on a bracelet now?</b> The Classic bracelet is ' + money(minBracelet()) + ', or add ' + more(10 - s.charms, 'charm') + ' and it\'s free:', true, true);
    else if (s.bracelets > 0 && CFG.matching && s.matching === 0 && (snapN <= s.bracelets)) h += pairSlider((s.bracelets === 1 ? '<b>Make it a pair.</b> A matching bracelet is ' : '<b>One more bracelet?</b> A matching one is ') + mt + (nextAt ? ', or free at ' + nextAt + ' charms' : '') + '.');
    if (snapN > s.bracelets && s.bracelets > 0 && !claim && CFG.matching) h += metalPicker('<b>' + (snapN - s.bracelets) + ' more bracelet' + (snapN - s.bracelets === 1 ? ' is' : 's are') + ' only in the builder.</b> Add ' + (snapN - s.bracelets === 1 ? 'it' : 'them') + ' for ' + mt + ' each:', true);
    // a long bag: lines off screen skip layout and paint until they scroll near (opening a 300-charm bag was the slow part)
    h += '<div class="cs-lines' + ((c.items || []).length > 30 ? ' many' : '') + '">';
    s.lines.bracelet.forEach(function (it) {
      var m = CFG.matching && it.handle === CFG.matching.handle;
      var note = it.final_line_price === 0 ? '<span class="g">free with your charms</span>' : (m ? 'matching bracelet' + (nextAt ? ' · free at ' + nextAt + ' charms' : '') : (E < 3 ? more((E + 1) * 10 - s.charms, 'charm') + ' and it\'s free' : ''));
      h += lineHtml(it, note);
    });
    s.lines.charm.forEach(function (it) {
      if (!isPhoto(it)) { h += lineHtml(it); return; }
      h += lineHtml(it, isPhotoGift(it) ? '<span class="g">free with ' + PH.need + ' charms</span>' : (s.base < PH.need && !s.photoFree ? more(PH.need - s.base, 'charm') + ' and one is free' : ''));
    });
    s.lines.gift.forEach(function (it) { h += lineHtml(it, '<span class="g">free with 5 charms</span>' + cotmNote(' · '), cotmStrip(it.variant_id, 'Swap for another design:')); });
    s.lines.tool.forEach(function (it) { h += lineHtml(it, it.final_line_price === 0 ? '<span class="g">free with your bracelet</span>' : ''); });
    s.lines.other.forEach(function (it) { h += lineHtml(it, CFG.pouch && it.handle === CFG.pouch.handle ? '<span class="g">free with every order</span>' : ''); });
    // gh: rewards already in this order; lk: rewards still to unlock (never labelled "Free" before they are)
    var gh = '', lk = '', cm = CFG.cotm, gt = CFG.giftTool;
    if (s.charms < 5 && !s.cotm) lk += giftRow({ locked: true, img: cm && cm.image, title: 'This month\'s charm' + (cm && cm.name ? ': ' + esc(cm.name) : ''), sub: 'Add ' + more(5 - s.charms, 'charm') + cotmNote(' · '), pct: s.charms / 5 * 100, val: cm && cm.value ? money(cm.value) : '' }) + cotmStrip(cm && cm.variant, 'Pick yours now:');
    if (!s.bracelets && !s.tools) lk += giftRow({ locked: true, ic: 'tool', title: 'Charm tool', sub: 'Add a bracelet', val: gt && gt.value ? money(gt.value) : '' });
    if (PH && !s.photo && s.base >= 10 && s.base < PH.need) lk += giftRow({ locked: true, img: PH.image, title: 'Photo charm', sub: 'Add ' + more(PH.need - s.base, 'charm') + ' · your photo or words', pct: (s.base - 10) / (PH.need - 10) * 100, val: money(PH.price) });
    if (s.charms < 30) {
      var nx = (freeBracelets(s.charms) + 1) * 10, bp = (CFG.braceletVariants || [])[0];
      if (s.charms >= 10 || s.bracelets) lk += giftRow({ locked: true, img: bp && bp.image, title: (nx === 10 ? 'Free bracelet' : nx === 20 ? '2nd free bracelet' : '3rd free bracelet'), sub: 'Add ' + more(nx - s.charms, 'charm'), pct: (s.charms - (nx - 10)) / 10 * 100, val: bp ? money(bp.price) : '' });
    }
    function backRow(cfg, img, ic, title, sub, val) { return '<div class="cs-line cs-reward cs-gift" data-a="bk' + cfg.variant + '"><span class="th">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : icon(ic)) + '</span><div><div class="nm">' + title + '</div><div class="sub">' + sub + '</div></div><div class="pr">' + giftWas(val) + '<button type="button" class="cs-link" data-cs-addv="' + cfg.variant + '" data-cs-gift data-title="' + esc(title) + '" aria-label="Add ' + title + ' back, free">Add it back</button></div></div>'; }
    if (cm && s.charms >= 5 && !s.cotm && flag('cs_cotm_no') === '1') gh += backRow(cm, cm.image, 'gift', 'This month\'s charm' + (cm.name ? ': ' + esc(cm.name) : ''), 'Free with your 5 charms', cm.value ? money(cm.value) : '');
    if (gt && s.bracelets && !s.tools && flag('cs_tool_no') === '1') gh += backRow(gt, null, 'tool', 'Charm tool', 'Free with your bracelet', gt.value ? money(gt.value) : '');
    if (PH && !s.photoFree && !s.photoPaid && s.base >= PH.need) gh += '<div class="cs-line cs-reward cs-gift" data-a="phm"><span class="th">' + (PH.image ? '<img src="' + esc(PH.image) + '" alt="" loading="lazy">' : icon('gift')) + '</span><div><div class="nm">Photo charm</div><div class="sub">Free with your ' + PH.need + ' charms · your photo or words</div></div><div class="pr">' + giftWas(money(PH.price)) + '<a class="cs-link" href="' + esc(PH.url) + '" data-ccz-open>Make it</a></div></div>';
    if (s.ship) gh += giftRow({ ic: 'gift', title: 'Surprise charm', sub: 'We pick one for every order' });
    var ghId = 'csGh' + (body.id || 'B');
    if (gh) h += '<div class="cs-gbox" data-a="gbox" role="group" aria-labelledby="' + ghId + '"><p class="hd" id="' + ghId + '">Free with your order</p>' + gh + '</div>';
    if (lk) h += '<div class="cs-gbox lock" data-a="lbox" role="group" aria-labelledby="' + ghId + 'L"><p class="hd" id="' + ghId + 'L">Unlock next</p>' + lk + '</div>';
    h += '</div>' + heartsRow(c);
    h += '<details class="cs-note" data-a="note"' + (c.note ? ' open' : '') + '><summary>' + icon('gift') + (c.note ? 'Your gift note' : 'Add a gift note') + '</summary><label class="sr" for="csNote' + (body.id || 'B') + '">Gift note</label><textarea id="csNote' + (body.id || 'B') + '" data-cs-note maxlength="300" rows="3" placeholder="Happy birthday, Mia! Love, Sam">' + esc(c.note || '') + '</textarea><small>It goes with your order. Saved as you type.</small></details>';
    if (s.charms) h += '<div class="cs-savebag" data-a="svb"><button type="button" class="cs-link" data-cs-savebag>' + icon('heart') + 'Save ' + (s.lines.charm.length === 1 ? 'this charm' : 'all ' + s.lines.charm.length + ' designs') + ' to your hearts</button></div>';
    h += '<div class="cs-clearrow" data-cs-clearrow data-a="clr"><button type="button" class="cs-link" data-cs-clear>Start over</button>' +
      '<span class="confirm" hidden><span>Remove everything from your bag?</span><button type="button" class="cs-btn ghost auto" data-cs-clear-yes>Yes, clear it</button><button type="button" class="cs-link" data-cs-clear-no>Keep it</button></span></div>';
    body.innerHTML = h;
    if (body.id === 'csBagBody') edgeBtns(document.getElementById('csBag'), n >= 30);
    paintInBag(body);
    fitRows(body); // before the anchor is restored, so the bracelet pictures do not resize after paint
    requestAnimationFrame(function () { var a = anchorTake(body); fitRows(body); anchorPut(a); });
    var ship = shipping(c, s), total = c.total_price + ship;
    // one short line instead of a row per item; the total sits on the button
    var otherTotal = s.lines.other.reduce(function (a, it) { return a + it.final_line_price; }, 0), paid = [], free = [];
    var pl = function (n, w) { return n > 1 ? n + ' ' + w + 's' : w; };
    // the open footer lists one line per item: label left, amount right
    var rows = [], FREE = '<span class="fr">Free</span>', cap1 = function (t) { return t.charAt(0).toUpperCase() + t.slice(1); };
    var row = function (l, v, cls) { rows.push('<div class="r' + (cls ? ' ' + cls : '') + '"><dt>' + l + '</dt><dd>' + v + '</dd></div>'); };
    paid.push('Charms ' + money(s.charmsTotal)); row('Charms', money(s.charmsTotal));
    var brFreeQ = s.lines.bracelet.reduce(function (a, it) { return a + (it.final_line_price === 0 ? it.quantity : 0); }, 0), brPaidQ = s.bracelets - brFreeQ;
    if (brFreeQ) { free.push(pl(brFreeQ, 'bracelet')); row(cap1(pl(brFreeQ, 'bracelet')), FREE); }
    if (brPaidQ) { paid.push(pl(brPaidQ, 'bracelet').replace(/^b/, 'B') + ' ' + money(s.braceletTotal)); row(cap1(pl(brPaidQ, 'bracelet')), money(s.braceletTotal)); }
    if (s.tools) { if (s.toolTotal === 0) { free.push(pl(s.tools, 'tool')); row(s.tools > 1 ? s.tools + ' charm tools' : 'Charm tool', FREE); } else { paid.push(pl(s.tools, 'tool').replace(/^t/, 'T') + ' ' + money(s.toolTotal)); row(s.tools > 1 ? s.tools + ' charm tools' : 'Charm tool', money(s.toolTotal)); } }
    if (s.cotm) { free.push('this month\'s charm'); row('This month\'s charm', FREE); }
    var gcTotal = s.lines.other.reduce(function (a, it) { return a + (it.gift_card ? it.final_line_price : 0); }, 0);
    if (gcTotal) { paid.push('Gift card ' + money(gcTotal)); row('Gift card', money(gcTotal)); }
    if (otherTotal - gcTotal) { paid.push('Other ' + money(otherTotal - gcTotal)); row('Other items', money(otherTotal - gcTotal)); }
    if (s.protTotal) { paid.push('Protection ' + money(s.protTotal)); row('Shipping protection', money(s.protTotal)); }
    if (c.cart_level_discount_applications && c.cart_level_discount_applications.length) c.cart_level_discount_applications.forEach(function (d) { paid.push(esc(d.title) + ' −' + money(d.total_allocated_amount)); row(esc(d.title), '−' + money(d.total_allocated_amount), 'dc'); });
    if (ship === 0) { free.push('shipping'); row('Shipping', FREE); } else { paid.push('Shipping ' + money(ship)); row('Shipping', money(ship)); }
    var fp = free.length ? (free.length > 1 ? free.slice(0, -1).join(', ') + ' and ' + free[free.length - 1] : free[0]) + ' free' : '';
    if (fp && paid.length === 1) fp = fp.charAt(0).toUpperCase() + fp.slice(1); // the button already shows the charms total
    var bits = (paid.length === 1 && fp ? [] : paid).concat(fp ? ['<span class="free">' + fp + '</span>'] : []);
    var cr = 0, cb = '', nr = rows.length;
    // the same savings checkout shows: Shopify's own discounts on this bag, nothing estimated
    var saved = c.total_discount || 0;
    if (saved > 0) row('You\'re saving', money(saved), 'sv');
    if (CFG.credit) {
      // the same sum Koin pays once the order ships: rate % of the order, rounded to the cent, capped per order (gift cards earn nothing)
      var K = CFG.credit, cap = Math.round((K.cap || 5) * 100 * (CS.ratio || 1));
      cr = Math.min(Math.round(Math.max(0, s.sub) * (K.rate || 2) / 100), cap);
      if (cr > 0) row('Store credit back<em>' + esc(String(K.rate)) + '%</em>', '+' + money(cr) + ' next time', 'cr cs-credit');
      if (K.bal > 0) cb = '<p class="cs-credbal">You have <b>' + money(K.bal) + '</b> in credit. It comes off at checkout.</p>';
      else if (!K.in && K.login) cb = '<p class="cs-credbal">Have store credit? <a href="' + esc(K.login) + '">Sign in</a> to use it.</p>';
    }
    if (rows.length > nr) rows[nr] = rows[nr].replace('<div class="r', '<div class="r top');
    var f = '<dl class="cs-frows">' + rows.join('') + '</dl>' + cb;
    f += protRow(c, s, foot.id);
    var rv = CFG.rating && CFG.reviews ? '<span class="cs-stars" aria-hidden="true">' + [1, 2, 3, 4, 5].map(function () { return icon('star'); }).join('') + '</span><span><b>' + esc(CFG.rating) + '</b> from ' + esc(CFG.reviews) + ' reviews</span>' : '';
    if (rv || CFG.note) f += '<p class="cs-fnote">' + (rv ? '<span class="rv">' + rv + '</span>' : '') + (CFG.note ? '<span>' + esc(CFG.note) + '</span>' : '') + '</p>';
    // folded by default: one line (credit back, savings) with an arrow; the arrow opens the rest above the checkout button
    var sum = [];
    if (cr > 0) sum.push('<em class="cr">+' + money(cr) + ' store credit</em>');
    if (saved > 0) sum.push('<span class="sv">You save <b>' + money(saved) + '</b></span>');
    if (!sum.length) sum.push('<span>' + bits.join('<i> · </i>') + '</span>');
    var fid = foot.id + 'X', fo = !!FOLD[foot.id];
    f = '<button type="button" class="cs-fold" data-cs-fold aria-expanded="' + fo + '" aria-controls="' + fid + '"><span class="s">' + sum.join('') + '</span><span class="m">' + (fo ? 'Less' : 'Details') + icon('up') + '</span></button>' +
      '<div class="cs-fx" id="' + fid + '"' + (fo ? '' : ' hidden') + '><div class="cs-fxi">' + f + '</div></div>';
    f += '<form action="' + esc(route('cart')) + '" method="post"><button type="submit" name="checkout" class="cs-btn">Checkout · ' + money(total) + '</button></form>';
    var ae = document.activeElement, pf = !!(ae && ae.hasAttribute && ae.hasAttribute('data-cs-prot') && foot.contains(ae));
    foot.innerHTML = f; foot.hidden = false; foot.classList.toggle('pbusy', PROT.busy);
    var fdr = foot.closest('.cs-drawer'); if (fdr) { foot.classList.toggle('open', fo); fdr.classList.toggle('fopen', fo); }
    if (pf) { var nb = foot.querySelector('[data-cs-prot]'); if (nb) { try { nb.focus({ preventScroll: true }); } catch (e) {} } }
  }
  CS.renderBag = renderBag;
  var FOLD = { csCartFoot: true }; // the cart page has room: open there
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cs-fold]'); if (!b) return;
    var foot = b.closest('.cs-bagfoot'), x = foot && document.getElementById(b.getAttribute('aria-controls')); if (!x) return;
    foldSet(foot, b, x, b.getAttribute('aria-expanded') !== 'true');
  });
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  function foldSet(foot, b, x, open) {
    FOLD[foot.id] = open;
    b.setAttribute('aria-expanded', open); b.querySelector('.m').firstChild.nodeValue = open ? 'Less' : 'Details';
    var dr = foot.closest('.cs-drawer');
    if (dr) { foot.classList.toggle('open', open); dr.classList.toggle('fopen', open); }
    if (x._anim) { x._anim.cancel(); x._anim = null; }
    var still = !x.animate || (RM && RM.matches);
    if (open) {
      x.hidden = false;
      if (!still) { var h = x.offsetHeight, cs = getComputedStyle(x); x.style.overflow = 'hidden'; x._anim = x.animate([{ height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0, transform: 'translateY(10px)' }, { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, opacity: 1, transform: 'none' }], { duration: 300, easing: 'cubic-bezier(.22,.8,.24,1)' }); x._anim.onfinish = x._anim.oncancel = function () { x.style.overflow = ''; x._anim = null; }; }
    } else if (still) x.hidden = true;
    else { var h0 = x.offsetHeight, cs0 = getComputedStyle(x); x.style.overflow = 'hidden'; x._anim = x.animate([{ height: h0 + 'px', paddingTop: cs0.paddingTop, paddingBottom: cs0.paddingBottom, opacity: 1 }, { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 }], { duration: 200, easing: 'cubic-bezier(.4,0,1,1)' }); x._anim.onfinish = function () { x.hidden = true; x.style.overflow = ''; x._anim = null; }; x._anim.oncancel = function () { x.style.overflow = ''; }; }
    var eb = dr && dr.querySelector('.cs-edge'); if (eb && eb._paint) eb._paint();
  }
  // a tap on the faded list closes the details again
  document.addEventListener('click', function (e) {
    var dr = e.target === document.getElementById('csBag') && e.target.classList.contains('fopen') ? e.target : null; if (!dr) return;
    var foot = dr.querySelector('.cs-bagfoot'), b = foot && foot.querySelector('[data-cs-fold]'), x = b && document.getElementById(b.getAttribute('aria-controls'));
    if (x) foldSet(foot, b, x, false);
  });
  function clearBag() {
    if (busy || !cart) return Promise.resolve(); busy = true;
    var snap = (cart.items || []).map(function (it) { var o = { id: it.variant_id, quantity: it.quantity }; if (it.properties && Object.keys(it.properties).length) o.properties = it.properties; return o; });
    // the builder's bracelets were made for this bag: they go with it, and come back with Undo
    var BK = ['csb_state', 'csb_snap'], keep = {};
    function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
    BK.forEach(function (k) { keep[k] = lsGet(k); });
    return api(route('clear', '.js'), {}).then(function () { resetGiftFlags(); if (!window.CSB) BK.forEach(function (k) { lsSet(k, null); }); busy = false; return loadCart(); }).then(function (c) {
      toast('Your bag is empty again.', { label: 'Undo', fn: function () { if (busy) return; busy = true; api(route('add', '.js'), { items: snap }).then(function () { if (!window.CSB) BK.forEach(function (k) { lsSet(k, keep[k]); }); busy = false; return loadCart(); }).then(function () { toast('Everything is back.'); }).catch(function () { busy = false; toast('Could not bring it back. Please add the charms again.'); }); } });
      return c;
    }).catch(function (e) { busy = false; toast(esc(e.message || 'Could not clear the bag')); });
  }
  CS.clearBag = clearBag;
  function heartsRow(c) {
    var have = {}; (c.items || []).forEach(function (it) { have[it.variant_id] = 1; have[it.handle] = 1; });
    var list = readHearts().filter(function (x) { return x.v ? !have[x.v] : !have[x.h]; }).slice(0, 3);
    if (!list.length) return '';
    return '<div class="cs-bhearts" data-a="hearts"><div class="hd"><span>From your hearts</span><button type="button" class="cs-link" data-cs-open="csHeartsD">See all ' + readHearts().length + '</button></div><div class="cs-grid cs-hgrid">' +
      list.map(heartCard).join('') + '</div></div>';
  }

  /* ---------- bottom dock (progress + review bag) ---------- */
  function paintDock(c, s) {
    var d = document.getElementById('csDock'); if (!d) return;
    if (!s.charms || document.body.hasAttribute('data-cs-nodock')) { d.hidden = true; document.body.classList.remove('cs-hasdock'); return; }
    // the bag total before shipping, so it reads the same as the charms the shopper picked
    d.querySelector('[data-cs-dock-sum]').textContent = s.charms + ' charm' + (s.charms === 1 ? '' : 's') + ' · ' + money(c.total_price);
    d.querySelector('[data-cs-dock-next]').textContent = shortNext(s) + (s.charms >= 10 && !s.freeShip ? ' · ' + money(s.shipNeed) + ' to free shipping' : '');
    d.querySelector('[data-cs-dock-bar]').style.width = pct(s.charms).toFixed(1) + '%';
    // store credit: what this order pays back, and what the shopper already has to spend (signed in)
    var dcr = d.querySelector('[data-cs-dock-cr]');
    if (dcr) {
      var K = CFG.credit, h = '';
      if (K) {
        var earn = Math.min(Math.round(Math.max(0, s.sub) * (K.rate || 2) / 100), Math.round((K.cap || 5) * 100 * (CS.ratio || 1)));
        if (earn > 0) h += '<em>+' + money(earn) + ' credit</em>';
        if (K.bal > 0) h += '<em class="wal">' + money(K.bal) + ' to use</em>';
      }
      dcr.innerHTML = h; dcr.hidden = !h;
    }
    d.hidden = false; document.body.classList.add('cs-hasdock');
  }

  /* ---------- show more (collection grids) ---------- */
  function showMore(btn) {
    var url = btn.getAttribute('data-cs-more'), sec = btn.getAttribute('data-section'), grid = document.getElementById(btn.getAttribute('aria-controls'));
    if (!url || !grid) return;
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'Loading…';
    fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(sec)).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var ng = doc.getElementById(grid.id), nb = doc.querySelector('[data-cs-more]'), nc = doc.querySelector('[data-cs-shown]');
      if (ng) $$(':scope > *', ng).forEach(function (el) { grid.appendChild(el); });
      if (nb) { btn.setAttribute('data-cs-more', nb.getAttribute('data-cs-more')); btn.disabled = false; btn.textContent = old; }
      else btn.parentNode.removeChild(btn);
      var cc = document.querySelector('[data-cs-shown]'); if (cc && nc) cc.textContent = nc.textContent;
      imgsIn(grid);
      paintHearts(); paintInBag();
    }).catch(function () { btn.disabled = false; btn.textContent = old; toast('Could not load more. Please try again.'); });
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    // a card with several designs: tapping its picture or name shows the designs (as the builder does), not the product page
    var cl = e.target.closest && e.target.closest('.cs-card a.pic,.cs-card a.n');
    if (cl && !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      var cc = cl.closest('.cs-card'), dn = Number(cc.getAttribute('data-designs') || 0), cv = cc && cc.getAttribute('data-v');
      if (cc && document.getElementById('csVarG') && cc.getAttribute('data-h')) {
        if (!cv && dn > 1) { e.preventDefault(); openPicker(cc.getAttribute('data-h'), cc.getAttribute('data-title'), cc.getAttribute('data-metal'), false, vidsOf(cc)); return; }
        if (cv && cl.classList.contains('pic')) { e.preventDefault(); openPicker(cc.getAttribute('data-h'), cc.getAttribute('data-title'), '', false, [cv]); return; }
      }
    }
    var t = e.target.closest('[data-cs-open],[data-cs-close],[data-cs-heart],[data-cs-add],[data-cs-addv],[data-cs-pick],[data-cs-q],[data-cs-more],[data-cs-clear],[data-cs-clear-yes],[data-cs-clear-no],[data-cs-prot],[data-cs-savebag]');
    if (!t) return;
    if (t.hasAttribute('data-cs-prot')) { e.preventDefault(); protToggle(); return; }
    if (t.hasAttribute('data-cs-clear') || t.hasAttribute('data-cs-clear-no')) { e.preventDefault(); var row = t.closest('[data-cs-clearrow]'); if (row) { var ask = t.hasAttribute('data-cs-clear'); row.querySelector('[data-cs-clear]').hidden = ask; row.querySelector('.confirm').hidden = !ask; if (ask) { row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); row.querySelector('[data-cs-clear-yes]').focus({ preventScroll: true }); } } return; }
    if (t.hasAttribute('data-cs-clear-yes')) { e.preventDefault(); t.disabled = true; clearBag(); return; }
    if (t.hasAttribute('data-cs-savebag')) {
      e.preventDefault(); var hl = readHearts(), have = {}, add = 0; hl.forEach(function (x) { have[x.k] = 1; });
      (cart && cart.items || []).forEach(function (it) {
        if (kind(it) !== 'charm') return; var k = it.product_has_only_default_variant ? it.handle : it.handle + ':' + it.variant_id; if (have[k]) return; have[k] = 1;
        hl.unshift({ k: k, h: it.handle, v: it.product_has_only_default_variant ? null : it.variant_id, t: it.product_has_only_default_variant ? it.product_title : it.variant_title, p: it.price, i: it.image ? imgUrl(it.image, 300) : '', at: Date.now() - (add++), m: MKT, n: 1 });
      });
      writeHearts(hl); fillImages();
      toast(add ? icon('heart') + 'Saved ' + (add === 1 ? '1 design' : add + ' designs') + ' to your hearts.' : 'They are all in your hearts already.', { label: 'See them', fn: function () { openPanel('csHeartsD'); } });
      return;
    }
    if (t.hasAttribute('data-cs-open')) {
      e.preventDefault();
      var id = t.getAttribute('data-cs-open');
      openPanel(id, t.hasAttribute('data-cs-menu-cats') ? { scrollTo: 'csMenuCats' } : null);
      return;
    }
    if (t.hasAttribute('data-cs-close')) { if (t.id === 'csScrim' || t.closest('.cs-drawer,.cs-sheet') || t.hasAttribute('data-cs-close')) { e.preventDefault(); closePanel(); } return; }
    if (t.hasAttribute('data-cs-heart')) { e.preventDefault(); toggleHeart(t); return; }
    if (t.hasAttribute('data-cs-add') || t.hasAttribute('data-cs-addv')) {
      e.preventDefault(); if (t.disabled) return;
      var vid = Number(t.getAttribute('data-cs-add') || t.getAttribute('data-cs-addv'));
      // free add-ons (the pouch): one per order; more would only push the item count toward free shipping
      var freeOne = (cart && cart.items || []).filter(function (it) { return it.variant_id === vid && kind(it) === 'other' && it.price === 0; })[0];
      if (freeOne) { toast('One ' + esc(freeOne.product_title || 'of these') + ' per order. It is already in your bag.'); return; }
      // gift card page: check the "email it to a friend" fields first; errors show under the fields
      var gcp = null;
      if (gcHook && (t.hasAttribute('data-cs-buy') || t.hasAttribute('data-cs-buy2')) && t.closest('[data-cs-pdp]')) { gcp = gcHook(); if (!gcp) return; }
      var fromSheet = t.closest('#csVar');
      t.classList.remove('cs-beat'); void t.offsetWidth; t.classList.add('cs-beat');
      if (!t.closest('.cs-drawer,.cs-sheet')) {
        var card = t.closest('.cs-card'), pimg = card ? card.querySelector('.pic img') : (t.closest('[data-cs-pdp]') ? document.querySelector('[data-cs-pdp] .cs-gal img') : null);
        flyToBag(pimg);
      }
      var items = [{ id: vid, quantity: 1 }];
      if (t.hasAttribute('data-cs-withtool') || t.hasAttribute('data-cs-gift')) items[0].properties = { _gift: '1' };
      else {
        // what is being added, so the badge can show before the bag answers
        var hc = t.closest('.cs-card'), pdp = t.closest('[data-cs-pdp]'), pinfo = pdp && pdp.querySelector('[data-cs-item][data-price]');
        items[0].h = t.getAttribute('data-h') || (hc && hc.getAttribute('data-h')) || (pdp && pdp.getAttribute('data-handle')) || '';
        items[0].price = t.getAttribute('data-price') || (hc && hc.getAttribute('data-price')) || (pinfo && pinfo.getAttribute('data-price')) || 0;
      }
      // a bracelet from "Make it a pair" is a second bracelet: the free one stays (giftFix, the builder)
      if (t.hasAttribute('data-cs-pair')) items[0].properties = { _pair: '1' };
      // a gift card is not a charm: no early badge; recipient properties only when the box is checked
      if (gcp) { if (gcp.props) items[0].properties = gcp.props; delete items[0].h; delete items[0].price; }
      // the shopper asked for this gift: the builder must not take it out again because of an earlier 'no'
      if (t.hasAttribute('data-cs-withtool') || t.hasAttribute('data-cs-gift')) { flag('csb_br_no', null); if (CFG.giftTool && vid === CFG.giftTool.variant) flag('cs_tool_no', null); if (CFG.cotm && vid === CFG.cotm.variant) flag('cs_cotm_no', null); }
      function sheetMark() {
        var b = t.querySelector('.cs-vpic'), v0 = view(); if (!b || !v0) return;
        var q = 0; v0.items.forEach(function (it) { if (it.variant_id === vid) q += it.quantity; });
        var em = b.querySelector('em');
        if (!q) { if (em) b.removeChild(em); return; }
        if (!em) { em = document.createElement('em'); b.appendChild(em); }
        em.innerHTML = icon('check') + q;
      }
      // a bracelet picked in the bag: show it in the bag at once ("Adding…") while the bag answers (that takes a second or two)
      var mp = t.closest('.cs-metals'), ghost = null;
      if (mp && !mp.classList.contains('busy')) {
        mp.classList.add('busy'); t.classList.add('adding');
        var lines = document.querySelector('#csBag .cs-lines'), im = t.querySelector('img');
        if (lines) {
          ghost = document.createElement('div'); ghost.className = 'cs-line cs-ghost'; ghost.setAttribute('aria-live', 'polite');
          ghost.innerHTML = '<span class="th">' + (im ? '<img src="' + esc(im.getAttribute('src')) + '" alt="">' : '') + '</span><div><div class="nm">' + esc(t.getAttribute('data-title') || 'Bracelet') + '</div><div class="sub">Adding to your bag…</div></div>';
          lines.insertBefore(ghost, lines.firstChild);
        }
      }
      var undoGhost = function () { if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost); if (mp) { mp.classList.remove('busy'); t.classList.remove('adding'); } };
      addItems(items, t.getAttribute('data-title'), function (er) { undoGhost(); if (gcp && gcp.fail) gcp.fail(er); }).then(function () { if (fromSheet) sheetMark(); });
      if (fromSheet) sheetMark();
      return;
    }
    if (t.hasAttribute('data-cs-pick')) { e.preventDefault(); openPicker(t.getAttribute('data-cs-pick'), t.getAttribute('data-title'), t.getAttribute('data-metal'), false, vidsOf(t)); return; }
    if (t.hasAttribute('data-cs-q')) {
      e.preventDefault(); if (t.disabled) return;
      var dq = Number(t.getAttribute('data-d') || 0), qk = t.getAttribute('data-cs-q'), qn = Math.max(0, Number(t.getAttribute('data-n')) || 0);
      if (dq) {
        // − on a line that shows 1: the line leaves (animated) instead of sitting at 0
        var ql = findLine(qk);
        if (dq < 0 && ql && ql.key === qk && ql.quantity + (qPend[qk] || 0) + dq <= 0) removeLine(qk, null, dq, t);
        else changeLine(qk, null, dq);
      } else { t.disabled = true; if (qn === 0) removeLine(qk, 0, 0, t); else changeLine(qk, qn); }
      return;
    }
    if (t.hasAttribute('data-cs-more')) { e.preventDefault(); showMore(t); return; }
  });

  var noteT = null;
  document.addEventListener('input', function (e) {
    var ta = e.target.closest && e.target.closest('[data-cs-note]'); if (!ta) return;
    clearTimeout(noteT); noteT = setTimeout(function () { api(route('update', '.js'), { note: ta.value.slice(0, 300) }).then(function (c2) { if (cart) cart.note = c2.note; }).catch(function () {}); }, 600);
  });

  /* ---------- rails: keep the current tile in view; fade the edge ---------- */
  // same math as the inline script in cs-rail.liquid, so the fallback never moves an already centred rail
  function centerRail(r) {
    var c = r.querySelector('[aria-current="true"]'), a = r.getBoundingClientRect(); if (!c || !a.width) return false;
    var b = c.getBoundingClientRect(); r.scrollLeft = Math.max(0, r.scrollLeft + b.left - a.left - (a.width - b.width) / 2);
    return true;
  }
  CS.centerRail = centerRail;
  function initRails() {
    $$('[data-cs-rail]').forEach(function (r) {
      if (r.hasAttribute('data-cs-centered')) return;
      if (centerRail(r)) r.setAttribute('data-cs-centered', '');
    });
  }

  /* ---------- images fade in when loaded (layout/cs.liquid listens from <head>; this is the fallback + the pass for cached ones) ---------- */
  function imgDone(e) { var t = e.target; if (t && t.tagName === 'IMG' && !t.classList.contains('cs-imgin')) t.classList.add('cs-imgin'); }
  document.addEventListener('load', imgDone, true); document.addEventListener('error', imgDone, true);
  function showImgs(root) { imgsIn(root); setTimeout(function () { $$('.cs-card .pic img', root).forEach(function (im) { im.classList.add('cs-imgin'); }); }, 2500); }
  function imgsIn(root) { $$('.cs-card .pic img,.cs-tile i img', root).forEach(function (im) { if (im.complete) im.classList.add('cs-imgin'); }); }
  CS.imgsIn = imgsIn; CS.fadeImgs = imgsIn;
  document.addEventListener('cs:swap', function (e) { imgsIn(e.detail && e.detail.root || document); });

  /* ---------- header: mega menu on desktop ---------- */
  function initMega() {
    var a = $('[data-cs-mega]'); if (!a) return;
    var wrap = a.parentNode, timer;
    function set(on) { wrap.classList.toggle('open', on); a.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    wrap.addEventListener('mouseenter', function () { clearTimeout(timer); set(true); });
    wrap.addEventListener('mouseleave', function () { timer = setTimeout(function () { set(false); }, 160); });
    wrap.addEventListener('focusin', function () { set(true); });
    wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) set(false); });
  }

  /* ---------- sticky bars under the header (collection rail) ---------- */
  function initSticky() {
    var head = document.getElementById('csHead');
    function setH() { if (head) document.documentElement.style.setProperty('--cs-head', head.getBoundingClientRect().height + 'px'); }
    setH(); window.addEventListener('resize', setH);
    var stick = $('[data-cs-stick]');
    if (stick && 'IntersectionObserver' in window) {
      var sent = document.createElement('div'); sent.style.height = '1px'; stick.parentNode.insertBefore(sent, stick);
      new IntersectionObserver(function (en) { stick.classList.toggle('stuck', !en[0].isIntersecting); }, { rootMargin: '-' + Math.round((head ? head.getBoundingClientRect().height : 52) + 1) + 'px 0px 0px 0px' }).observe(sent);
    }
    var top = document.getElementById('csTop');
    if (top) {
      var on = false;
      window.addEventListener('scroll', function () { var v = window.pageYOffset > 900; if (v !== on) { on = v; top.classList.toggle('on', v); } }, { passive: true });
      top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
  }

  /* ---------- charm page ---------- */
  function initPdp() {
    var root = $('[data-cs-pdp]'); if (!root) return;
    document.body.setAttribute('data-cs-nodock', ''); document.body.classList.add('cs-pdp');
    var vs = []; try { vs = JSON.parse($('[data-cs-variants]', root).textContent); } catch (e) {}
    var handle = root.getAttribute('data-handle'), multi = !!$('[data-cs-var]', root), cur = null;
    var info = $('.cs-pdp-info', root);
    var curId = Number(info.getAttribute('data-v'));
    vs.forEach(function (v) { if (v.id === curId) cur = v; });
    function select(v, push) {
      cur = v;
      $$('[data-cs-var]', root).forEach(function (b) { b.setAttribute('aria-checked', Number(b.getAttribute('data-cs-var')) === v.id ? 'true' : 'false'); });
      var img = $('.cs-gal img', root);
      if (img && v.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = v.img.replace(/^\/\//, 'https://'); img.alt = v.title; }
      var bt = $('.cs-pbar img', root); if (bt && v.thumb) { bt.removeAttribute('srcset'); bt.src = v.thumb.replace(/^\/\//, 'https://'); }
      $$('[data-cs-name],[data-cs-bname],[data-cs-dname]', root).forEach(function (n) { n.textContent = v.title; });
      $$('[data-cs-price],[data-cs-bprice]', root).forEach(function (n) { n.textContent = money(v.price); });
      var cmp = $('[data-cs-compare]', root); if (cmp) cmp.hidden = true;
      var lc = $('[data-cs-lc]', root); if (lc) lc.hidden = !v.lc;
      $$('[data-cs-add]', root).forEach(function (b) { b.setAttribute('data-cs-add', v.id); b.setAttribute('data-title', v.title); b.disabled = !v.available; });
      var buy = $('[data-cs-buy]', root); if (buy) buy.textContent = v.available ? 'Add to bag · ' + money(v.price) : 'Sold out';
      var h = $('[data-cs-heart]', root); if (h) { h.setAttribute('data-cs-heart', handle + ':' + v.id); h.setAttribute('data-title', v.title); h.setAttribute('aria-label', 'Save ' + v.title); }
      info.setAttribute('data-v', v.id); info.setAttribute('data-title', v.title); info.setAttribute('data-price', v.price); if (v.thumb) info.setAttribute('data-img', v.thumb);
      var tr = $('[data-cs-try]', root); if (tr) tr.href = tr.href.replace(/\?add=.*$/, '') + '?add=' + encodeURIComponent(handle + ':' + v.id);
      if (push) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {} }
      paintHearts(); meter();
    }
    if (multi) root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cs-var]'); if (!b) return;
      var id = Number(b.getAttribute('data-cs-var'));
      vs.forEach(function (v) { if (v.id === id) select(v, true); });
    });
    // progress towards the free bracelet, counting this charm
    var mt = $('[data-cs-pmeter]', root);
    function meter() {
      if (!mt || !cart || !cur) return;
      var s = stats(cart), inBag = (cart.items || []).some(function (it) { return it.variant_id === cur.id; });
      var x = s.charms + (inBag ? 0 : 1), t;
      if (inBag) t = 'In your bag. You have <b>' + s.charms + ' charm' + (s.charms === 1 ? '' : 's') + '</b>. ' + shortNext(s) + '.';
      else if (x < 5) t = 'This one makes <b>' + x + ' of 5</b>. ' + (5 - x === 1 ? 'One more' : (5 - x) + ' more') + ' and this month\'s charm is free.';
      else if (x === 5) t = 'This one makes <b>5</b>. This month\'s charm is free.';
      else if (x < 10) t = 'This one makes <b>' + x + ' of 10</b>. ' + (10 - x === 1 ? 'One more' : (10 - x) + ' more') + ' and the bracelet and tool are free.';
      else if (x === 10 || x === 20 || x === 30) t = 'This one makes <b>' + x + '</b>. ' + (x === 10 ? 'The bracelet and tool are free.' : x === 20 ? 'A second bracelet is free.' : 'A third bracelet is free.');
      else if (x < 30) t = 'This one makes <b>' + x + '</b>. At ' + (x < 20 ? '20 you get a second bracelet.' : '30 you get a third bracelet.');
      else t = 'This one makes <b>' + x + '</b>. Everything is unlocked.';
      $('[data-cs-pmeter-t]', mt).innerHTML = t; $('[data-cs-pmeter-bar]', mt).innerHTML = ladder(x); mt.hidden = false;
    }
    document.addEventListener('cs:cart', meter);
    // sticky add bar once the main button scrolls away
    var bar = $('[data-cs-pbar]', root), buy = $('[data-cs-buy]', root);
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var r = en[0].boundingClientRect; var show = !en[0].isIntersecting && r.top < 0; bar.hidden = !show; document.body.classList.toggle('cs-hasbar', show); }).observe(buy);
    }
    // gallery dots
    var gal = $('[data-cs-gal]', root), dots = $$('.cs-dots i', root);
    if (gal && dots.length) gal.addEventListener('scroll', function () { var i = Math.round(gal.scrollLeft / gal.clientWidth); dots.forEach(function (d, j) { d.classList.toggle('on', j === i); }); }, { passive: true });
  }

  function initRecs() {
    $$('[data-cs-recs]').forEach(function (sec) {
      if (sec.children.length) return;
      fetch(sec.getAttribute('data-cs-recs')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), n = doc.querySelector('[data-cs-recs]');
        if (n && n.innerHTML.trim()) { sec.innerHTML = n.innerHTML; paintHearts(); paintInBag(); } else sec.hidden = true;
      }).catch(function () { sec.hidden = true; });
    });
  }

  /* ---------- saved charms page ---------- */
  var tried = {};
  /* Hearts saved in the builder (or in another country) have no picture yet: look them up 4 at a time,
     try a failed one once more, and save the results in batches so the drawer is not redrawn for every charm. */
  function fillImages() {
    var todo = readHearts().filter(function (x) { return x.h && (!(x.i && x.m === MKT) || x.mt === undefined) && (tried[x.k] || 0) < 2; });
    if (!todo.length) return;
    var done = {}, live = 0, at = 0, flushT = null;
    function flush() {
      flushT = null; if (!Object.keys(done).length) return;
      var list = readHearts(); list.forEach(function (y) { var d = done[y.k]; if (!d) return; if (d.i && !y.i) y.i = d.i; y.p = d.p || y.p; y.f = d.f; y.m = MKT; y.mt = d.mt; }); done = {}; writeHearts(list);
    }
    function soon() { if (!flushT) flushT = setTimeout(flush, live || at < todo.length ? 600 : 0); }
    function next() {
      while (live < 4 && at < todo.length) (function (x) {
        live++; tried[x.k] = (tried[x.k] || 0) + 1;
        getProduct(x.h).then(function (p) {
          var src = '', vp = 0, vt = '';
          if (x.v) p.variants.forEach(function (v) { if (v.id === Number(x.v)) { vp = v.price; vt = v.title; if (v.featured_image) src = v.featured_image.src; } });
          if (!src) src = p.featured_image || '';
          done[x.k] = { i: src ? imgUrl(src, 300) : '', p: vp || p.price || 0, f: !x.v && p.price_varies ? 1 : 0, mt: metalOf(p.tags, vt) };
        }, function (e) {
          if (e && e.message === 'Not found') tried[x.k] = 2; // gone or not sold in this country: no second try
        }).then(function () { live--; soon(); next(); });
      })(todo[at++]);
      if (!live && at >= todo.length) { flush(); if (todo.some(function (x) { return tried[x.k] < 2 && !done[x.k]; })) setTimeout(fillImages, 4000); }
    }
    next();
  }
  function metalOf(tags, vt) {
    var tg = (tags || []).map(function (t) { return String(t).toLowerCase(); }), g = tg.indexOf('gold') >= 0 || tg.indexOf('gold charms') >= 0, sv = tg.indexOf('silver charms') >= 0 || tg.indexOf('silver') >= 0;
    if (g && sv && vt) { var vg = hasMetal(vt, 'gold'), vs = hasMetal(vt, 'silver'); if (vg && !vs) return 'g'; if (vs && !vg) return 's'; }
    return (g ? 'g' : '') + (sv ? 's' : '');
  }
  /* ---------- hearts tools: metal filter, sort, pick several to remove, clear all (drawer and saved page) ---------- */
  var HS = { f: 'all', s: 'new', sel: null, ask: false };
  try { var hs0 = JSON.parse(localStorage.getItem('cs_hs') || 'null'); if (hs0) { HS.f = hs0.f || 'all'; HS.s = hs0.s || 'new'; } } catch (e) {}
  function hsSave() { try { localStorage.setItem('cs_hs', JSON.stringify({ f: HS.f, s: HS.s })); } catch (e) {} }
  var HSORT = [['new', 'Newest'], ['old', 'Oldest'], ['lo', 'Price: low to high'], ['hi', 'Price: high to low'], ['az', 'Name: A to Z']];
  function heartsView(list) {
    var f = HS.f, out = list.filter(function (x) { if (f === 'all') return true; return String(x.mt || '').indexOf(f === 'gold' ? 'g' : 's') >= 0; });
    var by = { new: function (a, b) { return (b.at || 0) - (a.at || 0); }, old: function (a, b) { return (a.at || 0) - (b.at || 0); }, lo: function (a, b) { return (a.p || 0) - (b.p || 0) || (b.at || 0) - (a.at || 0); }, hi: function (a, b) { return (b.p || 0) - (a.p || 0) || (b.at || 0) - (a.at || 0); }, az: function (a, b) { return String(a.t || '').localeCompare(String(b.t || '')); } }[HS.s];
    return by ? out.slice().sort(by) : out;
  }
  function heartsTools(box, list, shown) {
    if (!box) return;
    box.hidden = !list.length; if (!list.length) { box.innerHTML = ''; HS.sel = null; HS.ask = false; return; }
    var ng = 0, ns = 0; list.forEach(function (x) { var m = String(x.mt || ''); if (m.indexOf('g') >= 0) ng++; if (m.indexOf('s') >= 0) ns++; });
    var chip = function (k, l, n) { return '<button type="button" class="cs-hchip" data-hf="' + k + '" aria-pressed="' + (HS.f === k) + '">' + l + ' <small>' + n + '</small></button>'; };
    var h = '<div class="r1"><div class="cs-hchips" role="group" aria-label="Show">' + chip('all', 'All', list.length) + chip('gold', 'Gold', ng) + chip('silver', 'Silver', ns) + '</div>' +
      '<label class="cs-hsort"><span class="sr">Sort your hearts</span>' + icon('sort') + '<select data-hs>' + HSORT.map(function (o) { return '<option value="' + o[0] + '"' + (HS.s === o[0] ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select></label></div>';
    if (HS.sel) {
      var n = shown.filter(function (x) { return HS.sel[x.k]; }).length;
      h += '<div class="r2 on"><span class="cnt"><b>' + n + '</b> picked</span><button type="button" class="cs-link" data-hselall>' + (n && n === shown.length ? 'Pick none' : 'Pick all ' + shown.length) + '</button><span class="sp"></span><button type="button" class="cs-btn ghost auto small" data-hrm' + (n ? '' : ' disabled') + '>Remove' + (n ? ' ' + n : '') + '</button><button type="button" class="cs-link" data-hsel>Done</button></div>';
    } else if (HS.ask) {
      h += '<div class="r2 on"><span class="cnt">Remove all ' + list.length + ' hearts?</span><span class="sp"></span><button type="button" class="cs-btn ghost auto small" data-hclear-yes>Yes, remove all</button><button type="button" class="cs-link" data-hclear-no>Keep them</button></div>';
    } else {
      h += '<div class="r2"><button type="button" class="cs-link" data-hsel>Select to remove</button><span class="sp"></span><button type="button" class="cs-link" data-hclear>Clear all</button></div>';
    }
    box.innerHTML = h;
  }
  // in pick mode every card gets a tap target on top: a tap picks or un-picks it instead of opening it
  function heartsPickMarks(grid) {
    $$('.cs-hpick', grid).forEach(function (b) { b.parentNode.removeChild(b); });
    if (!HS.sel) { grid.classList.remove('cs-picking'); return; }
    grid.classList.add('cs-picking');
    $$('.cs-card[data-cs-item]', grid).forEach(function (c) {
      var k = c.getAttribute('data-k'); if (!k) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'cs-hpick'; b.setAttribute('data-hpick', k);
      b.setAttribute('aria-pressed', HS.sel[k] ? 'true' : 'false'); b.setAttribute('aria-label', 'Pick ' + (c.getAttribute('data-title') || ''));
      b.innerHTML = '<i>' + icon('check') + '</i>'; c.appendChild(b);
    });
  }
  var savedDraw = null;
  function redrawHearts() { drawHeartsDrawer(); if (savedDraw) savedDraw(); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-hf],[data-hsel],[data-hselall],[data-hrm],[data-hclear],[data-hclear-yes],[data-hclear-no],[data-hpick]'); if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-hf')) { HS.f = t.getAttribute('data-hf'); hsSave(); redrawHearts(); return; }
    if (t.hasAttribute('data-hsel')) { HS.sel = HS.sel ? null : {}; HS.ask = false; redrawHearts(); return; }
    if (t.hasAttribute('data-hclear')) { HS.ask = true; HS.sel = null; redrawHearts(); return; }
    if (t.hasAttribute('data-hclear-no')) { HS.ask = false; redrawHearts(); return; }
    if (t.hasAttribute('data-hpick')) {
      var k = t.getAttribute('data-hpick'); if (!HS.sel) return;
      if (HS.sel[k]) delete HS.sel[k]; else HS.sel[k] = 1;
      $$('[data-hpick]').forEach(function (b) { if (b.getAttribute('data-hpick') === k) b.setAttribute('aria-pressed', HS.sel[k] ? 'true' : 'false'); });
      var shown = heartsView(readHearts()); $$('[data-cs-htools]').forEach(function (box) { heartsTools(box, readHearts(), shown); });
      return;
    }
    if (t.hasAttribute('data-hselall')) {
      var sh = heartsView(readHearts()), all = sh.length && sh.every(function (x) { return HS.sel && HS.sel[x.k]; });
      HS.sel = {}; if (!all) sh.forEach(function (x) { HS.sel[x.k] = 1; }); redrawHearts(); return;
    }
    if (t.hasAttribute('data-hrm') || t.hasAttribute('data-hclear-yes')) {
      var before = readHearts(), drop = t.hasAttribute('data-hclear-yes') ? null : HS.sel || {};
      var keep = drop ? before.filter(function (x) { return !drop[x.k]; }) : [], n = before.length - keep.length;
      HS.sel = null; HS.ask = false;
      if (!n) { redrawHearts(); return; }
      writeHearts(keep);
      toast(n === 1 ? 'Removed 1 heart.' : 'Removed ' + n + ' hearts.', { label: 'Undo', fn: function () { writeHearts(before); } });
    }
  });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-hs]'); if (!sel) return;
    HS.s = sel.value; hsSave(); redrawHearts();
  });
  function heartCard(x, n) {
    var url = (CS.routes && CS.routes.products || '/products/') + encodeURIComponent(x.h) + (x.v ? '?variant=' + x.v : '');
    var add = x.v ? 'data-cs-add="' + x.v + '"' : 'data-cs-pick="' + esc(x.h) + '"';
    return '<div class="cs-card" data-cs-item data-k="' + esc(x.k) + '" data-h="' + esc(x.h) + '"' + (x.v ? ' data-v="' + x.v + '"' : '') + ' data-title="' + esc(x.t) + '" data-price="' + (x.p || 0) + '" data-designs="' + (x.v ? 1 : (x.n || 1)) + '" data-img="' + esc(x.i || '') + '">' +
      '<a class="pic" href="' + esc(url) + '" aria-label="' + esc(x.t) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.t) + '"' + (n != null && n > 23 ? ' loading="lazy"' : '') + ' decoding="async">' : '') + (!x.v && x.n > 1 ? '<span class="dn">' + x.n + ' designs</span>' : '') + '</a>' +
      '<a class="n" href="' + esc(url) + '" title="' + esc(x.t) + '">' + esc(x.t) + '</a>' +
      '<div class="pr"><span class="p">' + (x.p ? (x.f ? '<small class="fr">From</small>' : '') + money(x.p) : '') + '</span><div class="acts">' +
      '<button type="button" class="cs-heart" data-cs-heart="' + esc(x.k) + '" data-title="' + esc(x.t) + '" aria-pressed="true" aria-label="Remove ' + esc(x.t) + '">' + icon('heart') + '</button>' +
      '<button type="button" class="cs-add" ' + add + ' data-title="' + esc(x.t) + '" aria-label="Add ' + esc(x.t) + '">' + icon('plus') + '</button></div></div></div>';
  }
  function drawHeartsDrawer() {
    var g = document.getElementById('csHeartsG'); if (!g) return;
    var list = readHearts(), shown = heartsView(list), inBag = {}; (cart && cart.items || []).forEach(function (it) { inBag[it.variant_id] = 1; });
    var addable = shown.filter(function (x) { return x.v && !inBag[x.v]; });
    $$('[data-cs-hd-n]').forEach(function (n) { n.textContent = list.length ? ' (' + list.length + ')' : ''; });
    heartsTools(document.getElementById('csHeartsTools'), list, shown);
    g.innerHTML = shown.length ? shown.map(function (x, n) { return heartCard(x, Math.min(n, 23)); }).join('') : (list.length ? '<p class="cs-p cs-hnone">No ' + HS.f + ' charms in your hearts.</p>' : '');
    heartsPickMarks(g);
    showImgs(g);
    edgeBtns(document.getElementById('csHeartsD'), shown.length >= 30);
    var e = document.getElementById('csHeartsE'); if (e) e.hidden = !!list.length;
    var f = document.getElementById('csHeartsF');
    if (f) {
      f.hidden = !list.length;
      var b = f.querySelector('[data-cs-hd-all]');
      var pick = shown.filter(function (x) { return !x.v; });
      if (b) { b.hidden = !addable.length; b.textContent = 'Add ' + (addable.length === 1 ? 'it' : 'all ' + addable.length) + ' to bag'; b.onclick = function () { addItems(addable.map(function (x) { return { id: Number(x.v), quantity: 1, h: x.h || '', price: x.p || 0 }; })).then(function () { if (pick.length) toast(pick.length === 1 ? 'Pick a design for ' + esc(pick[0].t || 'your saved charm') + ' to add it too.' : pick.length + ' saved charms need a design first. Tap their + to pick one.'); }); }; }
    }
    paintInBag(g);
  }
  CS.drawHearts = drawHeartsDrawer;
  function edgeBtns(drawer, on) {
    if (!drawer) return;
    var box = drawer.querySelector('.cs-edge'), sc = drawer.querySelector('.db');
    if (!on || !sc) { if (box) box.hidden = true; return; }
    if (!box) {
      box = document.createElement('div'); box.className = 'cs-edge';
      box.innerHTML = '<button type="button" data-edge="top" aria-label="Back to the top">' + icon('up') + '</button><button type="button" data-edge="end" aria-label="Go to the bottom">' + icon('up') + '</button>';
      drawer.appendChild(box);
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-edge]'); if (!b) return; var end = b.getAttribute('data-edge') !== 'top';
        sc.scrollTo({ top: end ? sc.scrollHeight : 0, behavior: 'smooth' });
        // lines that were skipped get their real height on the way down: finish at the true bottom
        if (end) setTimeout(function () { if (sc.scrollHeight - sc.clientHeight - sc.scrollTop > 4) sc.scrollTo({ top: sc.scrollHeight }); }, 650);
      });
      // sit just above the footer, whatever its height; step aside while the footer's Details are open
      var place = function () {
        var ft = drawer.querySelector('.cs-bagfoot'), shown = ft && !ft.hidden;
        box.style.bottom = ((shown ? ft.offsetHeight : 0) + 12) + 'px';
        box.classList.toggle('off', !!(shown && ft.querySelector('[data-cs-fold][aria-expanded="true"]')));
      };
      var paint = function () { place(); var y = sc.scrollTop, max = sc.scrollHeight - sc.clientHeight; box.querySelector('[data-edge=top]').disabled = y < 40; box.querySelector('[data-edge=end]').disabled = y > max - 40; };
      var ft0 = drawer.querySelector('.cs-bagfoot');
      if (ft0 && window.ResizeObserver) new ResizeObserver(function () { place(); }).observe(ft0);
      sc.addEventListener('scroll', function () { if (!box._r) box._r = requestAnimationFrame(function () { box._r = 0; paint(); }); }, { passive: true });
      box._paint = paint;
    }
    box.hidden = false; requestAnimationFrame(box._paint);
  }
  function initSaved() {
    var root = $('[data-cs-saved]'); if (!root) return;
    var grid = $('[data-cs-saved-grid]', root);
    function draw() {
      var all = readHearts(), list = heartsView(all), c = cart ? stats(cart).charms : 0;
      var inBag = {}; (cart && cart.items || []).forEach(function (it) { inBag[it.variant_id] = 1; });
      var addable = list.filter(function (x) { return x.v && !inBag[x.v]; });
      $('[data-cs-saved-title]', root).textContent = all.length ? all.length + ' saved charm' + (all.length === 1 ? '' : 's') : 'Your saved charms';
      heartsTools($('[data-cs-htools]', root), all, list);
      $('[data-cs-saved-sub]', root).textContent = list.length ? 'Worth ' + money(list.reduce(function (a, x) { return a + (x.p || 0); }, 0)) + ' together.' : 'Tap the heart on any charm and it waits for you here.';
      $('[data-cs-saved-empty]', root).hidden = !!all.length;
      var box = $('[data-cs-saved-box]', root); box.hidden = !addable.length;
      var after = c + addable.length;
      $('[data-cs-saved-msg]', root).innerHTML = after >= 10 ? 'Add ' + (addable.length === 1 ? 'it' : 'all ' + addable.length) + ' and <b>the bracelet is free</b>.' : 'Add all ' + addable.length + ' and you have <b>' + after + ' of 10</b>. ' + (10 - after) + ' more and the bracelet is free.';
      var btn = $('[data-cs-saved-all]', root); btn.textContent = 'Add ' + (addable.length === 1 ? 'it' : 'all ' + addable.length) + ' to bag';
      btn.onclick = function () { addItems(addable.map(function (x) { return { id: Number(x.v), quantity: 1, h: x.h || '', price: x.p || 0 }; })); };
      grid.innerHTML = list.length ? list.map(heartCard).join('') : (all.length ? '<p class="cs-p cs-hnone">No ' + HS.f + ' charms in your hearts.</p>' : '');
      heartsPickMarks(grid);
      showImgs(grid);
      paintInBag(grid);
    }
    draw(); savedDraw = draw;
    document.addEventListener('cs:hearts', draw);
    document.addEventListener('cs:cart', draw);
  }
  /* "Add all" buttons (this week's edit) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cs-addall]'); if (!b) return;
    var g = document.querySelector(b.getAttribute('data-cs-addall')); if (!g) return;
    var have = {}; (cart && cart.items || []).forEach(function (it) { have[it.variant_id] = 1; });
    var hint = {};
    var ids = $$('[data-cs-add]', g).map(function (x) { var id = Number(x.getAttribute('data-cs-add')), c = x.closest('.cs-card'); if (c && !hint[id]) hint[id] = { h: c.getAttribute('data-h'), price: c.getAttribute('data-price') }; return id; }).filter(function (id, i, a) { return id && !have[id] && a.indexOf(id) === i; });
    if (!ids.length) { toast('They are all in your bag already.', 'View bag'); return; }
    addItems(ids.map(function (id) { var o = { id: id, quantity: 1 }; if (hint[id] && hint[id].h) { o.h = hint[id].h; o.price = hint[id].price; } return o; }));
  });

  /* ---------- collection + search pages: switch in place (Section Rendering API); header, rail and chips stay still ---------- */
  var SW = { cache: [], inflight: {}, busy: false, spin: null, spinFor: null, live: null };
  var SWRM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var SWEASE = 'cubic-bezier(.32,.72,0,1)';
  function swKey(href) { var u = new URL(href, location.href); u.hash = ''; u.searchParams.delete('section_id'); return u.pathname + u.search; }
  function swPut(k, h) { SW.cache = SW.cache.filter(function (x) { return x.k !== k; }); SW.cache.push({ k: k, h: h }); while (SW.cache.length > 8) SW.cache.shift(); }
  function swGet(k, sec) {
    for (var i = 0; i < SW.cache.length; i++) if (SW.cache[i].k === k) return Promise.resolve(SW.cache[i].h);
    if (SW.inflight[k]) return SW.inflight[k];
    var ctl = window.AbortController ? new AbortController() : null, tm;
    var p = Promise.race([
      fetch(k + (k.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(sec), { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }),
      new Promise(function (res, rej) { tm = setTimeout(function () { if (ctl) ctl.abort(); rej(new Error('timeout')); }, 8000); })
    ]).then(function (h) { clearTimeout(tm); delete SW.inflight[k]; swPut(k, h); return h; }, function (e) { clearTimeout(tm); delete SW.inflight[k]; throw e; });
    SW.inflight[k] = p; return p;
  }
  function swParse(h, sel) { var d = new DOMParser().parseFromString(h, 'text/html'); if (!d.querySelector(sel)) throw new Error('parse'); return d; }
  function swAnim(el, kf, o) { if (!el || !el.animate) return null; try { return el.animate(kf, o); } catch (e) { return null; } }
  function swDone(a) { return a ? a.finished.then(null, function () {}) : Promise.resolve(); }
  // spinner in the grid area + 'cs:busy' for the page-load bar
  function swBusy(on, el) {
    if (on) {
      if (SW.spin || !el || !el.parentNode) return;
      SW.spin = document.createElement('div'); SW.spin.className = 'cs-swspin'; SW.spin.setAttribute('aria-hidden', 'true'); SW.spin.innerHTML = '<i></i>';
      el.parentNode.insertBefore(SW.spin, el); el.setAttribute('aria-busy', 'true'); SW.spinFor = el;
    } else {
      if (!SW.spin) return;
      if (SW.spin.parentNode) SW.spin.parentNode.removeChild(SW.spin);
      if (SW.spinFor) SW.spinFor.removeAttribute('aria-busy');
      SW.spin = SW.spinFor = null;
    }
    document.dispatchEvent(new CustomEvent('cs:busy', { detail: { on: !!on } }));
  }
  function swSay(t) {
    if (!t) return;
    if (!SW.live) { SW.live = document.createElement('div'); SW.live.className = 'sr'; SW.live.setAttribute('role', 'status'); SW.live.setAttribute('aria-live', 'polite'); document.body.appendChild(SW.live); }
    var l = SW.live; l.textContent = ''; setTimeout(function () { l.textContent = t; }, 50);
  }
  function swView() {
    var d = { url: location.href, title: document.title };
    document.dispatchEvent(new CustomEvent('cs:pageview', { detail: d }));
    if (typeof window.gtag === 'function') { try { window.gtag('event', 'page_view', { page_location: d.url, page_title: d.title }); } catch (e) {} }
  }
  function swSaveY(y) {
    try { var s = {}, o = history.state; if (o && typeof o === 'object') for (var k in o) s[k] = o[k]; s.cs = 1; s.y = y == null ? window.pageYOffset : y; history.replaceState(s, ''); } catch (e) {}
  }
  // we restore scroll ourselves: the browser would restore it before the new content is in place
  function swHist(onPop) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
    var st = history.state, nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (st && st.cs && st.y && nav && (nav.type === 'back_forward' || nav.type === 'reload')) requestAnimationFrame(function () { window.scrollTo(0, st.y); });
    else swSaveY();
    var t, idle = function () { return !SW.busy && !document.body.classList.contains('cs-lock'); };
    window.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { if (idle()) swSaveY(); }, 250); }, { passive: true });
    window.addEventListener('pagehide', function () { if (idle()) swSaveY(); });
    window.addEventListener('popstate', function (e) { if (e.state && e.state.cs) onPop(e.state); });
  }
  function swHeadH() { return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cs-head')) || 52; }
  function swSelect(sel, v) { if (!sel || v == null) return; $$('option', sel).forEach(function (o) { if (o.value === v) o.setAttribute('selected', ''); else o.removeAttribute('selected'); }); sel.value = v; }

  function initColSwitch() {
    var meta = $('[data-cs-colsec]'); if (!meta || !window.fetch || !window.DOMParser || !history.pushState) return;
    var sec = meta.getAttribute('data-cs-colsec'), root = meta.closest('.shopify-section') || meta.parentNode;
    var rail = $('[data-cs-rail]', root), stick = $('[data-cs-stick]', root);
    var COL = /^(\/[a-z]{2}(-[a-z]{2,4})?)?\/collections\/[^\/]+(\/[^\/]+)?\/?$/i;
    var cur = swKey(location.href), seq = 0, outA = null, inA = null, spinT = null;
    function tiles() { return rail ? $$('a.cs-tile', rail) : []; }
    function cats() { return tiles().filter(function (t) { return !t.hasAttribute('data-cs-sp'); }); } // the special tiles (For you, All, This week, Sets, Gift guide) are marked data-cs-sp
    function nowTile() { return rail ? rail.querySelector('a[aria-current="true"]') : null; }
    function handleOf(p) { var m = /\/collections\/([^\/?#]+)/.exec(p || ''); return m ? m[1] : ''; }
    function keyFor(a) {
      var u; try { u = new URL(a.href, location.href); } catch (e) { return null; }
      if (u.origin !== location.origin || !COL.test(u.pathname)) return null;
      u.searchParams.delete('page'); return swKey(u.href);
    }
    function swappable(a) { return !!a && root.contains(a) && !!(a.closest('[data-cs-rail]') || a.closest('.cs-chips')) && (!a.target || a.target === '_self') && !a.hasAttribute('download'); }
    function mark(list, on) { list.forEach(function (x) { if (x === on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); }); }
    function railTo(t) {
      if (!rail || !t) return;
      var rr = rail.getBoundingClientRect(), tr = t.getBoundingClientRect(), left = Math.max(0, rail.scrollLeft + (tr.left - rr.left) - rr.width / 2 + tr.width / 2);
      try { rail.scrollTo({ left: left, behavior: SWRM ? 'auto' : 'smooth' }); } catch (e) { rail.scrollLeft = left; }
    }
    // the count bar sits just under the sticky header + rail; the page only moves when it is above that line
    function toGrid(force) {
      var bar = $('.cs-colbar', root) || $('.cs-colgrid', root); if (!bar) return false;
      var off = swHeadH() + (stick ? stick.getBoundingClientRect().height : 0), t = bar.getBoundingClientRect().top;
      if (!force && t >= off - 1) return false;
      window.scrollTo({ top: Math.max(0, window.pageYOffset + t - off), behavior: SWRM ? 'auto' : 'smooth' });
      return true;
    }
    function go(key, o) {
      o = o || {};
      if (!key || (key === cur && !SW.busy)) return;
      var grid = $('.cs-colgrid', root); if (!grid) { location.href = key; return; }
      if (!SW.busy) swPut(cur, root.outerHTML); // Back restores exactly what was on screen
      var my = ++seq, y0 = window.pageYOffset, fade = o.fade || SWRM, dx = fade ? 0 : 24 * (o.dir || 1);
      SW.busy = true; clearTimeout(spinT);
      var data = swGet(key, sec).then(function (h) { return swParse(h, '[data-cs-colsec]'); });
      var scrolled = o.y == null && toGrid(false);
      var op = 1;
      if (inA) { op = Number(getComputedStyle(grid).opacity) || 0; inA.cancel(); inA = null; }
      if (!outA) {
        grid.style.willChange = 'transform,opacity';
        outA = swAnim(grid, [{ opacity: op, transform: 'translate3d(0,0,0)' }, { opacity: 0, transform: 'translate3d(' + (-dx) + 'px,0,0)' }], { duration: SWRM ? 100 : fade ? 120 : 180, easing: SWEASE, fill: 'forwards' });
      }
      grid.style.pointerEvents = 'none';
      var out = swDone(outA);
      out.then(function () { if (my === seq) spinT = setTimeout(function () { if (my === seq) swBusy(true, grid); }, 150); });
      Promise.all([data, out]).then(function (r) { if (my === seq) apply(r[0], key, o, dx, y0, scrolled, grid); })
        .catch(function () { if (my !== seq) return; clearTimeout(spinT); location.href = key; });
    }
    function apply(doc, key, o, dx, y0, scrolled, grid) {
      clearTimeout(spinT); swBusy(false);
      var nm = doc.querySelector('[data-cs-colsec]'), head = $('.cs-colhead', root), nh = doc.querySelector('.cs-colhead');
      var gy = grid.getBoundingClientRect().top, hidHead = !head || head.getBoundingClientRect().bottom <= swHeadH() + 1;
      if (head && nh) { head.innerHTML = nh.innerHTML; swAnim(head, [{ opacity: 0 }, { opacity: 1 }], { duration: SWRM ? 100 : 160, easing: 'ease' }); }
      // chips: same elements, new hrefs and states; hidden on gold, silver and bracelet like the Liquid
      var oc = stick && $('.cs-chips', stick), nc = doc.querySelector('[data-cs-stick] .cs-chips');
      if (nc && !nc.hidden) {
        if (!oc) { if (stick) stick.appendChild(document.importNode(nc, true)); }
        else {
          var oa = $$('a', oc), na = $$('a', nc);
          if (oa.length === na.length) oa.forEach(function (a, i) { a.setAttribute('href', na[i].getAttribute('href')); if (na[i].getAttribute('aria-current') === 'true') a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
          else oc.innerHTML = nc.innerHTML;
          oc.hidden = false;
        }
      } else if (oc) oc.hidden = true;
      // rail: not re-rendered, only the current mark moves
      var ct = doc.querySelector('[data-cs-rail] a[aria-current="true"]'), on = null;
      if (ct) { var p = new URL(ct.getAttribute('href'), location.href).pathname; tiles().forEach(function (t) { if (!on && t.pathname === p) on = t; }); }
      mark(tiles(), on); railTo(on);
      // count + sort
      var ns = doc.querySelector('[data-cs-shown]'), os = $('[data-cs-shown]', root); if (ns && os) os.textContent = ns.textContent;
      var so = doc.querySelector('[data-cs-sort] option[selected]'); swSelect($('[data-cs-sort]', root), so ? so.getAttribute('value') : null);
      // grid
      var ng = doc.querySelector('.cs-colgrid'); grid.innerHTML = ng ? ng.innerHTML : '';
      meta.setAttribute('data-cs-title', nm.getAttribute('data-cs-title') || ''); meta.setAttribute('data-cs-say', nm.getAttribute('data-cs-say') || '');
      if (o.y != null) window.scrollTo(0, o.y);
      else if (scrolled) toGrid(true);
      else { var d = grid.getBoundingClientRect().top - gy; if (d && hidHead) window.scrollTo(0, window.pageYOffset + d); }
      inA = swAnim(grid, [{ opacity: 0, transform: 'translate3d(' + dx + 'px,0,0)' }, { opacity: 1, transform: 'translate3d(0,0,0)' }], { duration: SWRM ? 100 : (dx ? 220 : 160), easing: SWEASE });
      if (outA) { outA.cancel(); outA = null; }
      grid.style.pointerEvents = '';
      if (inA) { var me = inA; inA.onfinish = function () { if (inA === me) { inA = null; grid.style.willChange = ''; } }; } else grid.style.willChange = '';
      cur = key; SW.busy = false;
      if (o.push !== false && key !== swKey(location.href)) { swSaveY(y0); try { history.pushState({ cs: 1, y: 0 }, '', key); } catch (e) {} }
      if (nm.getAttribute('data-cs-title')) document.title = nm.getAttribute('data-cs-title');
      swView();
      paintHearts(); paintInBag(grid);
      document.dispatchEvent(new CustomEvent('cs:swap', { detail: { root: grid, url: location.href } }));
      swSay(nm.getAttribute('data-cs-say'));
    }
    function pick(a, dir) {
      var key = keyFor(a); if (!key) return false;
      if (key === cur && !SW.busy) return true;
      var inRail = !!a.closest('[data-cs-rail]');
      if (inRail && dir == null) { var all = tiles(); dir = all.indexOf(a) < all.indexOf(nowTile()) ? -1 : 1; }
      go(key, { dir: dir, fade: !inRail });
      mark(inRail ? tiles() : $$('a', a.closest('.cs-chips')), a); // selected at once
      if (inRail) railTo(a);
      return true;
    }
    // capture phase, registered before initLeave, so the page fade never runs for these
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]'); if (!swappable(a) || !keyFor(a)) return;
      e.preventDefault(); pick(a);
    }, true);
    function pre(e) { var a = e.target.closest && e.target.closest('a[href]'); if (!swappable(a)) return; var k = keyFor(a); if (k && k !== cur) swGet(k, sec).catch(function () {}); }
    root.addEventListener('pointerdown', pre, { passive: true });
    root.addEventListener('touchstart', pre, { passive: true });
    root.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('[data-cs-sort]'); if (!s) return;
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
      go(swKey(u.href), { fade: true });
    });
    root.addEventListener('submit', function (e) { if (e.target.closest && e.target.closest('.cs-sortf')) e.preventDefault(); });
    // swipe the grid sideways: next / previous category (vertical scrolling is never blocked)
    var sx = 0, sy = 0, sY0 = 0, sT0 = 0, sOk = false;
    root.addEventListener('touchstart', function (e) {
      sOk = false; if (e.touches.length !== 1) return;
      var g = e.target.closest && e.target.closest('.cs-colgrid'); if (!g) return;
      for (var n = e.target; n && n !== g; n = n.parentNode) if (n.scrollWidth > n.clientWidth + 2 && /(auto|scroll)/.test(getComputedStyle(n).overflowX)) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; sY0 = window.pageYOffset; sT0 = Date.now(); sOk = true;
    }, { passive: true });
    root.addEventListener('touchcancel', function () { sOk = false; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!sOk) return; sOk = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      // only a clear, quick sideways flick switches category; anything slanted or slow is treated as scrolling
      if (Math.abs(dx) < 70 || Math.abs(dx) < 2.2 * Math.abs(dy) || Date.now() - sT0 > 900 || Math.abs(window.pageYOffset - sY0) > 10 || openEl) return;
      var list = cats(), i = list.indexOf(nowTile()), n = dx < 0 ? i + 1 : i - 1;
      if (i < 0) { if (dx > 0) return; n = 0; }
      if (list[n]) pick(list[n], dx < 0 ? 1 : -1);
    }, { passive: true });
    swHist(function (st) {
      var key = swKey(location.href); if (key === cur && !SW.busy) return;
      var all = tiles(), h = handleOf(location.pathname), from = all.indexOf(nowTile()), to = -1;
      all.forEach(function (t, i) { if (to < 0 && handleOf(t.pathname) === h) to = i; });
      go(key, { push: false, y: st.y || 0, dir: to < from ? -1 : 1, fade: to < 0 || from < 0 || to === from });
      if (all[to]) { mark(all, all[to]); railTo(all[to]); }
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      ++seq; clearTimeout(spinT); swBusy(false); SW.busy = false;
      if (outA) { outA.cancel(); outA = null; }
      var g = $('.cs-colgrid', root); if (g) { g.style.willChange = ''; g.style.pointerEvents = ''; }
    });
  }

  function initSearchSwap() {
    var root = $('[data-cs-srch]'); if (!root || !window.fetch || !window.DOMParser || !history.pushState) return;
    var sec = root.getAttribute('data-cs-srch'), cur = swKey(location.href), seq = 0, outA = null, inA = null, spinT = null;
    function go(key, o) {
      o = o || {};
      if (CS.searchOn) return; // the smart search owns the grid (sort + show more run client-side)
      if (!key || (key === cur && !SW.busy)) return;
      var box = $('[data-cs-sres]', root); if (!box) { location.href = key; return; }
      if (!SW.busy) swPut(cur, root.outerHTML);
      var my = ++seq, y0 = window.pageYOffset; SW.busy = true; clearTimeout(spinT);
      var data = swGet(key, sec).then(function (h) { return swParse(h, '[data-cs-sres]'); });
      if (o.top) { var t = box.getBoundingClientRect().top, off = swHeadH() + 12; if (t < off) window.scrollTo({ top: Math.max(0, window.pageYOffset + t - off), behavior: SWRM ? 'auto' : 'smooth' }); }
      var op = 1;
      if (inA) { op = Number(getComputedStyle(box).opacity) || 0; inA.cancel(); inA = null; }
      if (!outA) { box.style.willChange = 'opacity'; outA = swAnim(box, [{ opacity: op }, { opacity: 0 }], { duration: SWRM ? 100 : 120, easing: 'ease', fill: 'forwards' }); }
      box.style.pointerEvents = 'none';
      var out = swDone(outA);
      out.then(function () { if (my === seq) spinT = setTimeout(function () { if (my === seq) swBusy(true, box); }, 150); });
      Promise.all([data, out]).then(function (r) {
        if (my !== seq) return;
        clearTimeout(spinT); swBusy(false);
        var d = r[0], nb = d.querySelector('[data-cs-sres]'), so = d.querySelector('[data-cs-ssort] option[selected]'), sel = $('[data-cs-ssort]', root);
        box.innerHTML = nb.innerHTML;
        swSelect(sel, so ? so.getAttribute('value') : null);
        if (o.y != null) window.scrollTo(0, o.y);
        inA = swAnim(box, [{ opacity: 0 }, { opacity: 1 }], { duration: SWRM ? 100 : 160, easing: 'ease' });
        if (outA) { outA.cancel(); outA = null; }
        box.style.pointerEvents = '';
        if (inA) { var me = inA; inA.onfinish = function () { if (inA === me) { inA = null; box.style.willChange = ''; } }; } else box.style.willChange = '';
        cur = key; SW.busy = false;
        if (o.push !== false && key !== swKey(location.href)) { swSaveY(y0); try { history.pushState({ cs: 1, y: 0 }, '', key); } catch (e) {} }
        swView(); paintHearts(); paintInBag(box);
        document.dispatchEvent(new CustomEvent('cs:swap', { detail: { root: box, url: location.href } }));
        var pn = $('.cs-pager .n', box);
        swSay((sel && sel.selectedIndex >= 0 ? 'Sorted by ' + sel.options[sel.selectedIndex].text + '. ' : '') + (pn ? pn.textContent : ''));
      }).catch(function () { if (my !== seq) return; clearTimeout(spinT); location.href = key; });
    }
    // the smart search takes over: drop any server swap still on its way
    CS.searchSwapStop = function () {
      ++seq; clearTimeout(spinT); swBusy(false); SW.busy = false;
      if (outA) { outA.cancel(); outA = null; } if (inA) { inA.cancel(); inA = null; }
      var b = $('[data-cs-sres]', root); if (b) { b.style.willChange = ''; b.style.pointerEvents = ''; }
    };
    function pageKey(a) { var u; try { u = new URL(a.href, location.href); } catch (e) { return null; } return u.origin === location.origin ? swKey(u.href) : null; }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[data-cs-spage]'); if (!a || !root.contains(a)) return;
      var k = pageKey(a); if (!k) return;
      e.preventDefault(); go(k, { top: true });
    }, true);
    root.addEventListener('pointerdown', function (e) {
      var a = e.target.closest && e.target.closest('a[data-cs-spage]'); if (!a) return;
      var k = pageKey(a); if (k && k !== cur) swGet(k, sec).catch(function () {});
    }, { passive: true });
    root.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('[data-cs-ssort]'); if (!s) return;
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
      go(swKey(u.href), {});
    });
    swHist(function (st) { var k = swKey(location.href); if (k === cur && !SW.busy) return; go(k, { push: false, y: st.y || 0 }); });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      ++seq; clearTimeout(spinT); swBusy(false); SW.busy = false;
      if (outA) { outA.cancel(); outA = null; }
      var b = $('[data-cs-sres]', root); if (b) { b.style.willChange = ''; b.style.pointerEvents = ''; }
    });
  }

  /* ---------- smart search (W5): words from the charm pictures (assets/cs-search.json); instant results; search page ---------- */
  var SX = { items: null, vocab: null, p: null, fails: 0, cache: {}, cn: 0 };
  var SXSTOP = { a: 1, an: 1, the: 1, 'for': 1, 'with': 1, of: 1, and: 1, charm: 1, charms: 1, italian: 1, bracelet: 1 };
  function sxNorm(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/&/g, ' and ').replace(/['\u2019`]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function sxWords(s) { s = sxNorm(s); return s ? s.split(' ') : []; }
  function sxPl(a, b) { return a === b + 's' || a === b + 'es' || (a.length > 4 && /ies$/.test(a) && a.slice(0, -3) + 'y' === b); }
  // edit distance <= 1 (insert, delete, substitute, swap of two neighbours)
  function sxEd1(a, b) {
    if (a.length < b.length) { var x = a; a = b; b = x; }
    var la = a.length, lb = b.length, i = 0;
    if (la - lb > 1) return false;
    while (i < lb && a.charCodeAt(i) === b.charCodeAt(i)) i++;
    if (i === lb) return true;
    if (la > lb) return a.slice(i + 1) === b.slice(i);
    if (a.slice(i + 1) === b.slice(i + 1)) return true;
    return a.charCodeAt(i) === b.charCodeAt(i + 1) && a.charCodeAt(i + 1) === b.charCodeAt(i) && a.slice(i + 2) === b.slice(i + 2);
  }
  // once after load: one shared word list; every item keeps word ids per field
  function sxPrep(list) {
    if (!Array.isArray(list) || !list.length) throw new Error('bad index');
    var vm = Object.create(null), vocab = [], items = [];
    function ids(words) {
      var out = [], seen = Object.create(null);
      for (var i = 0; i < words.length; i++) { var w = words[i]; if (seen[w]) continue; seen[w] = 1; var id = vm[w]; if (id === undefined) { id = vm[w] = vocab.length; vocab.push(w); } out.push(id); }
      return out;
    }
    list.forEach(function (x, n) {
      if (!x || !x.h) return;
      if (!Array.isArray(x.d)) x.d = [];
      items.push({ x: x, i: n, t: ids(sxWords(x.t)), tn: sxNorm(x.t), d: x.d.map(function (s) { return ids(sxWords(s)); }), k: ids(sxWords(x.k)) });
    });
    SX.vocab = vocab; SX.cache = {}; SX.cn = 0; SX.items = items;
  }
  function sxLoad() {
    if (SX.items) return Promise.resolve(SX);
    if (SX.p) return SX.p;
    var url = CS.searchIndex;
    if (!url || !window.fetch || SX.fails > 1) return Promise.reject(new Error('no index'));
    try { if (sessionStorage.getItem('csSxU') === url) { sxPrep(JSON.parse(sessionStorage.getItem('csSxT'))); return Promise.resolve(SX); } } catch (e) { SX.items = null; }
    var p = SX.p = fetch(url).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function (t) {
      sxPrep(JSON.parse(t)); SX.p = null;
      try { sessionStorage.setItem('csSxT', t); sessionStorage.setItem('csSxU', url); } catch (e) { try { sessionStorage.removeItem('csSxT'); sessionStorage.removeItem('csSxU'); } catch (x) {} }
      return SX;
    });
    p.then(null, function () { SX.fails++; if (SX.p === p) SX.p = null; });
    return p;
  }
  // how well one typed word matches every known word (0 = not at all)
  // q: exact 1, plural .92, typo .5 (only if the word is unknown); p: q plus prefix .35
  function sxTok(t, loose) {
    var ck = (loose ? '~' : '') + t, c = SX.cache[ck]; if (c) return c;
    var V = SX.vocab, N = V.length, q = new Float32Array(N), p = null, L = t.length, known = false, i, w;
    for (i = 0; i < N; i++) {
      w = V[i];
      if (w === t) { q[i] = 1; known = true; }
      else if (sxPl(w, t) || sxPl(t, w)) { q[i] = 0.92; known = true; }
    }
    if (!known && (L >= 5 || (loose && L === 4))) for (i = 0; i < N; i++) { w = V[i]; if (Math.abs(w.length - L) <= 1 && sxEd1(w, t)) q[i] = 0.5; }
    if (L >= 2) { p = new Float32Array(q); for (i = 0; i < N; i++) if (!p[i] && V[i].length > L && V[i].lastIndexOf(t, 0) === 0) p[i] = 0.35; }
    if (++SX.cn > 60) { SX.cache = {}; SX.cn = 1; }
    return (SX.cache[ck] = { q: q, p: p || q });
  }
  function sxBest(ids, q) { var b = 0; for (var i = 0; i < ids.length; i++) { var v = q[ids[i]]; if (v > b) b = v; } return b; }
  function sxSearch(query, loose) {
    if (!SX.items) return [];
    var raw = sxWords(query), toks = raw.filter(function (w) { return !SXSTOP[w]; });
    if (!toks.length) toks = raw;
    toks = toks.filter(function (w, i) { return toks.indexOf(w) === i; });
    if (!toks.length) return [];
    var T = toks.map(function (w) { return sxTok(w, loose); }), qn = sxNorm(query), n = T.length, out = [];
    // prefix only for the last word, only on title and design names
    var F = T.map(function (o, j) { return j === n - 1 ? o.p : o.q; });
    SX.items.forEach(function (it) {
      var s = 0, inT = 0, mq = 1, j, m, v;
      for (j = 0; j < n; j++) {
        var f = F[j], bt = sxBest(it.t, f), bd = 0;
        for (m = 0; m < it.d.length && bd < 1; m++) { v = sxBest(it.d[m], f); if (v > bd) bd = v; }
        var bk = bt >= 1 || bd >= 1 ? 0 : sxBest(it.k, T[j].q), b = Math.max(bt * 100, bd * 70, bk * 45);
        if (!b) return; // every word must match somewhere
        s += b; if (bt >= 0.92) inT++;
        v = b === bt * 100 ? bt : b === bd * 70 ? bd : bk;
        if (v < mq) mq = v;
      }
      var dj = -1, best = 0, ok = false;
      if (inT < n) for (m = 0; m < it.d.length; m++) {
        var ds = 0, st = true;
        for (j = 0; j < n; j++) { v = sxBest(it.d[m], F[j]); if (!v) { ds = 0; break; } if (v < 0.5) st = false; ds += v; }
        if (ds > best) { best = ds; dj = m; ok = st; }
      }
      if (inT === n) s += 40; else if (ok) s += 20;
      if (inT === n && qn && (it.tn === qn || it.tn.lastIndexOf(qn + ' ', 0) === 0)) s += 30;
      s += ((it.x.a ? 15 : 0) + 10 / Math.max(1, it.t.length)) * mq * mq;
      out.push({ x: it.x, s: s, i: it.i, dj: dj });
    });
    out.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    if (!out.length && !loose && toks.some(function (w) { return w.length === 4; })) return sxSearch(query, true);
    return out;
  }
  CS.search = sxSearch; CS.searchLoad = sxLoad;
  /* CAD, GBP, AUD and EUR shoppers get the gift card made in their currency (round amounts); see snippets/cs-gc.liquid */
  var GCL = { CAD: 'gift-card-cad', GBP: 'gift-card-gbp', AUD: 'gift-card-aud', EUR: 'gift-card-eur' }[(window.Shopify && Shopify.currency && Shopify.currency.active) || ''];
  function sxH(x) { return x.h === 'gift-card' && GCL ? GCL : x.h; }
  function sxPurl(h, x) { return (CS.routes && CS.routes.products || '/products/') + encodeURIComponent(h === 'gift-card' && GCL ? GCL : h) + (x && x.gr && x.v ? '?variant=' + x.v : ''); }
  function sxVids(x) { return x.g && x.g.length ? ' data-vids="' + x.g.join(',') + '"' : ''; }
  function sxPrice(x) { return x.h === 'gift-card' && GCL ? (x.p || 0) : Math.round((x.p || 0) * (Number(CS.ratio) || 1)); }
  function sxImg(x, w) { return x.i ? imgUrl((CS.searchCdn || 'https://cdn.shopify.com/s/files/1/0824/3118/1076/files/') + x.i, w) : ''; }
  function sxBusy(form, on) {
    var sp = form.querySelector('.cs-sspin'), inp = form.querySelector('input[type=search]');
    if (on && !sp) { var ic = form.querySelector(':scope > svg'); sp = document.createElement('i'); sp.className = 'cs-sspin'; sp.setAttribute('aria-hidden', 'true'); form.insertBefore(sp, ic ? ic.nextSibling : form.firstChild); }
    form.classList.toggle('cs-sbusy', !!on);
    if (inp) { if (on) inp.setAttribute('aria-busy', 'true'); else inp.removeAttribute('aria-busy'); }
  }
  function sxRow(r, id) {
    var x = r.x, d = r.dj >= 0 ? x.d[r.dj] : '', lp = sxPrice(x), im = sxImg(x, 120), e = esc(x.t);
    var btn = x.m ? '<button type="button" class="cs-add" data-cs-pick="' + esc(sxH(x)) + '"' + sxVids(x) + ' data-title="' + e + '" aria-label="Choose a design of ' + e + '">'
      : '<button type="button" class="cs-add" data-cs-add="' + x.v + '" data-h="' + esc(x.h) + '" data-price="' + lp + '" data-title="' + e + '" aria-label="Add ' + e + '"' + (x.a ? '' : ' disabled') + '>';
    return '<li role="option" id="' + id + '" aria-selected="false"><a href="' + esc(sxPurl(x.h, x)) + '" tabindex="-1"><i class="th">' + (im ? '<img src="' + esc(im) + '" alt="" width="60" height="60" loading="lazy" decoding="async">' : '') + '</i>' +
      '<span class="tx"><b>' + esc(d || x.t) + '</b>' + (d ? '<small>' + e + '</small>' : '') + '</span><span class="p">' + (x.a ? (x.m ? '<small>From</small>' : '') + money(lp) : 'Sold out') + '</span></a>' + btn + icon('plus') + '</button></li>';
  }
  // same structure as snippets/cs-card.liquid
  function sxCard(r) {
    var x = r.x, url = esc(sxPurl(x.h, x)), lp = sxPrice(x), e = esc(x.t), multi = !!x.m, n = x.d.length, im = sxImg(x, 400);
    var ss = im ? [200, 300, 400, 600].map(function (w) { return sxImg(x, w) + ' ' + w + 'w'; }).join(', ') : '';
    return '<div class="cs-card" data-cs-item data-h="' + esc(x.h) + '"' + (multi ? sxVids(x) : ' data-v="' + x.v + '"') + ' data-title="' + e + '" data-price="' + lp + '" data-designs="' + (multi ? Math.max(2, n) : 1) + '" data-url="' + url + '"' + (im ? ' data-img="' + esc(sxImg(x, 300)) + '"' : '') + '>' +
      '<a class="pic" href="' + url + '" aria-label="' + e + '">' + (im ? '<img src="' + esc(im) + '" srcset="' + esc(ss) + '" sizes="(min-width: 1100px) 220px, (min-width: 600px) 25vw, 33vw" alt="' + e + '" loading="lazy" decoding="async">' : '') + (multi && n > 1 ? '<span class="dn">' + n + ' designs</span>' : '') + soldPill(x.s) + '</a>' +
      '<a class="n" href="' + url + '" title="' + e + '">' + e + '</a>' +
      '<div class="pr"><span class="p">' + (multi ? '<small class="fr">From</small>' : '') + money(lp) + '</span><div class="acts">' +
      '<button type="button" class="cs-heart" data-cs-heart="' + esc(x.h) + '" data-title="' + e + '" aria-pressed="false" aria-label="Save ' + e + '">' + icon('heart') + '</button>' +
      (multi ? '<button type="button" class="cs-add" data-cs-pick="' + esc(sxH(x)) + '"' + sxVids(x) + ' data-title="' + e + '" aria-label="Choose a design of ' + e + '">'
        : '<button type="button" class="cs-add" data-cs-add="' + x.v + '" data-title="' + e + '" aria-label="Add ' + e + '"' + (x.a ? '' : ' disabled') + '>') + icon('plus') + '</button></div></div></div>';
  }
  /* instant results under the header search (desktop) and in the menu drawer (phone) */
  function initInstant(id, max, phone) {
    var inp = document.getElementById(id), form = inp && inp.form; if (!form) return;
    var lid = id + 'L', box = document.createElement('div'), db = phone ? form.parentNode : null;
    var open = false, act = -1, last = '', t = null, hideT = null;
    box.className = 'cs-sp' + (phone ? ' ph' : ''); box.hidden = true;
    box.innerHTML = '<ul class="ls" role="listbox" id="' + lid + '" aria-label="Matching charms"></ul><div class="ft"></div>';
    if (phone) form.parentNode.insertBefore(box, form.nextSibling); else form.appendChild(box);
    var ul = box.firstChild, ft = box.lastChild;
    inp.setAttribute('role', 'combobox'); inp.setAttribute('aria-autocomplete', 'list'); inp.setAttribute('aria-expanded', 'false'); inp.setAttribute('aria-controls', lid);
    function setAct(i) {
      var rows = ul.children, r = rows[act];
      if (r) { r.classList.remove('act'); r.setAttribute('aria-selected', 'false'); }
      act = i; r = rows[i];
      if (r) { r.classList.add('act'); r.setAttribute('aria-selected', 'true'); inp.setAttribute('aria-activedescendant', r.id); try { r.scrollIntoView({ block: 'nearest' }); } catch (e) {} }
      else { act = -1; inp.removeAttribute('aria-activedescendant'); }
    }
    function show(on) {
      if (on === open) return; open = on; clearTimeout(hideT);
      inp.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (db) db.classList.toggle('cs-msrch-on', on);
      if (on) { box.hidden = false; void box.offsetWidth; box.classList.add('on'); return; }
      box.classList.remove('on'); setAct(-1);
      if (phone) box.hidden = true; else hideT = setTimeout(function () { if (!open) box.hidden = true; }, 150);
    }
    function render(q) {
      var res = sxSearch(q), n = res.length, qs = esc(q.trim());
      act = -1; inp.removeAttribute('aria-activedescendant');
      ul.innerHTML = res.slice(0, max).map(function (r, i) { return sxRow(r, lid + i); }).join('');
      ft.innerHTML = (n ? '' : '<p class="cs-spnone">No charm matches \u201C' + qs + '\u201D yet.</p>') + '<button type="submit" class="cs-spall"><span>' + (n ? 'See all ' + n + ' result' + (n === 1 ? '' : 's') : 'Search everything for \u201C' + qs + '\u201D') + '</span>' + icon('right') + '</button>';
      show(true);
    }
    function run() {
      var q = inp.value;
      if (q.trim().length < 2) { last = ''; show(false); return; }
      if (!SX.items) {
        sxBusy(form, true);
        sxLoad().then(function () { sxBusy(form, false); if (inp.value === q) run(); }, function () { sxBusy(form, false); });
        return;
      }
      if (q === last && open) return;
      last = q; render(q);
    }
    function warm() { sxLoad().catch(function () {}); }
    inp.addEventListener('pointerdown', warm);
    inp.addEventListener('focus', function () { warm(); if (inp.value.trim().length >= 2) run(); });
    inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 80); });
    inp.addEventListener('keydown', function (e) {
      var n = open ? ul.children.length : 0;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { if (!n) return; e.preventDefault(); setAct(e.key === 'ArrowDown' ? (act + 1) % n : (act <= 0 ? n - 1 : act - 1)); }
      else if (e.key === 'Enter' && open && act >= 0) { var a = ul.children[act] && ul.children[act].querySelector('a'); if (a) { e.preventDefault(); a.click(); } }
      else if (e.key === 'Escape' && open) { e.preventDefault(); e.stopPropagation(); show(false); }
    });
    if (!phone) {
      document.addEventListener('pointerdown', function (e) { if (open && !form.contains(e.target)) show(false); }, true);
      form.addEventListener('focusout', function (e) { if (open && e.relatedTarget && !form.contains(e.relatedTarget)) show(false); });
    }
  }
  /* search page: once the index is in, the engine owns the product grid (sort + show more client-side) */
  function initSearchPage() {
    var root = $('[data-cs-srch]'), inp = document.getElementById('csSq'), form = inp && inp.form;
    var box = root && $('[data-cs-sres]', root); if (!box || !form || !root.contains(inp)) return;
    var q0 = inp.value.trim(), others = $('.cs-sothers', box), tpl = document.getElementById('csSnone');
    var mic = $('.hd .cs-micro', root), h1 = $('.hd .cs-h1', root), PER = 24;
    var list = [], shown = 0, curQ = null, seq = 0, outA = null, t = null;
    function sel() { return $('[data-cs-ssort]', root); }
    function on() {
      if (CS.searchOn) return; CS.searchOn = true;
      if (CS.searchSwapStop) CS.searchSwapStop();
      if (!sel()) { var b = form.querySelector('button[type=submit]'); if (b) b.insertAdjacentHTML('beforebegin', '<label class="sr" for="csSs">Sort</label><select id="csSs" name="sort_by" data-cs-ssort><option value="relevance">Relevance</option><option value="price-ascending">Price, low to high</option><option value="price-descending">Price, high to low</option></select>'); }
    }
    function cards(a, b) { return list.slice(a, b).map(sxCard).join(''); }
    function moreLbl() { return 'Show more (' + (list.length - shown) + ' left)'; }
    function fresh(el) { paintHearts(); paintInBag(el); imgsIn(el); }
    function swapIn(html, extra) {
      var my = ++seq;
      if (!outA && !SWRM) outA = swAnim(box, [{ opacity: 1 }, { opacity: 0 }], { duration: 50, easing: 'ease', fill: 'forwards' });
      swDone(outA).then(function () {
        if (my !== seq) return;
        box.innerHTML = html; if (extra) box.appendChild(extra);
        if (outA) { outA.cancel(); outA = null; }
        if (!SWRM) swAnim(box, [{ opacity: 0 }, { opacity: 1 }], { duration: 110, easing: 'ease' });
        fresh(box);
      });
    }
    function sync(q) {
      try {
        var u = new URL(location.href), s = sel();
        u.searchParams.set('q', q); u.searchParams.delete('page');
        if (s && s.value !== 'relevance') u.searchParams.set('sort_by', s.value); else u.searchParams.delete('sort_by');
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }
    function paint(q) {
      var qt = q.trim(), s = sel(), v = s ? s.value : '';
      list = qt ? sxSearch(qt) : [];
      if (v === 'price-ascending') list.sort(function (a, b) { return a.x.p - b.x.p || b.s - a.s; });
      else if (v === 'price-descending') list.sort(function (a, b) { return b.x.p - a.x.p || b.s - a.s; });
      shown = Math.min(PER, list.length);
      var n = list.length, html;
      if (mic) mic.textContent = qt ? n + ' result' + (n === 1 ? '' : 's') : 'Search';
      if (h1) h1.textContent = qt ? '\u201C' + qt + '\u201D' : 'Find a charm';
      if (s) s.hidden = n < 2;
      if (n) html = '<div class="cs-grid" id="csSgrid">' + cards(0, shown) + '</div>' + (n > shown ? '<div class="cs-more"><button type="button" class="cs-btn ghost" data-cs-smore>' + moreLbl() + '</button></div>' : '');
      else html = '<div class="cs-snone"><p class="cs-p">' + (qt ? 'Nothing matched \u201C' + esc(qt) + '\u201D. Try a shorter word, or one of these:' : 'Popular right now:') + '</p>' + (tpl ? tpl.innerHTML : '') + '</div>';
      swapIn(html, others && qt && qt === q0 ? others : null);
      swSay(qt ? n + ' result' + (n === 1 ? '' : 's') + ' for \u201C' + qt + '\u201D' : '');
    }
    function upd() {
      var q = inp.value;
      if (!SX.items) { sxBusy(form, true); sxLoad().then(function () { sxBusy(form, false); if (inp.value === q) upd(); }, function () { sxBusy(form, false); }); return; }
      on(); if (q === curQ) return;
      curQ = q; paint(q); sync(q);
    }
    function warm() { sxLoad().catch(function () {}); }
    inp.addEventListener('pointerdown', warm); inp.addEventListener('focus', warm);
    inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(upd, 150); });
    form.addEventListener('submit', function (e) { if (!CS.searchOn) return; e.preventDefault(); clearTimeout(t); upd(); try { inp.blur(); } catch (x) {} });
    root.addEventListener('change', function (e) {
      if (!CS.searchOn || !(e.target.closest && e.target.closest('[data-cs-ssort]'))) return;
      paint(curQ || ''); sync(curQ || '');
    });
    box.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-cs-smore]'); if (!b) return;
      e.preventDefault();
      var g = document.getElementById('csSgrid'); if (!g) return;
      var from = shown; shown = Math.min(list.length, shown + PER);
      g.insertAdjacentHTML('beforeend', cards(from, shown));
      fresh(g);
      if (shown >= list.length) { var w = b.parentNode, nx = g.children[from], a = nx && nx.querySelector('a.n'); w.parentNode.removeChild(w); if (a) { try { a.focus({ preventScroll: true }); } catch (x) {} } }
      else b.textContent = moreLbl();
      swSay('Showing ' + shown + ' of ' + list.length);
    });
    if (q0) sxLoad().then(function () { if (!CS.searchOn) upd(); }, function () {});
  }

  /* ---------- page change: top progress bar, a spinner on the tapped menu row, then a short fade
     (or the browser's own view transition where supported). bfcache-safe. ---------- */
  var VT = 'CSSViewTransitionRule' in window;
  var prog = (function () {
    var el = null, bar = null, t1 = 0, t2 = 0, state = 0;
    function make() { if (el) return; el = document.createElement('div'); el.className = 'cs-prog'; el.setAttribute('aria-hidden', 'true'); el.innerHTML = '<i></i>'; document.body.appendChild(el); bar = el.firstChild; }
    function set(s, tr) { bar.style.transition = tr; bar.style.transform = 'scaleX(' + s + ')'; }
    function start() {
      make(); clearTimeout(t2);
      if (state === 1) return;
      clearTimeout(t1); state = 1;
      set(0, 'none'); el.classList.add('on'); void bar.offsetWidth;
      set(0.7, 'transform .32s cubic-bezier(.2,.7,.2,1)');
      t1 = setTimeout(function () { set(0.94, 'transform 9s cubic-bezier(.1,.5,.2,1)'); }, 340);
    }
    function done() {
      if (!el || state !== 1) return;
      clearTimeout(t1); state = 2;
      set(1, 'transform .18s ease');
      t2 = setTimeout(function () { el.classList.remove('on'); t2 = setTimeout(reset, 220); }, 180);
    }
    function reset() { clearTimeout(t1); clearTimeout(t2); state = 0; if (!el) return; el.classList.remove('on'); set(0, 'none'); }
    return { start: start, done: done, reset: reset };
  })();
  CS.progress = prog;
  var going = null;
  function rowClear() {
    if (!going) return;
    var g = going; going = null;
    g.a.classList.remove('cs-going'); if (g.chev) g.chev.classList.remove('cs-chevoff');
    if (g.sp.parentNode) g.sp.parentNode.removeChild(g.sp);
    if (g.box) g.box.classList.remove('cs-dim');
  }
  // a menu row (drawer, desktop charm menu, big tiles): spinner where its chevron was, the other rows dim
  function rowBusy(a) {
    if (a.classList.contains('logo') || !(a.closest('#csMenu,.cs-mega') || a.matches('.cs-big a,.cs-mrows a,.cs-mshop a,.cs-gtiles a'))) return;
    rowClear();
    if (a.closest('.cs-big')) { var bx = a.closest('.cs-big'); bx.classList.add('cs-dim'); a.classList.add('cs-going'); going = { a: a, sp: document.createElement('span'), chev: null, box: bx }; return; }
    var sp = document.createElement('span'), kids = a.children, last = kids[kids.length - 1];
    var chev = kids.length > 1 && last.classList && last.classList.contains('ic') ? last : null;
    var pic = !chev && a.firstElementChild && a.firstElementChild.tagName === 'I' ? a.firstElementChild : null;
    sp.className = 'cs-rspin' + (pic ? ' ov' : ''); sp.setAttribute('aria-hidden', 'true');
    if (chev) { chev.classList.add('cs-chevoff'); a.insertBefore(sp, chev); } else (pic || a).appendChild(sp);
    var box = a.closest('#csMenu,.cs-mega,.cs-big'); if (box) box.classList.add('cs-dim');
    a.classList.add('cs-going');
    going = { a: a, sp: sp, chev: chev, box: box };
  }
  function initLeave() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var root = document.documentElement;
    // window + bubble: runs after every document handler, so links handled in place (preventDefault) are left alone
    window.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.hasAttribute('data-cs-open') || a.hasAttribute('data-cs-close') || a.hasAttribute('data-cs-nofade') || a.closest('[data-cs-inplace]')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(href)) return;
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname && u.search === location.search && u.hash) return;
      prog.start(); rowBusy(a);
      // an open drawer is in the old snapshot: a named header would paint over it during the transition
      if (VT && openEl) root.classList.add('cs-vtoff');
      if (VT || reduced) return; // the browser navigates now (view transition, or no fade at all)
      e.preventDefault();
      document.body.classList.add('cs-leaving');
      setTimeout(function () { location.href = u.href; }, 90);
    });
    window.addEventListener('submit', function (e) {
      var f = e.target; if (e.defaultPrevented || !f || (f.target && f.target !== '_self')) return;
      prog.start();
    });
    // the in-place collection switch reports its loading here
    document.addEventListener('cs:busy', function (e) {
      if (e.detail && e.detail.on) prog.start();
      else { prog.done(); requestAnimationFrame(function () { imgsIn(); }); }
    });
    window.addEventListener('pageshow', function (e) {
      document.body.classList.remove('cs-leaving'); root.classList.remove('cs-vtoff');
      prog.reset(); rowClear();
      if (e.persisted && openEl && openEl.id === 'csMenu') closePanel(true);
    });
    window.addEventListener('pagehide', function () { document.body.classList.remove('cs-leaving'); prog.done(); });
  }

  /* ---------- paged charm grid: swipe sideways page by page; the page number stays in the address ---------- */
  function initPages() {
    var root = $('[data-cs-pages]'); if (!root) return;
    var total = Number(root.getAttribute('data-total')) || 1, cur = Number(root.getAttribute('data-cur')) || 1;
    var per = Number(root.getAttribute('data-per')) || 12, items = Number(root.getAttribute('data-items')) || 0, sec = root.getAttribute('data-section');
    var track = $('[data-cs-ptrack]', root); if (!track || total < 2) return;
    var first = $('.cs-ppage', track), panels = [], loading = {};
    for (var i = 1; i <= total; i++) {
      var p = first;
      if (i !== cur) { p = document.createElement('div'); p.className = 'cs-ppage'; p.setAttribute('data-p', i); p.setAttribute('role', 'group'); p.setAttribute('aria-label', 'Page ' + i + ' of ' + total); p.innerHTML = '<div class="cs-pload" aria-hidden="true"></div>'; }
      panels.push(p);
    }
    var frag = document.createDocumentFragment(); panels.forEach(function (p) { frag.appendChild(p); }); track.appendChild(frag);
    root.classList.add('on');
    function urlFor(n, part) { var u = new URL(location.href); if (n > 1) u.searchParams.set('page', n); else u.searchParams.delete('page'); if (part) u.searchParams.set('section_id', sec); return u.toString(); }
    function load(n) {
      if (n < 1 || n > total) return; var p = panels[n - 1];
      if (p.hasAttribute('data-loaded') || loading[n]) return; loading[n] = 1;
      fetch(urlFor(n, true)).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), g = doc.querySelector('.cs-ppage[data-loaded] .cs-pgrid');
        if (!g) throw new Error('no grid');
        g.removeAttribute('id'); p.innerHTML = ''; p.appendChild(document.importNode(g, true)); p.setAttribute('data-loaded', '');
        paintHearts(); paintInBag(p); fitNames(p);
      }).catch(function () { delete loading[n]; p.innerHTML = '<div class="cs-pload err"><a class="cs-link" href="' + esc(urlFor(n)) + '">Open page ' + n + '</a></div>'; });
    }
    function paint(n) {
      $$('[data-cs-pnum]', root).forEach(function (b) { b.textContent = n; });
      $$('[data-cs-pform] input', root).forEach(function (x) { x.value = n; });
      $$('[data-cs-pgo]', root).forEach(function (a) { var t = n + Number(a.getAttribute('data-cs-pgo')), off = t < 1 || t > total; if (off) a.setAttribute('aria-disabled', 'true'); else a.removeAttribute('aria-disabled'); if (a.tagName === 'A' && !off) a.setAttribute('href', urlFor(t)); });
      var shown = $('[data-cs-shown]'); if (shown && items) shown.textContent = ((n - 1) * per + 1) + '–' + Math.min(items, n * per) + ' of ' + items;
    }
    function setCur(n) {
      if (n === cur) return; cur = n; paint(n);
      try { history.replaceState(history.state, '', urlFor(n)); } catch (e) {}
      load(n); load(n + 1); load(n - 1);
    }
    function toTop() {
      var r = root.getBoundingClientRect(), hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cs-head')) || 56;
      if (r.top < hh) window.scrollTo({ top: window.pageYOffset + r.top - hh - 8, behavior: 'smooth' });
    }
    function go(n, far) {
      n = Math.max(1, Math.min(total, n)); load(n);
      track.scrollTo({ left: (n - 1) * track.clientWidth, behavior: far ? 'auto' : 'smooth' });
      if (far) setCur(n);
      toTop();
    }
    track.style.scrollBehavior = 'auto'; track.scrollLeft = (cur - 1) * track.clientWidth; track.style.scrollBehavior = '';
    var st = null;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1; if (n !== cur) { setCur(n); toTop(); } }, 90);
    }, { passive: true });
    window.addEventListener('resize', function () { track.style.scrollBehavior = 'auto'; track.scrollLeft = (cur - 1) * track.clientWidth; track.style.scrollBehavior = ''; });
    // Phones: the browser only scrolls the page up/down here (touch-action: pan-y), so a slightly slanted scroll
    // can no longer flip the page. A page turn needs a clear sideways swipe while the page itself stays still.
    var tx = 0, ty = 0, tY = 0, tLock = '';
    track.addEventListener('touchstart', function (e) {
      tLock = ''; if (e.touches.length !== 1) { tLock = 'n'; return; }
      tx = e.touches[0].clientX; ty = e.touches[0].clientY; tY = window.pageYOffset; track.style.transition = '';
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (tLock === 'n' || tLock === 'y') return;
      var dx = e.touches[0].clientX - tx, dy = e.touches[0].clientY - ty;
      if (!tLock) { if (Math.abs(dx) < 12 && Math.abs(dy) < 12) return; tLock = Math.abs(dx) > 2 * Math.abs(dy) ? 'x' : 'y'; }
      if (Math.abs(window.pageYOffset - tY) > 6) { tLock = 'y'; track.style.transform = ''; return; }
      if (tLock === 'x') { var edge = (dx > 0 && cur <= 1) || (dx < 0 && cur >= total); track.style.transform = 'translateX(' + Math.round(dx * (edge ? 0.12 : 0.3)) + 'px)'; }
    }, { passive: true });
    function tEnd(e) {
      var was = tLock; tLock = '';
      if (track.style.transform) { track.style.transition = 'transform .22s ease'; track.style.transform = ''; }
      if (was !== 'x' || !e.changedTouches || !e.changedTouches[0]) return;
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) < 60 || Math.abs(dx) < 2 * Math.abs(dy) || Math.abs(window.pageYOffset - tY) > 6 || openEl) return;
      var n = cur + (dx < 0 ? 1 : -1); if (n >= 1 && n <= total) go(n);
    }
    track.addEventListener('touchend', tEnd, { passive: true });
    track.addEventListener('touchcancel', function () { tLock = ''; track.style.transform = ''; }, { passive: true });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cs-pgo]');
      if (b) { e.preventDefault(); if (b.getAttribute('aria-disabled') !== 'true') go(cur + Number(b.getAttribute('data-cs-pgo'))); return; }
      var j = e.target.closest('[data-cs-pjump]');
      if (j) { var f = j.parentNode.querySelector('[data-cs-pform]'); if (f) { f.hidden = !f.hidden; j.setAttribute('aria-expanded', f.hidden ? 'false' : 'true'); if (!f.hidden) { var x = f.querySelector('input'); x.focus(); x.select(); } } }
    });
    root.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-cs-pform]'); if (!f) return; e.preventDefault();
      var n = parseInt(f.querySelector('input').value, 10); if (n) go(n, Math.abs(n - cur) > 1); f.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (/input|select|textarea/i.test((e.target.tagName || '')) || openEl) return;
      if (e.key === 'ArrowRight') go(cur + 1); else if (e.key === 'ArrowLeft') go(cur - 1);
    });
    paint(cur); load(cur + 1); load(cur - 1);
  }

  /* ---------- Redeemly loyalty launcher: on phones its floating button sat on the cards; a Rewards row in the menu opens it instead ---------- */
  function initRewards() {
    var ID = 'mcb-launcher-widget-root', CLOSED = 'launcher__floating-button--closed', row = $('[data-cs-rewards]');
    var stop = Date.now() + 15000, mo = null, rt = null, watch = null;
    function btnOf(host) { var sr = host && host.shadowRoot; return sr ? (sr.querySelector('button.launcher__floating-button') || sr.querySelector('button[aria-label="Open launcher"]')) : null; }
    function style(sr) {
      if (sr.querySelector('style[data-cs-rw]')) return;
      var st = document.createElement('style'); st.setAttribute('data-cs-rw', '');
      st.textContent = '@media (max-width:749px){.launcher__floating-button.' + CLOSED + '{visibility:hidden!important;opacity:0!important;pointer-events:none!important}}';
      sr.appendChild(st);
    }
    function found(host) {
      var sr = host.shadowRoot; style(sr);
      // the app may redraw its shadow root: put the style back if it goes
      if ('MutationObserver' in window) new MutationObserver(function () { style(sr); }).observe(sr, { childList: true });
      if (row) row.hidden = false;
    }
    function check() {
      clearTimeout(rt); rt = null;
      var host = document.getElementById(ID);
      if (host && host.shadowRoot) { if (mo) mo.disconnect(); mo = null; found(host); return true; }
      if (Date.now() > stop) { if (mo) mo.disconnect(); mo = null; return true; }
      if (host) rt = setTimeout(check, 300); // the host is there, its shadow root not yet
      return false;
    }
    if (!check() && 'MutationObserver' in window) {
      mo = new MutationObserver(function () { if (!rt) rt = setTimeout(check, 100); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(check, 15100);
    }
    if (!row) return;
    row.addEventListener('click', function (e) {
      e.preventDefault();
      var host = document.getElementById(ID), b = btnOf(host);
      if (!b) { toast('Rewards are still loading. Please try again in a moment.'); return; }
      closePanel();
      if (watch) watch();
      document.body.classList.add('cs-rw-open');
      var seen = false, ob = null, tm = null;
      function end() { if (ob) ob.disconnect(); clearTimeout(tm); document.body.classList.remove('cs-rw-open'); watch = null; }
      function chk() { var cb = btnOf(host); if (!cb) return; if (!cb.classList.contains(CLOSED)) seen = true; else if (seen) end(); }
      watch = end;
      if ('MutationObserver' in window) { ob = new MutationObserver(chk); ob.observe(host.shadowRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] }); }
      tm = setTimeout(function () { if (!seen) end(); }, 2000); // the panel never opened
      b.click();
      chk();
    });
  }

  /* ---------- gift card: preset amounts or any whole amount from $10 to $200 ---------- */
  /* Shipping-to switch (footer): Shopify sends a page the new country's shop can't show to the home page, and each
     currency has its own gift card. On a gift card page, go to that country's card, same amount. */
  CS.locGo = function (sel) {
    var f = sel.form, rt = f.querySelector('[name="return_to"]'), o = sel.options[sel.selectedIndex];
    var m = location.pathname.match(/^(.*\/products\/)gift-card(-[a-z]{3})?\/?$/);
    if (rt && m && o) {
      var map = {}; (f.getAttribute('data-cs-gcmap') || '').split(',').forEach(function (x) { var p = x.split(':'); if (p[1]) map[p[0]] = p[1]; });
      var on = $('[data-cs-gc-a][aria-checked="true"]'), amt = on ? on.getAttribute('data-cs-gc-a') : '';
      rt.value = m[1] + (map[o.getAttribute('data-cur')] || 'gift-card') + (amt ? '?amount=' + encodeURIComponent(amt) : '');
    }
    f.submit();
  };
  function initGc() {
    var box = $('[data-cs-gc]'); if (!box) return;
    var root = box.closest('[data-cs-pdp]'), vs = []; try { vs = JSON.parse($('[data-cs-variants]', root).textContent); } catch (e) {}
    // amounts come from the variant names ("$25"), so a shopper paying in another currency still gets the right card
    var byAmt = {}; vs.forEach(function (v) { var m = String(v.title || '').match(/(\d+)/); byAmt[m ? Number(m[1]) : Math.round(v.price / 100)] = v; });
    var input = $('[data-cs-gc-input]', box), msg = $('[data-cs-gc-msg]', box);
    function pick(a, fromInput) {
      var v = byAmt[a];
      $$('[data-cs-gc-a]', box).forEach(function (b) { b.setAttribute('aria-checked', String(Number(b.getAttribute('data-cs-gc-a')) === a && !fromInput)); });
      if (!v) { if (msg) { var ks = Object.keys(byAmt).map(Number); msg.textContent = (fromInput && ks.length) ? 'Pick a whole amount from $' + Math.min.apply(null, ks) + ' to $' + Math.max.apply(null, ks) + '.' : ''; } $$('[data-cs-buy],[data-cs-buy2]', root).forEach(function (b) { b.disabled = true; }); return; }
      if (msg) msg.textContent = '';
      $('[data-cs-gc-amt]', box).textContent = money(v.price).replace(/\.00$/, '');
      var p = $('[data-cs-price]', root); if (p) p.textContent = money(v.price);
      $$('[data-cs-buy],[data-cs-buy2]', root).forEach(function (b) { b.disabled = !v.available; b.setAttribute('data-cs-add', v.id); b.setAttribute('data-title', 'Gift card ' + money(v.price).replace(/\.00$/, '')); });
      var b1 = $('[data-cs-buy]', root); if (b1) b1.textContent = 'Add to bag · ' + money(v.price);
      var bp = $('[data-cs-bprice]', root); if (bp) bp.textContent = money(v.price);
      var info = $('.cs-pdp-info', root); if (info) { info.setAttribute('data-v', v.id); info.setAttribute('data-price', v.price); }
    }
    box.addEventListener('click', function (e) { var b = e.target.closest('[data-cs-gc-a]'); if (!b) return; if (input) input.value = ''; pick(Number(b.getAttribute('data-cs-gc-a'))); });
    if (input) input.addEventListener('input', function () { var n = Number(input.value); if (!input.value) return; pick(Math.round(n) === n ? n : -1, true); });
    // came here from another country's gift card page (CS.locGo): the same amount
    var qa = Number((location.search.match(/[?&]amount=(\d+)/) || [])[1]); if (qa && byAmt[qa]) pick(qa);
    // send it to a friend: Shopify's own recipient fields, sent as line item properties
    var rb = $('[data-cs-gcr]', root); if (!rb) return;
    var on = $('[data-cs-gcr-on]', rb), wrap = $('[data-cs-gcr-f]', rb), srv = $('[data-cs-gcr-srv]', rb), cnt = $('[data-cs-gcr-count]', rb);
    var f = { email: $('[data-cs-gcr-email]', rb), name: $('[data-cs-gcr-name]', rb), msg: $('[data-cs-gcr-msg]', rb), date: $('[data-cs-gcr-date]', rb) };
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function range() { var t = new Date(); return [ymd(t), ymd(new Date(t.getFullYear(), t.getMonth(), t.getDate() + 90))]; }
    function nice(s) { var p = s.split('-'); try { return new Date(+p[0], p[1] - 1, +p[2]).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return s; } }
    function err(el, m) { var x = document.getElementById(el.id + 'Err'); if (x) x.textContent = m || ''; if (m) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid'); }
    function count() { cnt.textContent = f.msg.value.length + '/200'; }
    function toggle() {
      var o = on.checked; rb.classList.toggle('on', o);
      if (o) { wrap.removeAttribute('inert'); var r = range(); f.date.min = r[0]; f.date.max = r[1]; }
      else { wrap.setAttribute('inert', ''); Object.keys(f).forEach(function (k) { err(f[k], ''); }); }
      srv.textContent = '';
    }
    on.addEventListener('change', toggle);
    f.msg.addEventListener('input', count);
    Object.keys(f).forEach(function (k) { f[k].addEventListener('input', function () { if (f[k].hasAttribute('aria-invalid')) err(f[k], ''); srv.textContent = ''; }); });
    toggle(); count();
    gcHook = function () {
      srv.textContent = '';
      var fail = function (e) { if (e && e.status === 422 && e.message) srv.textContent = e.message; };
      if (!on.checked) return { props: null, fail: fail };
      var r = range(), bad = [], em = f.email.value.trim(), nm = f.name.value.trim(), ms = f.msg.value.trim(), dt = f.date.value;
      Object.keys(f).forEach(function (k) { err(f[k], ''); });
      if (!em) bad.push([f.email, 'Enter your friend\'s email.']);
      else if (!EMAIL.test(em)) bad.push([f.email, 'That email doesn\'t look right. Check it for typos.']);
      if (nm.length > 255) bad.push([f.name, 'Keep the name to 255 characters.']);
      if (ms.length > 200) bad.push([f.msg, 'Keep the message to 200 characters (' + ms.length + ' now).']);
      if ((!dt && f.date.validity && f.date.validity.badInput) || (dt && (!/^\d{4}-\d{2}-\d{2}$/.test(dt) || dt < r[0] || dt > r[1]))) bad.push([f.date, 'Pick a date from today to ' + nice(r[1]) + ', or leave it empty.']);
      if (bad.length) {
        bad.forEach(function (b) { err(b[0], b[1]); });
        try { bad[0][0].scrollIntoView({ block: 'center' }); bad[0][0].focus({ preventScroll: true }); } catch (e) { bad[0][0].focus(); }
        return false;
      }
      var p = { __shopify_send_gift_card_to_recipient: 'on', 'Recipient email': em };
      if (nm) p['Recipient name'] = nm;
      if (ms) p['Message'] = ms;
      if (dt) p['Send on'] = dt;
      p.__shopify_offset = String(new Date().getTimezoneOffset());
      return { props: p, fail: fail };
    };
  }
  /* store copy says "free shipping from $40" in dollars; shoppers paying another currency see their own amount */
  function localShipCopy(root) {
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active, shopCur = (CS.shopCurrency || 'USD');
    if (!cur || cur === shopCur || RATE === 1 || !document.createTreeWalker) return;
    var amt = money(Math.ceil(4000 * RATE / 100) * 100).replace(/[.,]00(?=\D*$)/, '');
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) { if (/\$40(?![\d.,])/.test(n.nodeValue) && /ship/i.test((n.parentNode && n.parentNode.textContent) || '') && !(n.parentNode && /^(SCRIPT|STYLE|TEXTAREA)$/.test(n.parentNode.nodeName))) hits.push(n); }
    hits.forEach(function (t) { t.nodeValue = t.nodeValue.replace(/\$40(?![\d.,])/g, amt); });
  }
  function init() {
    localShipCopy();
    document.addEventListener('cs:swap', function (e) { localShipCopy(e.detail && e.detail.root); });
    paintHearts(); imgsIn(); initPages(); initGc(); initRails(); initMega(); initSticky(); initPdp(); initRecs(); initSaved(); fillImages(); initColSwitch(); initSearchSwap(); initInstant('csHq', 8, false); initInstant('csMq', 12, true); initSearchPage(); initLeave();
    initRewards();
    paintCotm();
    document.addEventListener('cs:swap', function () { paintCotm(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) paintCotm(); });
    loadCart().catch(function () {});
    document.addEventListener('cs:hearts', function () { if (openEl && openEl.id === 'csHeartsD') drawHeartsDrawer(); });
    document.addEventListener('cs:cart', function () { if (openEl && openEl.id === 'csHeartsD') drawHeartsDrawer(); });
    window.addEventListener('storage', function (e) { if (e.key === HKEY) paintHearts(); if (e.key === 'csb_snap') renderBag(); });
    window.addEventListener('online', function () { renderBag(); });
    window.addEventListener('offline', function () { renderBag(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
